<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{
    "num_cand": "U2FsdGVkX1+Fn4DApInlXvXOT2+tcRGdxekWoRrtqqY=",
    "cpf": "U2FsdGVkX190UJcZ/phQqRD9Ff+TPnjEOLr8JqRAmJU="
}, {
    "num_cand": "U2FsdGVkX1+l4OT3C4fZzaiwS/OqUdEAh/Wg8U/NjLY=",
    "cpf": "U2FsdGVkX1+r+ZglKq+LfX5Fc+l3BZs1m5qHZB+x4x4="
}, {
    "num_cand": "U2FsdGVkX19bG+Puinr2WBmxAHQxBCLLqIawY5TZ/5w=",
    "cpf": "U2FsdGVkX1+71emRnMFRlHkY0E1FGTHVCvMR4fttItU="
}, {
    "num_cand": "U2FsdGVkX19z+dbRVix8bjeo21f5xJF+BAMtDp7GtYY=",
    "cpf": "U2FsdGVkX19mceL/5rNPoFlheyVfb692i6r6U/zm2bg="
}, {
    "num_cand": "U2FsdGVkX1/EJXslH+BiRmkgSnt3lu6M8FjcnFjABdA=",
    "cpf": "U2FsdGVkX1976auiB8mjgJyl1rJTNaLHDPzB0m5jjGE="
}, {
    "num_cand": "U2FsdGVkX1/If6BkLO2MD+fGbWBpHWV8/eASPdjF/to=",
    "cpf": "U2FsdGVkX1/8NorQ7mo3eyue7vXaFCN3t4k0uSTdpbs="
}, {
    "num_cand": "U2FsdGVkX1+1soymG3f0WPsTMS0GGvVYu6mClc/I6As=",
    "cpf": "U2FsdGVkX19PvdZU1awt4NQy1F8ni1K4/4gaZqTn8rE="
}, {
    "num_cand": "U2FsdGVkX1/OygHInBWPniHD+0/V+EEgepSfxwraEpo=",
    "cpf": "U2FsdGVkX1//XlzB5E70CRvM2YCw49RoJpPv5dB9tNs="
}, {
    "num_cand": "U2FsdGVkX1/K0p6h3H/WiL2dL2IZhds4kNSfwaUHVas=",
    "cpf": "U2FsdGVkX19ZLOR8riD88jFFTYDpt7+PTO6X48yhW8I="
}, {
    "num_cand": "U2FsdGVkX19Ds2N8dPwSxsXcbQHkPONo5XYkLijh/ps=",
    "cpf": "U2FsdGVkX1986olIhGb7VnEgyP3RlJeEitof1ThTd08="
}, {
    "num_cand": "U2FsdGVkX18XFOiXlNs1C1JKX7YOExDhhzuOYhE/y88=",
    "cpf": "U2FsdGVkX18xpJtUkG5FNGtkkQafqdo4tEP8zSetm7Y="
}, {
    "num_cand": "U2FsdGVkX18dIgzQ8pshtUESEaCjxzZ03mvWzQ8Ehxw=",
    "cpf": "U2FsdGVkX1+nSOqsHKjpmbszqmQqYesah3xDHgmQ718="
}, {
    "num_cand": "U2FsdGVkX1/Nh7qcDS/fC9oN0xwB7btXDyX5SMkWXro=",
    "cpf": "U2FsdGVkX18O+7ROKn03x30AKVjKDh3lxSmHB+3iMh4="
}, {
    "num_cand": "U2FsdGVkX1+J2Auy3XpQKd1gkIi5MT4WIpd0hb5LJrc=",
    "cpf": "U2FsdGVkX18UG29rcB4eTI0P7hL8ZuHUp+n3fnmqzgo="
}, {
    "num_cand": "U2FsdGVkX1+OY4z5Nc47GgXbwwTkCpN84yaLeKCfuP4=",
    "cpf": "U2FsdGVkX1/8U3LO55aagYHOTcYQA0h5j9scGeS/xz8="
}, {
    "num_cand": "U2FsdGVkX18lGGlMN7mEsmHtmBzcyqSUN0YPDN8Nass=",
    "cpf": "U2FsdGVkX189o0oDrU8McUfK6AsqHk5GmE3WvzMhaZc="
}, {
    "num_cand": "U2FsdGVkX1+F2jQi3aDaznv3Lbjh8pP0lBRkhFOnn5c=",
    "cpf": "U2FsdGVkX18Fq3M4SoaaOZeXfuQDMtfdpw6+ZE5bKz0="
}, {
    "num_cand": "U2FsdGVkX18jWOCxZvM7VaW+dxvAFnYuxbb1ysdo524=",
    "cpf": "U2FsdGVkX1+knKr4SLQ789dw+wrcAfvfBeHPofL8tU0="
}, {
    "num_cand": "U2FsdGVkX195f20OxNsTDYxWmw1W5El2e1V9mOoU600=",
    "cpf": "U2FsdGVkX18Oild2G7/EeQXaHUkz8cgoyM7zAL+IAjE="
}, {
    "num_cand": "U2FsdGVkX1/pM4yYiZWikVwaNBFulXq1nSrWMuLBJGI=",
    "cpf": "U2FsdGVkX1/fd6NmJFSFOVr13ylhRUp9ku2yX9ptWSY="
}, {
    "num_cand": "U2FsdGVkX18FIkYLfqZxFIXFksbcQ3IuZvz1g792Fdw=",
    "cpf": "U2FsdGVkX19W11IE/q4XNdUm8+AzG8zyt1foKIqYBSI="
}, {
    "num_cand": "U2FsdGVkX1/SviL2Tb7lN9TcCTM8Orz4s6msFzWuMr0=",
    "cpf": "U2FsdGVkX19xhcIQDiCcqQ8vgLi5wAKDc8lvIsSa27U="
}, {
    "num_cand": "U2FsdGVkX19IKn1eL85K7At+UjHAIri+YQVA1v9IOgg=",
    "cpf": "U2FsdGVkX1+LgyMA2GQC3jXGUNt1ov76j3InP31zA+k="
}, {
    "num_cand": "U2FsdGVkX1+oIXWIdSBrya2bz/qJ15gO5a+bktdszwE=",
    "cpf": "U2FsdGVkX18RKzsX6aJUg4HrGccx+P0cMEFgz0ork0k="
}, {
    "num_cand": "U2FsdGVkX1/167UEYUUskAvA5t14LoyLKtpL706I2Mw=",
    "cpf": "U2FsdGVkX19L4UZ0Fp1VMZSj9eAx4er17la4tmPwXNo="
}, {
    "num_cand": "U2FsdGVkX1/BZd+6Kqkv/dt5njxy9HEI/+6UFU5Vudk=",
    "cpf": "U2FsdGVkX196MGarZnRNGNObIn01zHxeVqjoiQu7LLE="
}, {
    "num_cand": "U2FsdGVkX18VAKgjGpN9dCd9xaTWUKF/lJ2+HzCCGnY=",
    "cpf": "U2FsdGVkX19u2/Wb86NSS1gVbtJAV/mjuTT5CES6GNs="
}, {
    "num_cand": "U2FsdGVkX1+xTbRiaKWzhH2XP9Ef85XqD6eUuXntk2I=",
    "cpf": "U2FsdGVkX18BWPGeN2LtjYyDjc7cAPnn9mruxQoLcmA="
}, {
    "num_cand": "U2FsdGVkX1/rd1dYHIw/07WIbq6siN6oGdsWIz3cqdY=",
    "cpf": "U2FsdGVkX1+XsAWRX3pHVLnP/Los2A58vfSoygwvZmQ="
}, {
    "num_cand": "U2FsdGVkX19GWdQG2k645a/OY+I7C0PbEMoVLgYDWtQ=",
    "cpf": "U2FsdGVkX1+i36g4eKln4CKW6pKBgwWDnME1PFQpjj8="
}, {
    "num_cand": "U2FsdGVkX1+au9+Sq+CdhZfQ9KC4HE9/zA92S/JRvZI=",
    "cpf": "U2FsdGVkX19aSvcqwkdfgfXrmEKN4bmhwQN/a/z8QZo="
}, {
    "num_cand": "U2FsdGVkX1+H1j28j16Vp+T3gzEC4g7G/05kSe3MNNc=",
    "cpf": "U2FsdGVkX1+uQX18ygHSTzaE3Ya4tjsXmPIDBw/MwO8="
}, {
    "num_cand": "U2FsdGVkX1+B1LiOn8NNMUsni0Ge94JLbVo1jped000=",
    "cpf": "U2FsdGVkX19cYMVB7MxVEWRyok6T/jGWR0voGYM5Cj4="
}, {
    "num_cand": "U2FsdGVkX18yzbbUEc0qVIXFb+xdJ50NBoCDWuDATZ4=",
    "cpf": "U2FsdGVkX19GZpf/rTLm2nBCsjIIs8BhCmED7M6VP0Q="
}, {
    "num_cand": "U2FsdGVkX1/t/OTn1PUJaqmrTvcCCvxm5/fbfGmrNUw=",
    "cpf": "U2FsdGVkX18W+uyraOcRihuoUfoxox+aysFHr3YAw9Q="
}, {
    "num_cand": "U2FsdGVkX18CjQoJBLs+PRobAphdNdiTVBMYTtNBMQA=",
    "cpf": "U2FsdGVkX1+zFfDGBExO8AfVZSSazC092R5DVMq9TMY="
}, {
    "num_cand": "U2FsdGVkX1+W4Y4igBSNUJo28HF1/sGCXz+0JwpDQVI=",
    "cpf": "U2FsdGVkX19yYeOLfgPU/Rs7Gp7ThhQ5WWRSFd1VwVQ="
}, {
    "num_cand": "U2FsdGVkX18giF7bSKD+vA7eL4JVq0QSdHE4SKaxSaE=",
    "cpf": "U2FsdGVkX18zYF3hvkN2DNlce889Qx5bVU3Olpl/b9c="
}, {
    "num_cand": "U2FsdGVkX19IeG/nEiT+DJCl7JgpZTg/NOsHn7A5/cw=",
    "cpf": "U2FsdGVkX19YjPwyJFSRaK999mzlWE9/WU8nOXpwekY="
}, {
    "num_cand": "U2FsdGVkX1+oiOlC5MWmWUk0LfP9ZlbwcGxt5Yv6OoY=",
    "cpf": "U2FsdGVkX19Qsx5mnIvFNblM1OPpeX28DeL1sSf8DTY="
}, {
    "num_cand": "U2FsdGVkX18i8LYAvAlSt6BbGHs8N0jxHfF1rrzTHVQ=",
    "cpf": "U2FsdGVkX1/pPNR4EiN8ZNt6bvw6Lzy/IsQXWxsYL50="
}, {
    "num_cand": "U2FsdGVkX196lR4kzDs/NqtMV9TcvfcdGU++2WdZFok=",
    "cpf": "U2FsdGVkX19Pi/GBnWp2IlM/i+fnVlmHCt1G3F5VM4w="
}, {
    "num_cand": "U2FsdGVkX1/x845dt3d9r8OwgVU/Dr5QoWnMdO5biEQ=",
    "cpf": "U2FsdGVkX18N8pPVkH21yDQm20dqB/qN3oqcSLypHSk="
}, {
    "num_cand": "U2FsdGVkX18vusFKHkbJnhp1iqqqKTflW28aCL2164A=",
    "cpf": "U2FsdGVkX1/uJ0//QiRev3r4IyDJUBuglC0JJCWwshM="
}, {
    "num_cand": "U2FsdGVkX19Xm70aJ/q1r+894SrViCV5As7xswD4vmE=",
    "cpf": "U2FsdGVkX1+X62lih7g3V2Y1Z9C9A4bAu6WlkHsH6PY="
}, {
    "num_cand": "U2FsdGVkX18tk1SdGJD+nLzKxSP6AE8rZEtu858iZLI=",
    "cpf": "U2FsdGVkX18llTbGO+Pjuz08Gm4ETHuFfQqjp0DBwZQ="
}, {
    "num_cand": "U2FsdGVkX19LRAxnv0cvxLvWksOxeye9nlifnwBqBbc=",
    "cpf": "U2FsdGVkX187in4j/QRrXINbP3AUVt4b9u2wURgv9Qc="
}, {
    "num_cand": "U2FsdGVkX1/Z2czY0t03nHW3b3B9rBOnSBD0nnqr6P0=",
    "cpf": "U2FsdGVkX1/7iGZTrDNqGCO/EfmTBfCbKAvwwfW8mLw="
}, {
    "num_cand": "U2FsdGVkX1+ZHYjj2uUbiHOKNDp6fDf9fCYeylT7TRM=",
    "cpf": "U2FsdGVkX1/vGW3BKM1VZ3tJnGEWAZDVgurNNxVFmyU="
}, {
    "num_cand": "U2FsdGVkX1/nnG2Qh379sfcnWy7CjgetXDRL46+F7ks=",
    "cpf": "U2FsdGVkX1/TyH2sn0Ciym4ONAa6+38AqlaWzwzGSjo="
}, {
    "num_cand": "U2FsdGVkX1/EA3w09ChBy8WKPsoWS7fuuh4BryZQYjA=",
    "cpf": "U2FsdGVkX1+4PcpoqFZ7rS1C2cmu0RPp5Xs0dHWTq1Y="
}, {
    "num_cand": "U2FsdGVkX1+CoVhiSbh26+xYTpWSSMjDrs8RzXGKkDU=",
    "cpf": "U2FsdGVkX1/SDwQwroRmh4Zn2XyLqO3CpTn/zuN/cDM="
}, {
    "num_cand": "U2FsdGVkX1+X89Sj3fURTWs2nGt5JlDItEFD6lhpo6I=",
    "cpf": "U2FsdGVkX18YxuhTSU7EUyYVFO4rbTjxWSDjyE41F3Y="
}, {
    "num_cand": "U2FsdGVkX18K+yZzSjX900HEax0sxUd1QmLqiTJ635I=",
    "cpf": "U2FsdGVkX1/qzrfGt/v8NAM5IJRcmoGbzpR8ezbpdfs="
}, {
    "num_cand": "U2FsdGVkX1+v1LftOrHQWPo4TunTFrz9Gq+NkY1sUy4=",
    "cpf": "U2FsdGVkX18wzj+eSuxlLmultNEtgZneurY/IRKAvIA="
}, {
    "num_cand": "U2FsdGVkX1/VRba5baHvvkP/04kJmjW5Kgaw6YkyhbI=",
    "cpf": "U2FsdGVkX18IM7oR7Z3yvrbJvcVjddfWG+4PTuJs3dw="
}, {
    "num_cand": "U2FsdGVkX1+/Pw6nbHnVTG5xUX3bH2IoN8CXG2kYBkA=",
    "cpf": "U2FsdGVkX186RXkmN+Na/VukOLY2jFEmi0K3D/N+c3c="
}, {
    "num_cand": "U2FsdGVkX19KJX4Tjk/TgE20Aa3wCyDU2lbynJEAPAk=",
    "cpf": "U2FsdGVkX1/KE4ufOjY9GLxwm1ge2CyPgY7+eBS41+w="
}, {
    "num_cand": "U2FsdGVkX1/kL+zSaFj0m3Ck7prEDeuJfiGkVWnTTPA=",
    "cpf": "U2FsdGVkX18DxpJp9GC2npwYmEY+o/OrQT361yb5FFo="
}, {
    "num_cand": "U2FsdGVkX18EOSontxTi/s8mUhHLXsSm1gcR4aoG3Qg=",
    "cpf": "U2FsdGVkX1+NR12hzhUYXJr+EnsTWDcomI5ONtww1qQ="
}, {
    "num_cand": "U2FsdGVkX19SEcUtJyk3efdQu2ZdOaT3cFFwyF5Aqsk=",
    "cpf": "U2FsdGVkX19Knm9y349/UXBLpln/aWTgDx1QhJsiDWU="
}, {
    "num_cand": "U2FsdGVkX1+e7HH//XTFQk9qxHJdCnkj6RR+poBNcRI=",
    "cpf": "U2FsdGVkX1/VYWR77ifdfCdNb/itkCUwhNNthrypeWQ="
}, {
    "num_cand": "U2FsdGVkX18g1xTWD0KnCuA4GGxqv7ceLx4eASrkzqo=",
    "cpf": "U2FsdGVkX19pirqaPyWeX1/vlFKaOm+odL2RnSQ/5KI="
}, {
    "num_cand": "U2FsdGVkX1/9shgV4+7ZYdgPVR4ig9VIUcE20/d43oE=",
    "cpf": "U2FsdGVkX1//WaMgJ1mNVXFnZuqi+120Qnyiqi0y6dc="
}, {
    "num_cand": "U2FsdGVkX184sdWfoHklPS4rYjIn3DKcmYpGCADT8bM=",
    "cpf": "U2FsdGVkX19QFbkPYRHIaZrHg4rpZUG0FqmTqdcqja8="
}, {
    "num_cand": "U2FsdGVkX18f12cUOWk6hTyyIJtnehK9Tgvy8OIjXeM=",
    "cpf": "U2FsdGVkX195Lf38RQxrFN2EZZx8SdLn0lPPszFlai0="
}, {
    "num_cand": "U2FsdGVkX1856gm2v/8/ammVTTd1gYJWqrtWkawwkTE=",
    "cpf": "U2FsdGVkX1/UN4gtj+LFlpn7VSbvtlA54NcYkWXO998="
}, {
    "num_cand": "U2FsdGVkX1/u+5w5L4+I136QrkOs/yQrzgSy0QyBFUs=",
    "cpf": "U2FsdGVkX1/mU0allWxQx86nB1UcZNxWcTkLufNE2xs="
}, {
    "num_cand": "U2FsdGVkX186AQrmXFCiz/oY5CL1aZRgD8aeivHVYkM=",
    "cpf": "U2FsdGVkX197p7xuZPwWNJZfOBRcTn6KhbJjNbJq7J0="
}, {
    "num_cand": "U2FsdGVkX1+1ufAexFABd1MKuqpGTdQGC3JFBll2zFM=",
    "cpf": "U2FsdGVkX18U3ItxnJlTRr5IDgyA4JuznX89woH5l9s="
}, {
    "num_cand": "U2FsdGVkX1+r22tNxnQbLWj7d0PE/YBe9NTFOn7CKcc=",
    "cpf": "U2FsdGVkX19Mbv3eBYPLcGKEzCZITm5I/8R5kTHQ5v0="
}, {
    "num_cand": "U2FsdGVkX18z3f6rcCgsJ0r7QKHFIS4+z82u2TnQjCw=",
    "cpf": "U2FsdGVkX19Fb0PvvWwJOw2K2cqMZrkqtdtvPc1TIKM="
}, {
    "num_cand": "U2FsdGVkX1/0YVplEB1UDQtv68NokCr1c4rS7e6q6wg=",
    "cpf": "U2FsdGVkX19eb6rWhKGoOa+MA3AqJhfTd0tKSHJxYsQ="
}, {
    "num_cand": "U2FsdGVkX1+Lcf43qnHIW6GA9DyGp1eLPAp1V13bi/0=",
    "cpf": "U2FsdGVkX193f87prP0N+PcLnOJnzVdRj61tEmzu7Ww="
}, {
    "num_cand": "U2FsdGVkX18L8JgbzoXfkIDd4kWf2q9AmKPiBgB6ejc=",
    "cpf": "U2FsdGVkX19DE5PyOxzSHK7sb9k+56MW3YO51dfKnK8="
}, {
    "num_cand": "U2FsdGVkX1+BC4iqCKI8gm26FGHpHwW32qFgo/4ocQU=",
    "cpf": "U2FsdGVkX182wJG5DGLm3BDbTal1W+2gPVrvxIvl/c0="
}, {
    "num_cand": "U2FsdGVkX18qZ67JSAFn1Fex/4avX9keAadNBrUvb3E=",
    "cpf": "U2FsdGVkX1+8cbY3V3eGBFVBMWYtgLwwJyaGDEdf4nI="
}, {
    "num_cand": "U2FsdGVkX185M1a+m8Adfy97iL5ARWaVqVPL/eZK/Ac=",
    "cpf": "U2FsdGVkX1+EAztZHNy2l0RjJBSXymZb6vsCKYoOwzU="
}, {
    "num_cand": "U2FsdGVkX18e+Ui6pKcTweqtKYNNCvXeGdtlT1kGr6U=",
    "cpf": "U2FsdGVkX1+bABlGqKbCBpSpI8fEkHLYN1n7g8nMcoQ="
}, {
    "num_cand": "U2FsdGVkX1+pV2QXNes33zoMrC0zD2g4kmQWTAFRwzA=",
    "cpf": "U2FsdGVkX1+ji52YdpY6yVYUS/gwY9Bua2S6uZABBrc="
}, {
    "num_cand": "U2FsdGVkX1+ODRP2dUjn0o+Ns0EC66rC/OqR4RaCjrY=",
    "cpf": "U2FsdGVkX199P+zodBqm31OlKcQi6Ay/xKNV/d3oOVA="
}, {
    "num_cand": "U2FsdGVkX1+vSgMxkhX2CGv5dtpkB7HmBWuP699UQik=",
    "cpf": "U2FsdGVkX19OPVgK6fb+x68NZ2YolNnRJqoCbi4Prhk="
}, {
    "num_cand": "U2FsdGVkX18pQbxt37MOZ6EQpECP19AiAHsmPlsryrE=",
    "cpf": "U2FsdGVkX1+3cR2WJoZIONWEEz1+WnCLmpLji0xrfOk="
}, {
    "num_cand": "U2FsdGVkX19W7Opx5vIadsfH7z1TJF29YcZlqmj5WXA=",
    "cpf": "U2FsdGVkX1+5kId+q+3BuvIvztQRK5zoYGWMyk7h3PE="
}, {
    "num_cand": "U2FsdGVkX1/IIH6HcKGLPrexUJGQWbT/789e0Z38jEY=",
    "cpf": "U2FsdGVkX1/z85hopSMwiV5P73YmVRfuZeI4ZNPKIzg="
}, {
    "num_cand": "U2FsdGVkX19vsxVLlVPMBMK1Dg3B0mAv+lAjb69yJ7A=",
    "cpf": "U2FsdGVkX18cwLuvcGn3+xM+c+F5yW6s+FUquLOpYr8="
}, {
    "num_cand": "U2FsdGVkX1/dPnQ3GHwCtNYL/+Cfszk4UD8GkThLozM=",
    "cpf": "U2FsdGVkX183F4+bCIKsFuLPDny9JvqxSEcqTwoFNT4="
}, {
    "num_cand": "U2FsdGVkX18pRDcsB49zk1gRhmIiVN3Jhfo4Jyspo2s=",
    "cpf": "U2FsdGVkX1+1MpaeOfAUdAHYkEkBsrG9+BpWXA/VE+g="
}, {
    "num_cand": "U2FsdGVkX1+Dnii6G08hU8CS/q2+gvbK+zsnQQcMtqM=",
    "cpf": "U2FsdGVkX1+JJsSo1YY0RP3eIStFJ/3TvxdEOVNeBqg="
}, {
    "num_cand": "U2FsdGVkX1+PX9Hm7jxKNieh8ftN1KwWH7Yx9M6Kx1k=",
    "cpf": "U2FsdGVkX1/u0f1D9CYPfqly6r0lT433/lWwh5NF1mw="
}, {
    "num_cand": "U2FsdGVkX1/OHJneP9qJ01nHEqSBunUQqvcZl/WAvdI=",
    "cpf": "U2FsdGVkX1/HpCJZfbTQckVjtdvNtvdMIkuiA8DbFvQ="
}, {
    "num_cand": "U2FsdGVkX19bFAi1+27rU+rQPreP70y6hkb5HnQ2quY=",
    "cpf": "U2FsdGVkX1/SVjZRmLYsgGSe6/Xn1jtkMG+fzZNjR10="
}, {
    "num_cand": "U2FsdGVkX18DTV6yPaRsoc6rkZf6YxPzkWXX1Yr9YAI=",
    "cpf": "U2FsdGVkX19YJE+VQKEVC95+bxU5u1rYp3MnMo52BGQ="
}, {
    "num_cand": "U2FsdGVkX19y65RK+Pi5TGInbSjS1GpAGGbK/bC1zDw=",
    "cpf": "U2FsdGVkX18pkEl4ZFjM0uhob9XbcqxwBG8d77HkiaA="
}, {
    "num_cand": "U2FsdGVkX1/LmhHU+cDADdkNROr/2B95bYSlc2UwT9g=",
    "cpf": "U2FsdGVkX19tE/9OQkJWJSUN1DmQEITAkDXTjwb11ww="
}, {
    "num_cand": "U2FsdGVkX19Kf3O4Q9nqq48pTI91uE/l1vUWtYkIJYI=",
    "cpf": "U2FsdGVkX1+B9++C1OvIM4Lqo7e/dn3C7zLE8V8as+4="
}, {
    "num_cand": "U2FsdGVkX187Ty6v8i0G0XxmV7UG4LPm7nxaMcMzKpY=",
    "cpf": "U2FsdGVkX1/k1239JWOKFKqTtGfd23kIL82KD8dNWz8="
}, {
    "num_cand": "U2FsdGVkX1/exrCpIb+Mfmx8uExr9I++ORYOhU51H+w=",
    "cpf": "U2FsdGVkX19o+RwM8V5QKHFc4FtgVx6KVm5TUZbUWvc="
}, {
    "num_cand": "U2FsdGVkX19KCeAS+FRHvPy7ZTUF51zhTJ8iK1/YNwQ=",
    "cpf": "U2FsdGVkX1+TIQoRugVQJvHQ/VVXcXGNcLOO5VJrqE8="
}, {
    "num_cand": "U2FsdGVkX18BoCyxuqtj2MbWBxg0KUtgwTsn3/Xjwk8=",
    "cpf": "U2FsdGVkX184NZckSSWcPPD1feuFlkYVUz8LwcJuurw="
}, {
    "num_cand": "U2FsdGVkX18A0gqSmQwwqpVexj+UQPcA4/0V2l3U5Bw=",
    "cpf": "U2FsdGVkX19eG5TZO6PqMHaNi9pEpTaRWwgzgP93qAM="
}, {
    "num_cand": "U2FsdGVkX18tx+nIU4Snfx2JkWILT4/EKJPVB4FEmtQ=",
    "cpf": "U2FsdGVkX1/0SLqz41mWYBPKaBzBV8A7yn70FBZMPDM="
}, {
    "num_cand": "U2FsdGVkX1+0v1thL2vnOKud/ovpEaNEINjZIarmIsc=",
    "cpf": "U2FsdGVkX18sw43VzkbA6APsGHd5ys+sZe/3tLqy+nM="
}, {
    "num_cand": "U2FsdGVkX19ybKa9zgpexkdQvBS2+Cc78FFwkW/Qzxg=",
    "cpf": "U2FsdGVkX19YHk02bccptlYUkFw1mt9i/TG4oRZ61Ts="
}, {
    "num_cand": "U2FsdGVkX1+LtQ1O7XVJfczcPfgLZCd+BfkQ2/lbEPI=",
    "cpf": "U2FsdGVkX1/JpW16pvh8qxIgj7xk7uL3faEZpx6ALJA="
}, {
    "num_cand": "U2FsdGVkX1/pciBFl8GIcGztw7vZpAPbJxrOFNmg8pM=",
    "cpf": "U2FsdGVkX18WPNbMmATraYpseK1ilOFcXOKA4Egjb8w="
}, {
    "num_cand": "U2FsdGVkX180EEU96pZIMT0FwYhamzLMGeMPOLjJ918=",
    "cpf": "U2FsdGVkX1+GwX/UhHsiKo4WftdXbXQXwlLvyjMc/Sw="
}, {
    "num_cand": "U2FsdGVkX1+KzmWfbNWK+eMOQEtfvcg/eyj8xlXZt8c=",
    "cpf": "U2FsdGVkX1/cGELaT5WfyURZg1RrLmoo92zZz2u1qdA="
}, {
    "num_cand": "U2FsdGVkX19nbfD5sgQ0PfFmZLYkFpbVW/Ef59029lg=",
    "cpf": "U2FsdGVkX19wvLYKFsA8LKNQHWZa40NZexAWjPHR/hY="
}, {
    "num_cand": "U2FsdGVkX1+v5K+xV1i7Mkqszf5IOZ17hLh5O+1DmqQ=",
    "cpf": "U2FsdGVkX1+BOPnfuv8hkO8nTel7FzaEV/XMwAMyjWw="
}, {
    "num_cand": "U2FsdGVkX1+SQr8ElAuG2vgo9s9kEmPwJz2F05IRYMs=",
    "cpf": "U2FsdGVkX1+8//6r2uz7Qrd6Qy8J0p5g087oIIkamkc="
}, {
    "num_cand": "U2FsdGVkX1+6Ax5c72o07fLo/4uMCIHXG0nlf9xp1dI=",
    "cpf": "U2FsdGVkX18vyBgtJuOTajQc+GRXybKmk+OHwI47QHk="
}, {
    "num_cand": "U2FsdGVkX1/IQMRNwVKPIDC1/jCbFfPC9RtQHDo8ybg=",
    "cpf": "U2FsdGVkX1/R5pO8Nt7OWGtE80apQhaCxsRRMyBBzt0="
}, {
    "num_cand": "U2FsdGVkX19a9K9UHrLEKdBnE8AIZ1mADUAHF7elk+U=",
    "cpf": "U2FsdGVkX18s1tcDYkQPNZF4RcIomYdIFBX53mUas94="
}, {
    "num_cand": "U2FsdGVkX19QoWmgwgM/nI0WwNpFfEm2bgyHQ/iM6p8=",
    "cpf": "U2FsdGVkX1/wEeQnasqcSNLFHNJmYPhcpE6EIcnTggg="
}, {
    "num_cand": "U2FsdGVkX1+dg0EAok9R4VCTo9x6AqUkGM6TzTND59Y=",
    "cpf": "U2FsdGVkX1/OK1jMEblhdK9YrP0Fk2yyl4TL4mI3SvU="
}, {
    "num_cand": "U2FsdGVkX18sHD96OsI8TNm7FLfCuQ0xT3Itvd8o5xQ=",
    "cpf": "U2FsdGVkX18W/UnKg8qFsEzERVqiYQV6E4zbygTlsh0="
}, {
    "num_cand": "U2FsdGVkX1+sfEax+Zl5u9VQm1Enn1e7FqHji5weFv4=",
    "cpf": "U2FsdGVkX18K5mTtWGpXHW/esktaMFNBiByzbJltYz0="
}, {
    "num_cand": "U2FsdGVkX1+mfZ87B/+THALw7GNQMclhfknEzqjSQCQ=",
    "cpf": "U2FsdGVkX18fgBMZqKlQuGcVSaiutjJoQh8RbW3SmSs="
}, {
    "num_cand": "U2FsdGVkX18oa/9H11cy2vAB9CSoh6NfKar4m83W/do=",
    "cpf": "U2FsdGVkX19P05oS/B28ozF2Q0LR91d9DIquJav6CxQ="
}, {
    "num_cand": "U2FsdGVkX1+b7F5JMrbZyVrk0Y+/NS9TwQ4ZUuSxBus=",
    "cpf": "U2FsdGVkX1/KVt6gGrspGGHXlUT0lUl9CGO16mPlQao="
}, {
    "num_cand": "U2FsdGVkX19rhfK1chEMTLv6siLRfArVD6Q2gYLtOaw=",
    "cpf": "U2FsdGVkX199LAQ+1m5YdVKRYngygIswEsoSW+rqUe4="
}, {
    "num_cand": "U2FsdGVkX1+nxj8Ft8NVWddr7YhEhECXvNLgESWUDak=",
    "cpf": "U2FsdGVkX19os9DLcT8RmVyuR4BGaU2p7I5EM4xG3Uc="
}, {
    "num_cand": "U2FsdGVkX18BxVL2yRdHssb6HlOaEZ3Dlf61JXP6UKE=",
    "cpf": "U2FsdGVkX18P+X4ar/F+MK2Gb/TCjQYjnsGRyk6hPHc="
}, {
    "num_cand": "U2FsdGVkX180XTAF2M3k1aDcWlVrVf2lsW2JWZ8Wnuc=",
    "cpf": "U2FsdGVkX1/ykRmgskE3+qc9+XcKjtWGWIBNVUJCEko="
}, {
    "num_cand": "U2FsdGVkX1+OgeMwhCS5SMWNZK/YEfBK9MwOOfj2ZbY=",
    "cpf": "U2FsdGVkX19fIKsLOWKMmScqXrSjfvnVHj2+DLJdt7o="
}, {
    "num_cand": "U2FsdGVkX1+/+G6mAbMrJY/q4Pykj6OvEtW1fxotnsg=",
    "cpf": "U2FsdGVkX18P2oGJr2Bg1/C63Vd2XJeePHLxBR7Q8zI="
}, {
    "num_cand": "U2FsdGVkX18R+M7ZyT6Smlxlvu3Tg+q2z25QXlVSE50=",
    "cpf": "U2FsdGVkX18FHyaCKO/H64ExGP3+cT0M7Q3G2So5Zdk="
}, {
    "num_cand": "U2FsdGVkX1/l232U4t4cyaIy6DEeJ4gTdU9IrDnAkLQ=",
    "cpf": "U2FsdGVkX1+nq1QfG6zbpBnVfQq75CdO0r4Hk3uFNvI="
}, {
    "num_cand": "U2FsdGVkX19QnKLbIFLtXmv3axVM1+kX3m0a2cbNjpk=",
    "cpf": "U2FsdGVkX1+fH/L8UHGcsqSoGGTC2d14G0p6Cr8zIX8="
}, {
    "num_cand": "U2FsdGVkX1+aaTMily5/9ZND70um3JJTyQiTBqwmZNU=",
    "cpf": "U2FsdGVkX1//hNp1LS7/YiytFhrU46SeCJkaJzIy4XY="
}, {
    "num_cand": "U2FsdGVkX1/g4x1+GRrtZILES/ZOVtBgHksLmf507KI=",
    "cpf": "U2FsdGVkX18fjUX84Fm/HztCubQnGuOJZ3ysoTHlvjA="
}, {
    "num_cand": "U2FsdGVkX1+G3bSeBV3eOcIAP2QJvwnON8tVeGwAG0c=",
    "cpf": "U2FsdGVkX18xnVjAcGrinCnwmxX5G6s0Q5pIke+zxxI="
}, {
    "num_cand": "U2FsdGVkX19hobIOdwxGE8Ug1FTS4YTTKN6Qnu2zZfU=",
    "cpf": "U2FsdGVkX1/k28U7J3t67VkeLNQJVIsqplaAkkpxbH0="
}, {
    "num_cand": "U2FsdGVkX1/5HwpZuIZY2in49JLA1C1GgBtL7soHuYY=",
    "cpf": "U2FsdGVkX1/2GvhRGdWFioxLO3z2nSab6/q93P1l58o="
}, {
    "num_cand": "U2FsdGVkX19Xw9VV8ln13Y38uo7NGwtiPugMGCcbRVw=",
    "cpf": "U2FsdGVkX1+e2kiODmxKNSXldbYwa8lfB2cl4TaI6BI="
}, {
    "num_cand": "U2FsdGVkX1+ix7KB19T4QyuhF5FY+EzQng8FhTF6Wsw=",
    "cpf": "U2FsdGVkX1+2voHXtggws8Djx/aZBCr7T60s76rjqwI="
}, {
    "num_cand": "U2FsdGVkX19Ud4l+9glCrjvWLgXU8pZ4XDnO5lBwLuw=",
    "cpf": "U2FsdGVkX1+K18I35NhxDaip7+Eda4qGsv0tk5T6YGs="
}, {
    "num_cand": "U2FsdGVkX18VwEwExGxCQPkTdO7m56CPsBfd8jIXkT8=",
    "cpf": "U2FsdGVkX18XdHj3vAfSdgoUTj7PXsc3XurjwjxsAss="
}, {
    "num_cand": "U2FsdGVkX18Hukx5nM33huk00gPjm2SgXY83gZZynF8=",
    "cpf": "U2FsdGVkX1+UQNqTidx6yprrO5Uo7skwVjNSW4wdvjk="
}, {
    "num_cand": "U2FsdGVkX1/25FdMf8XjvpUF1RFjzP5rGZRo5zOeDZY=",
    "cpf": "U2FsdGVkX1+ak1/GYhE/e3rBuOqkqDBGeTWa1Vu2Piw="
}, {
    "num_cand": "U2FsdGVkX1946PrGHhGOLVQbC4DOU7uy0Xb8IeNy0n8=",
    "cpf": "U2FsdGVkX1/KkNoe6ezC4ZswHfLypYXAnDVKAtKe2C0="
}, {
    "num_cand": "U2FsdGVkX183o8NTILOket9hMoO31xBH1TW6mBkMXmg=",
    "cpf": "U2FsdGVkX1/3r60DNLKmcMchAOZhhaVh8S4yChkdHAY="
}, {
    "num_cand": "U2FsdGVkX19Ky1qnlZCayQPWzDOX9Wt0MDAeM8RLSDM=",
    "cpf": "U2FsdGVkX1/uP3WSoknHnKg9+t5Juvn8QCW2uBTDXVI="
}, {
    "num_cand": "U2FsdGVkX18m8/EaL420Rz+hBvy71mVjEUutValoSB8=",
    "cpf": "U2FsdGVkX19Mx9L6uwPq4oqyX5mLFDpusAVuvQoilI8="
}, {
    "num_cand": "U2FsdGVkX183VCzT+x29wWchP8sciN6sJ7Lz84QX220=",
    "cpf": "U2FsdGVkX19OBjLrFUEpFe7wQbM/DFxwwGutbOcHxCU="
}, {
    "num_cand": "U2FsdGVkX1+k7y3+7aTC2hE3b1R6kr6cIUmccvxfBf8=",
    "cpf": "U2FsdGVkX1/8gHihyWwc8PhjrwP6QPDkWw0xb/JfANM="
}, {
    "num_cand": "U2FsdGVkX18XQaPJwg1DvibS/VHP3iaGg+Ue7GmBpTU=",
    "cpf": "U2FsdGVkX1/sn0NyBGHW9L4H3ZOvbE//thy+UFZD92U="
}, {
    "num_cand": "U2FsdGVkX1+AhgGfmQHDk0QGyMQbvVgCBo4W/E/XThE=",
    "cpf": "U2FsdGVkX1+w897fugHG/39y8aIJ6JyhEf+ptRZqzBI="
}, {
    "num_cand": "U2FsdGVkX19UNxmf+oBWcoAqyGvHzuyE8VncaM/m8W8=",
    "cpf": "U2FsdGVkX1/BfP2XaAbydUGIV/vO7QLXqpWjBU3PqZE="
}, {
    "num_cand": "U2FsdGVkX1+twGTiPKd6e54FOttpNlFGdwfUpeNQ2Yo=",
    "cpf": "U2FsdGVkX18UyvYeU60npbi7URoVguWlO/26vR5pnG8="
}, {
    "num_cand": "U2FsdGVkX18+SG36X6nJ70r1IDp8BQ5trwG4/DDLzdI=",
    "cpf": "U2FsdGVkX18InwAgunP4K0lzYhZwiu+VDeOzGWeGPtc="
}, {
    "num_cand": "U2FsdGVkX1/UPqKjqHZtpOOEo5UCNJZE/tskqkK/Rxw=",
    "cpf": "U2FsdGVkX1+CO9gqh8XOKYPC+plOd3i/VhZqDGfBVho="
}, {
    "num_cand": "U2FsdGVkX1+3JdgWoj18sn5/ufj9KLS0R33cEPB0FbI=",
    "cpf": "U2FsdGVkX18gZoc91uQOO9qP8hE2dQ9SKK169qjuo74="
}, {
    "num_cand": "U2FsdGVkX1/5pMs5lWigX6BMA6vHxrunTAEfaoUPStA=",
    "cpf": "U2FsdGVkX19BebhBTrevDFJmkPHTQheSaCV9ea2+V3I="
}, {
    "num_cand": "U2FsdGVkX1/ilA96kboj9NOZDz0RwEeX1j9uCY+CN7c=",
    "cpf": "U2FsdGVkX19cUSJXgixr16Uoro5FhrzYh4BEfjJ7Q7Y="
}, {
    "num_cand": "U2FsdGVkX18Pu5TkYGglS9KULv/crxpFevfi+FhbdDQ=",
    "cpf": "U2FsdGVkX19QVYjyRsG9rkIAhVNJNR/k//j3b1d3NhQ="
}, {
    "num_cand": "U2FsdGVkX1/tDIHhy2yUzqojZy/xGuIuwMdfX1m7ong=",
    "cpf": "U2FsdGVkX1/V4FMovNZ2hqysuOLppJx6aXBppxELdM4="
}, {
    "num_cand": "U2FsdGVkX19MsS6knfjNnEaC6s+5Ww96YQQzyIb8ess=",
    "cpf": "U2FsdGVkX1/0iYyUNaBuQtNlljUU5gp6f2z67A90xN4="
}, {
    "num_cand": "U2FsdGVkX18C1RZYRrLNmwj8WGMK9VXnPN/6KEsev68=",
    "cpf": "U2FsdGVkX1+k2FJxYZPFLE9Mi0+OKHOD3VPemDX49k8="
}, {
    "num_cand": "U2FsdGVkX1+Yaq1DFLmdQk5cJV7OatQS9Ri4jj357W8=",
    "cpf": "U2FsdGVkX19l8vZTl+x9W3iVNFsZO1daZ5FO17CvR7U="
}, {
    "num_cand": "U2FsdGVkX19C//e7QI/zAxgtIiFCg4gtii2/eoNDeMk=",
    "cpf": "U2FsdGVkX1+qKlXerWP6FmnB8vxFNQw33iwp4mMmDKs="
}, {
    "num_cand": "U2FsdGVkX19uciG4rQno+3rew6uQvL8/B1OvN6G/rt8=",
    "cpf": "U2FsdGVkX1+9FV5ofm55UYiFNIR+iwiI5XVMQxXZvC4="
}, {
    "num_cand": "U2FsdGVkX1/WgH/XJO4w8Ut5czAhFRKocEk900XVa/U=",
    "cpf": "U2FsdGVkX18oyuKYxEe/V8WGcAqGGWYJDmjm5367QiY="
}, {
    "num_cand": "U2FsdGVkX1+RPEjcwboVoGux+eHc2jdMXckhdHQi4Fk=",
    "cpf": "U2FsdGVkX19xKaHbg6HrHwrDZvAsLER416HAM7wFGAU="
}, {
    "num_cand": "U2FsdGVkX19p201SabfTAAfrVKsIqBUNKqc+TjYSBbc=",
    "cpf": "U2FsdGVkX1/yej8TGdjt6cZygyMBfLh2vrNEKhdFCsw="
}, {
    "num_cand": "U2FsdGVkX1/ORPtkruB9FeW0hZ/niUiX8xASEG/OXME=",
    "cpf": "U2FsdGVkX19CztCownp5g0E+E6ppJ2OtwTz09BrTsDg="
}, {
    "num_cand": "U2FsdGVkX19yWLDBU75/Iu0oVP/e0BflWH6OckBydvs=",
    "cpf": "U2FsdGVkX1/CjNP+gYW9JF2oxVnzHJEiTSvlHZP5BaU="
}, {
    "num_cand": "U2FsdGVkX1/ncaTG2P3adCYk1aR975gDdLZQ9cQeBvY=",
    "cpf": "U2FsdGVkX18+lXf+R8lopwy34t5Ur6bolvv44gABNA8="
}, {
    "num_cand": "U2FsdGVkX18HNgF2pmngquZw96KZgx9hSZG0sOevviA=",
    "cpf": "U2FsdGVkX1/1nDl50wekRGnN+Xpgq0ZnEuGKOYJitO0="
}, {
    "num_cand": "U2FsdGVkX1/gVQAWtK4gsO5wcQU0fRQy0btqSR0bj7U=",
    "cpf": "U2FsdGVkX19Q56KZKL65F+Ftc5OQlrHr9ZnkfXD3ZNg="
}, {
    "num_cand": "U2FsdGVkX18L4kpPr2+SMj707zHO9qgm7QfNwR6bp5I=",
    "cpf": "U2FsdGVkX19Yi0B2kL6T6LufkfMkWdAFu5y0sMsVbFw="
}, {
    "num_cand": "U2FsdGVkX19HGtLUdYlAMbfWrhtqu1zU0WFO7Ex5FYk=",
    "cpf": "U2FsdGVkX18H5vDd6yGSq4qk03dJ69cUf/Ay70685es="
}, {
    "num_cand": "U2FsdGVkX1+FQBeF58rMvVKwYNP/r4VUjCiHhIdK3mE=",
    "cpf": "U2FsdGVkX192f0OtbEjyLuJBKQfqpNTPhVbT3tfpTG4="
}, {
    "num_cand": "U2FsdGVkX18LB4fB81T7LiH6mmeMdJIk9HczHk3h4VE=",
    "cpf": "U2FsdGVkX1+lU9Wl/LE0jcqwy6IFE5PgGeGgpIXVi/U="
}, {
    "num_cand": "U2FsdGVkX1+MEhdM7/ZtdC+TBmbnDU3u5YawNtP5RJQ=",
    "cpf": "U2FsdGVkX1+cl9XUZEtSWgburZQorMFrQTIl7w1OEu0="
}, {
    "num_cand": "U2FsdGVkX1+CraGVIxksgdggUXFqRYq9yUXzu+VB/vk=",
    "cpf": "U2FsdGVkX19TGng5WV00jhoRDCWaSBsv7rPklkVvDTo="
}, {
    "num_cand": "U2FsdGVkX19saQVu5+OGok2XcTDDK7JNfXKs87RuMOc=",
    "cpf": "U2FsdGVkX1+Wpuz5V8XGkwHAk+oXUR/t90boTm56KKs="
}, {
    "num_cand": "U2FsdGVkX19I29JKmJG4gwzVud47RPBoHNuiO9u2mws=",
    "cpf": "U2FsdGVkX1/oBsuld3b84VW0wYvh0+tRU/j4iLUtS0U="
}, {
    "num_cand": "U2FsdGVkX196bVuWh4z73902+3Vw828cuyjZOMJiiwY=",
    "cpf": "U2FsdGVkX19zTSPLKqX19QbgRzwz1fitmajFpkn1guA="
}, {
    "num_cand": "U2FsdGVkX18aoQMJ/c11aYlSOf49gadooSG/VW/jVmk=",
    "cpf": "U2FsdGVkX195jmZhlBOMG8YKrR7W/ghakAJbvqMQSXc="
}, {
    "num_cand": "U2FsdGVkX1+W/MGaoqnui2ymph/ZerlBlPmX89U2FCY=",
    "cpf": "U2FsdGVkX19M2jxKLqgTaIev3d3LdcEAVXUHArE0nqA="
}, {
    "num_cand": "U2FsdGVkX18gLtABknbifzmiTg8TzLherWsmiEyD9CY=",
    "cpf": "U2FsdGVkX18uKAv6AIj226hvePE0p0RCY8jWrndf1uU="
}, {
    "num_cand": "U2FsdGVkX1+u0A+ILfhVhr3IZXezcLTjflGpsyc3LO4=",
    "cpf": "U2FsdGVkX1+0djoIuVxdmRTGq6bai4wK5FuE1pw+Uls="
}, {
    "num_cand": "U2FsdGVkX1+PsS29JoU5MMj9qlunx+Ois9BEplKg3VE=",
    "cpf": "U2FsdGVkX1/SM+vNMlSKB+RuFB2xFmL6aeh2jsuvcuU="
}, {
    "num_cand": "U2FsdGVkX1/B6WgYGaKYT1xSApInxqR9rnpV8Q2GQ/0=",
    "cpf": "U2FsdGVkX187eO1tUeBNgFPTs6xk9q8m3Aq7X68CGdo="
}, {
    "num_cand": "U2FsdGVkX1+taHl8xrYT3AhcWjYww/0/mwkXFCqipBQ=",
    "cpf": "U2FsdGVkX19f38L3c2mCtG3//nhX4HA6AD14sJsJZJk="
}, {
    "num_cand": "U2FsdGVkX1/UYNZ2l7IBbupffrdQ+RbtuCM1bxXTlaA=",
    "cpf": "U2FsdGVkX19RLjwcX4bboAJ4LGKi6abRwdH/KXf477E="
}, {
    "num_cand": "U2FsdGVkX1+/r91BFXCJF6mJ6Zw4XFADZbATZn8MvD0=",
    "cpf": "U2FsdGVkX1+y9a2tIQqHHJj5vJbz4Ajk8u/6+R61qy4="
}, {
    "num_cand": "U2FsdGVkX18SEig64/iVKRioEcHmGIg3nH/AblLvFAQ=",
    "cpf": "U2FsdGVkX18DD/BeWKLxfhWnQ95PqmtKgO/0W64YNfQ="
}, {
    "num_cand": "U2FsdGVkX1/SEsG428SqyQ5c9S1SN/+hP6fcxj+YL5s=",
    "cpf": "U2FsdGVkX1+An/1+wtb7QJpENKnBtcWs9CwTvRNXZYc="
}, {
    "num_cand": "U2FsdGVkX1/S+vO0I6yQtj1tAEfgFxRUQQ6hT0V6P7g=",
    "cpf": "U2FsdGVkX1/xjZkisQtntcxsV+A4eImIyVPry8XOL0I="
}, {
    "num_cand": "U2FsdGVkX197nhyjRvdETJWHQ7k7c4yEQzEl00S8A1g=",
    "cpf": "U2FsdGVkX1/VQRQLGmVsG3JXSbr+TZ3w8S5iIWbzecY="
}, {
    "num_cand": "U2FsdGVkX19MRM3fGnfrJ3BSOMHNNv0N1HV2Ho+itEc=",
    "cpf": "U2FsdGVkX1+HrrjMv6N79fBhjf7kgm37JtONerwz8oc="
}, {
    "num_cand": "U2FsdGVkX18hh5uMojM1bZOuTbynTrtaEKf8mwrfUPw=",
    "cpf": "U2FsdGVkX18G9aPqdAwmzeGcF4IbWsMl2/FgE0GOSBk="
}, {
    "num_cand": "U2FsdGVkX19FaQ9KpsjGTCGtJPhCsSHyBBszKwpR0+c=",
    "cpf": "U2FsdGVkX1/SeBA5FJ32YRr1yYI3DgK9ZdJ5aOTqUno="
}, {
    "num_cand": "U2FsdGVkX1/D5vyVRIbP8LGnqOAh9RjGK9xeFRBVSuk=",
    "cpf": "U2FsdGVkX1+YtCwgGl9Uu4TzdAU4IZDWFqo3i4BmshI="
}, {
    "num_cand": "U2FsdGVkX18ZeTAAuF79+iblDC39o/vT3BvSVdO7I9I=",
    "cpf": "U2FsdGVkX19zWjyEFh+tBJeOMSLIIfNZLckoOPLBvrc="
}, {
    "num_cand": "U2FsdGVkX1+csw5tHjcffefNwIcO5xkhVcA64gDEJ0w=",
    "cpf": "U2FsdGVkX19asfZxU9uJZW6Pe0MRGbYG9fvkZkO7E3M="
}, {
    "num_cand": "U2FsdGVkX1/m7ppJQOpjY6+Qq6UXKSQIJTADoInEEcE=",
    "cpf": "U2FsdGVkX19bNXwILvNXJGGifyQPlGfre3GcwnRIYNE="
}, {
    "num_cand": "U2FsdGVkX1+BEBCfLDhJfLRZ3TKiVq9KuN7fY2rhzcQ=",
    "cpf": "U2FsdGVkX1+SdS/YFTjCnur6veDPb/ovfxMUDaTiaxo="
}, {
    "num_cand": "U2FsdGVkX1+wnCMhy4NmGkc5TQBfyspCuynPn1coB0c=",
    "cpf": "U2FsdGVkX18IkCyMJSnNPgFdNX4WlC4EDq6PnM43MoM="
}, {
    "num_cand": "U2FsdGVkX183bKYfKELQVh8XDyaKJF9BvnAQM2CcgZM=",
    "cpf": "U2FsdGVkX1+8I3W3a0i9+Bk6g1ljcaqjXD5KMpTXnp0="
}, {
    "num_cand": "U2FsdGVkX19mg2vmd4wThOiGBLGokZoWJsgxKgL6e0Y=",
    "cpf": "U2FsdGVkX18fmdSxvTzS8xA6TKkjeasXsZ22QeDpxwI="
}, {
    "num_cand": "U2FsdGVkX188o3OwFakIeBxefOCLzC0oqfB59eCMoJE=",
    "cpf": "U2FsdGVkX1/+WWxo21T8oFeB3J9Hkt6I/QcrLTdNnvA="
}, {
    "num_cand": "U2FsdGVkX18F9S/T4mBIpQ/2BOUfk+ZjdpCYlU0ymOQ=",
    "cpf": "U2FsdGVkX1/yNI6v35JSoprTqxrv6skJb4sRQD+FjWU="
}, {
    "num_cand": "U2FsdGVkX1+IwsCs6ULXJkzPCfpAfzIOPW5B52Jk9lo=",
    "cpf": "U2FsdGVkX1+RBaCLxdjD5rFhvsH1dfrX/8Z97KQM6gY="
}, {
    "num_cand": "U2FsdGVkX1++OLkzFs6en0beq3WXGrpbEFMlHELtawc=",
    "cpf": "U2FsdGVkX18NrLda0wbWrNIW6Osi8B1PxBAFtoUbdqQ="
}, {
    "num_cand": "U2FsdGVkX1+D1fWMxYunCinkOU0YveIeqIFikpm+4YY=",
    "cpf": "U2FsdGVkX19DijIsiNyUvCDheT9tKTheWUepBKCvSMs="
}, {
    "num_cand": "U2FsdGVkX1/i8oZHuhaRdEnVYU6QG96EvydPS5NeP6I=",
    "cpf": "U2FsdGVkX1+moh9RPWBZFYFekgdq+26EamQQG3MtzGM="
}, {
    "num_cand": "U2FsdGVkX193QN7GQaC+lgEMT1iToXvt1QOp0oADdT4=",
    "cpf": "U2FsdGVkX1+Md52965gcHjAIQHy/qNdHSO19u7SV9i8="
}, {
    "num_cand": "U2FsdGVkX18Zq8n11c6KVrpyqbkM5l85ppoF2HNkGU4=",
    "cpf": "U2FsdGVkX1+5rnEWkuFJSMgdCIeu2WGRXDiBzAc04IQ="
}, {
    "num_cand": "U2FsdGVkX196jtTeMW6NYrzl8v6snJ+dPQUr2bfVAU0=",
    "cpf": "U2FsdGVkX1/HjR+ZJypLgt0isaMaSZwHD1nzeq0P5Cg="
}, {
    "num_cand": "U2FsdGVkX1+3zA216xoTiJWZRumSdjAQBu64IOiHMII=",
    "cpf": "U2FsdGVkX1/rPx8nZKXveMP877rmVbMNuAe27h2+PSM="
}, {
    "num_cand": "U2FsdGVkX180oDOwdD1/CmxQq0wTFzHbqRaF3AfTjLA=",
    "cpf": "U2FsdGVkX18dCm7VcbZq3t3ZbnwXV9EUGQhot33OEWQ="
}, {
    "num_cand": "U2FsdGVkX19QCiTGUXpvtzybfWRFsepGCECoe2CAPhs=",
    "cpf": "U2FsdGVkX1+vGAUdho/OFL9aoeavSOeKxgHCHWDQn/Y="
}, {
    "num_cand": "U2FsdGVkX1+fgsEX/0606McGuob8G41gQphcpO1vm5w=",
    "cpf": "U2FsdGVkX187OlDXFPAurEDw86fY69AzfAZn2ck1WX8="
}, {
    "num_cand": "U2FsdGVkX1//aH1noREok/16RRH0Pjq/gTgBWt3wup0=",
    "cpf": "U2FsdGVkX18eFQPNDQ0giJjpWvs4uDPbgq7mbnKqtiA="
}, {
    "num_cand": "U2FsdGVkX1+Azl8T5wqgjezr5vgLfqhX+v1MxUYOPfU=",
    "cpf": "U2FsdGVkX18VFdhMQ/eZIzvaeCzNhzgyZTsBSILE/cg="
}, {
    "num_cand": "U2FsdGVkX1+tqm8MZQmW0zxkqSrrNBRPPnSybIUodVM=",
    "cpf": "U2FsdGVkX1/1BZO+/dJR4w1KjA7NELBR+bLjqfEX3C4="
}, {
    "num_cand": "U2FsdGVkX1+IWVuKZ+TKyiQQxjIugNTk9/7D7miT9w8=",
    "cpf": "U2FsdGVkX19Q6tJNY/D2640KMDh7UVK3mqIMh2SWqNo="
}, {
    "num_cand": "U2FsdGVkX1+8sN2Qds9a7fTkx3iH26zBk0RAcLTyLM0=",
    "cpf": "U2FsdGVkX1/uKvW0cl/HgXxTcY4hTdaEgIri9W0RAXA="
}, {
    "num_cand": "U2FsdGVkX193LvPugozWpDWbC0EDM0rmdfyeBRdGI5E=",
    "cpf": "U2FsdGVkX18R/9AeFgvZyK4QMT5wWeQaMxIM9c1hS1M="
}, {
    "num_cand": "U2FsdGVkX190VAACOMldFjJadpF/QclzRijIn0abBNg=",
    "cpf": "U2FsdGVkX1+HbPYM5TFsnJW4HysRWtmEzJZ3UPPw0s0="
}, {
    "num_cand": "U2FsdGVkX19aUr1bJCoU3XZh8/TdL5Itesq11OZfbz0=",
    "cpf": "U2FsdGVkX19QhaXeIJbCd8EikolblH3Y9wI6gpRzPMA="
}, {
    "num_cand": "U2FsdGVkX1/RfxCHBMKLpsay+JHskUs9zAPlSbbvJbw=",
    "cpf": "U2FsdGVkX18F/Zi0xt5Yd2SNM4RZSk+fEnzeodsvcPw="
}, {
    "num_cand": "U2FsdGVkX18ZZGLpGuoiD4JFmD68OPpB6G8K/ho0/0w=",
    "cpf": "U2FsdGVkX1/gBFiCQeVOxAxYJk3JXvccqQxSsOJsBtY="
}, {
    "num_cand": "U2FsdGVkX18aAeQ+VXzD8r7xfWOUJ1g6duMx59e6yx0=",
    "cpf": "U2FsdGVkX18ck6JnZlNmnXQ8OldxxwH/a2mJ5eIDdDg="
}, {
    "num_cand": "U2FsdGVkX1+yY1tzc38jnhJO90M5IVNiD0+M6kAWOSQ=",
    "cpf": "U2FsdGVkX1+/I8MYaSJfjyJOPEQcLzonrsMGcirwzt4="
}, {
    "num_cand": "U2FsdGVkX1+cGYJvf2E9ofQL9tRNGbjb5dyWGxJ17q0=",
    "cpf": "U2FsdGVkX1+n09kx1MRXN/zbfJPN2BoF2Ik7RRT0eMo="
}, {
    "num_cand": "U2FsdGVkX1+WIxldZEkSJiOab3qDCjhHMfLxILwAyFI=",
    "cpf": "U2FsdGVkX1+S38OIui5DCtJKBK3LvBd1uF6bapbODt8="
}, {
    "num_cand": "U2FsdGVkX19GgcDBvtOMdG8Xuf8Rf+xPY7isqTIlJO0=",
    "cpf": "U2FsdGVkX18oNvs8+oZtDtr0UfNPQ2vvuuiBH4rN+ZE="
}, {
    "num_cand": "U2FsdGVkX1+DxjOuGhcdWoJFVOl6cpfgvhRU//wwaqc=",
    "cpf": "U2FsdGVkX19JPYtJHfWcpJ+OQHOra32eCn6RNPZtYa4="
}, {
    "num_cand": "U2FsdGVkX1/74UQxHmkwBnCiq6Wk4hkt4RVUJ/Q7muw=",
    "cpf": "U2FsdGVkX18qAP76s/hy0gKumnZdUqUWslIXRAOMYgY="
}, {
    "num_cand": "U2FsdGVkX19LDaHWP/TclOPCXHeEwQpY9XtFTknH0Ek=",
    "cpf": "U2FsdGVkX19IPyoND4lgbWUKDWmJdgJ3hN3Yt36ag6o="
}, {
    "num_cand": "U2FsdGVkX1+s1Fpfb4uMBqkpxk9CL61VB0lDDXjqLH4=",
    "cpf": "U2FsdGVkX18A5tYaQnYNH0Exem3GpzdBXhh2aAwPe6U="
}, {
    "num_cand": "U2FsdGVkX1/bjftY27u2cVkLIR7hZJdslvsX+GurCjI=",
    "cpf": "U2FsdGVkX180q2uWb4RORA6fJ2S8MFKeh6v2oqXOBqw="
}, {
    "num_cand": "U2FsdGVkX19E4+EOOtyg84BKWZ19O12oJW1EhhOAF+Q=",
    "cpf": "U2FsdGVkX1/C8lGRUB2ev25SGAI5fzKwdCwDGKWbxSg="
}, {
    "num_cand": "U2FsdGVkX18faMejR1VMSHIQj+CZzt6jccE/lLTdvUo=",
    "cpf": "U2FsdGVkX18KMMfEZJrMXDDRa8C90BkT7ZjScnXRmiA="
}, {
    "num_cand": "U2FsdGVkX1+IqHPYzYTmGqxAcMQfqGSTkLlFIzmkHm4=",
    "cpf": "U2FsdGVkX1+mVpVSnwPP4MPn/INyN34VBKCKDZgXACk="
}, {
    "num_cand": "U2FsdGVkX1+z3OtsMbMLybs1nuS5daRpBxZFPD8XdGo=",
    "cpf": "U2FsdGVkX1/dkSexQTVu1TqsUdO+jwEt/p0EZBfhmfc="
}, {
    "num_cand": "U2FsdGVkX1/TkpWKtxqDzA1yH+xOXdcLLJ2YozNmxjg=",
    "cpf": "U2FsdGVkX1/6mQyjijVkLj4tbnavcgPpfchgMTeWqbk="
}, {
    "num_cand": "U2FsdGVkX1+bkS4B3UJMoZUFISSPQsg6ZyXksrDe1Is=",
    "cpf": "U2FsdGVkX18GYKyRcTfy95TSwTEwmI/ZeMN/ThGiiLk="
}, {
    "num_cand": "U2FsdGVkX18bHNfecpaWLAb91607s+/cXn5o2z/PdJg=",
    "cpf": "U2FsdGVkX193a1+lqyzuuNMPhQ7KMLg8zuCZid2fNeQ="
}, {
    "num_cand": "U2FsdGVkX1+k9QHnjHqEAW8go8lHj5pa5svYF7HBSMY=",
    "cpf": "U2FsdGVkX1+5AI/X3Fy7L6nimDchqe6DMRZqTJYNtyI="
}, {
    "num_cand": "U2FsdGVkX18nJ+RUGgpcSliKprLXo4YcwF4aCIIQaVI=",
    "cpf": "U2FsdGVkX19TgDGv+IZpQJrSTS81Jk/3mUNyllPDj+g="
}, {
    "num_cand": "U2FsdGVkX19JFLJo8WguK2Q9LrMVVrnva5pwmsM/Dfo=",
    "cpf": "U2FsdGVkX19cmvBvtQA7fZtFpt3/i3I+uCSCgcoHJ14="
}, {
    "num_cand": "U2FsdGVkX182Ofi3GQhAS8gMswiyjy1rXYLkkl7EvnI=",
    "cpf": "U2FsdGVkX1/oF1HlX9vO4ecWjWWiKXn9H51GvN4Vygg="
}, {
    "num_cand": "U2FsdGVkX1/sYeOjxsWips5sor/Og7KxeJcvTEtMz9w=",
    "cpf": "U2FsdGVkX19u7XWwZAisOIm+Z2lLbofmw3oNG3xjqxA="
}, {
    "num_cand": "U2FsdGVkX1/ylHFAG9CWEQ366QKcYr9OISI3CPXlCyM=",
    "cpf": "U2FsdGVkX18REHGyoC3iH/+qtENahollPpDT/5unrgU="
}, {
    "num_cand": "U2FsdGVkX192fXfY9L8kUFyuh00AIP3TeDfnzCnsC5g=",
    "cpf": "U2FsdGVkX18GjL9maRp46ph4jBiMkyLI/ipHTlNCvH8="
}, {
    "num_cand": "U2FsdGVkX1+Ds25Lve1AWcuopHKP+lbANFOUevzWkBs=",
    "cpf": "U2FsdGVkX1+ictDLffnMyrFt1CioK5qjhi3HfvByrn8="
}, {
    "num_cand": "U2FsdGVkX1+/SiMohoeju09QJ7lik+18VVunmCx6+m4=",
    "cpf": "U2FsdGVkX18lZ21691sdg9LUYFS/GWJ0k8L33IjgC48="
}, {
    "num_cand": "U2FsdGVkX18TeH38/iRODQJpxOykhOBRhe+WB7gufN8=",
    "cpf": "U2FsdGVkX1/RecYCoI9e5txTtiDuUl5CpL0PDotV4y0="
}, {
    "num_cand": "U2FsdGVkX1/alVkniIQX8AkIiqZgfh2SzPzNy8qKyXQ=",
    "cpf": "U2FsdGVkX1+PRdH8y5bUnufis8AyBJ6mkMAXDyakquo="
}, {
    "num_cand": "U2FsdGVkX18WQ6l3BdeJivZyOkBAvRY6RLfWwdJEJQ8=",
    "cpf": "U2FsdGVkX19s1PHkF/pHCebMl9bHcALpDpHMkYFQQxI="
}, {
    "num_cand": "U2FsdGVkX1/e/9zXU0OITF7agIEHKZlT0HIbvRO8LAo=",
    "cpf": "U2FsdGVkX1+4STbpogN4tlnf4vkHdPkFqe9Kqye8pO0="
}, {
    "num_cand": "U2FsdGVkX1/48AZTdFujumnLCiDKdtN31Ixblb9vhAw=",
    "cpf": "U2FsdGVkX1+KgAk9WRAz/sWpDCHl6BU/9NmSCrz3kR8="
}, {
    "num_cand": "U2FsdGVkX19faAe7n2U8fr7KL1CGL0DgeKmjA7+d+do=",
    "cpf": "U2FsdGVkX19K4oBHQpqvr1Lhc1MeZ9SLhE3BMokKxo4="
}, {
    "num_cand": "U2FsdGVkX18QinZ0JcN5NOlRIfqDEim2XKuXrVZhjcI=",
    "cpf": "U2FsdGVkX1/nBQijFKGPBaR6tMDL7H2GsNPrtQ7RStY="
}, {
    "num_cand": "U2FsdGVkX18NjLH5bg8D/OyHuRK+NwAAyvoVedekTws=",
    "cpf": "U2FsdGVkX19gsZcXrymcYadVgb8wFulW5grzsYlOGrg="
}, {
    "num_cand": "U2FsdGVkX1+aJJc0+4lI9GBF+op+etGLtoE8G5ovu4o=",
    "cpf": "U2FsdGVkX18jTGhNe1+nlZT8xyEY95c8jbMVqsJcnq0="
}, {
    "num_cand": "U2FsdGVkX199mQVRQetIkPGxxwzAZiLieltgVor5wNw=",
    "cpf": "U2FsdGVkX19wfd5K6YPjyOPFvwcaPZcQ9GhwUmqBrwI="
}, {
    "num_cand": "U2FsdGVkX1+IJ5zsNG/EJYER3qFzl5FXyCKEi57r7Xg=",
    "cpf": "U2FsdGVkX19V5xfmda3dF5NFrF54QxQ93/at79zqNjw="
}, {
    "num_cand": "U2FsdGVkX18Qz5ZU/1UPfWElvB9S4zK2pO5X/TU/ghs=",
    "cpf": "U2FsdGVkX19GjezE9lCUlrtePTfbQwGLCWmKz8NS+Wc="
}, {
    "num_cand": "U2FsdGVkX1+lrD+2pajZrrFrR4B29onFomTj3Ouu5vE=",
    "cpf": "U2FsdGVkX1+D2x2ziN87fd14qnsRA0uo7kugWdoljDo="
}, {
    "num_cand": "U2FsdGVkX1/1b2ITQcLay9qRLPM55sDntg3ojchwA6M=",
    "cpf": "U2FsdGVkX1+bcHaEZVA0Btsll4m4rCGCQ/J7iHUUm0k="
}, {
    "num_cand": "U2FsdGVkX18XgxWNg7J1to4VftLOeLmYCCIVFjGT9Vg=",
    "cpf": "U2FsdGVkX1/vVFXd+51b5qOpO/8osqhZn6Ww6OwDQys="
}, {
    "num_cand": "U2FsdGVkX1/A/MVTunoJSX+iTw37WNwIGHpfoXHhqdY=",
    "cpf": "U2FsdGVkX18xPLGawxl/YTQ7LKH461kC7h46P0uw+pA="
}, {
    "num_cand": "U2FsdGVkX1/ZviK8gulgsnkRloOLFShFZ9m7u3cAjMg=",
    "cpf": "U2FsdGVkX18B++AorgsfONWfuzkKv5cHkSF9s3rfiZA="
}, {
    "num_cand": "U2FsdGVkX18ejIvJ2WTh6b1vxV2IU2WQgDjOHuAQdYU=",
    "cpf": "U2FsdGVkX1+fLvV0LeGvRc+gs98oL7zzWpjXQK8UKts="
}, {
    "num_cand": "U2FsdGVkX1/aPXEyDnmUEEO1CUqizd1QZJZ4EIfvapo=",
    "cpf": "U2FsdGVkX18NpJE+iiQvEwCZXDhoYr379vGpmgpy7AI="
}, {
    "num_cand": "U2FsdGVkX190tkH5oDCAIixFXXn+9r41JQKZw12iwK4=",
    "cpf": "U2FsdGVkX1+KNLqleUf2pzTS87uC8jY5zUwqFrRPfV0="
}, {
    "num_cand": "U2FsdGVkX1/GBW0Yl6V/E4ecADlV1IGRpbzw4yqcitY=",
    "cpf": "U2FsdGVkX194Fz5lusTHGqmebYmlXNj1Frwfe9iljNE="
}, {
    "num_cand": "U2FsdGVkX19h+igDrqu+D4EAMvuz8LV9RwY/8PeKzb8=",
    "cpf": "U2FsdGVkX18042XQPyupk1aCXWLD+bnG7f3/H8jeFVQ="
}, {
    "num_cand": "U2FsdGVkX19/0W6iTKEbY3kat7/QwAry1zmBcEXKsS8=",
    "cpf": "U2FsdGVkX19M5XEx0Tfl3ugrUFzEwdtAg5MCBj5fPL8="
}, {
    "num_cand": "U2FsdGVkX1+P7d5r30qYmn0bLNx1F+e4k/52DeIYCzw=",
    "cpf": "U2FsdGVkX1/UBVJJmDJYxhP0CKGG8xJ4+4k2Vv17hts="
}, {
    "num_cand": "U2FsdGVkX1/NcvJLV4aHEGOBRLI+YhYCLJG6XeaBLQo=",
    "cpf": "U2FsdGVkX19H2A65BkMMreCoaK0tuEejCf3HYlXSJpM="
}, {
    "num_cand": "U2FsdGVkX19F6hf8caWeSaSFcYjCkwgVpErzohRDAko=",
    "cpf": "U2FsdGVkX19SQDaibzLIKdvGq5053KuwvplK0jFF4e4="
}, {
    "num_cand": "U2FsdGVkX1+r+SvY+ugH/s+f8AnR3AUoEyyDBVCIT+s=",
    "cpf": "U2FsdGVkX18MqJdwnRI7duUrG67LilZnMS0TA9AZeLY="
}, {
    "num_cand": "U2FsdGVkX1/WLEKMYCCEzIN6xDqv+Id9e+SzmiVwHO0=",
    "cpf": "U2FsdGVkX1+UIMAM9Q8Aw8cWUJ+DBiyEmzIzBJObAnQ="
}, {
    "num_cand": "U2FsdGVkX189WELU+4JSQuSrHzUj4I028YPAylooMJ8=",
    "cpf": "U2FsdGVkX19eqXaK9n1J/cyiTdUhBn9R/eoEs2LVB0Q="
}, {
    "num_cand": "U2FsdGVkX1821y72HLRoX5B9+6Pfg4tk7bi8oXMjl48=",
    "cpf": "U2FsdGVkX19DbJlIs1pGYLNbIwdThV7lmXD1Wy54IPM="
}, {
    "num_cand": "U2FsdGVkX19O0p9NBe/7ah6RkktwmI91pSYNMHMEa0Y=",
    "cpf": "U2FsdGVkX19kA5JMGX8Du6TkSex1vH7Qsf4+Jxf+JPc="
}, {
    "num_cand": "U2FsdGVkX1+KyOkjzY0Ms2mSDp0bV3AOiRhV82ldWXw=",
    "cpf": "U2FsdGVkX1+TaS3LxQcAr7s2YfWaLN9F+KDSVQ1yHlE="
}, {
    "num_cand": "U2FsdGVkX18aAH0ortgHOw1bHX2Z9znJtnMDHXXdRhU=",
    "cpf": "U2FsdGVkX18rZjbjCTtE8Zvu/WJM6OEA4++FYXKqgpk="
}, {
    "num_cand": "U2FsdGVkX1+n9rcKI+SdKxHIw1qrLRFzgV+NprcFjdo=",
    "cpf": "U2FsdGVkX18Ue8XL+BEwUpcUQxH28PFBQBlrJe3cF58="
}, {
    "num_cand": "U2FsdGVkX1/ZJ+nqcDVd1lr+HH5QIqgN5RKr46FJSGw=",
    "cpf": "U2FsdGVkX183sEUEai4esrs8POrgDV3PnFXkLtT8YGc="
}, {
    "num_cand": "U2FsdGVkX185wGbU3bYTgVJiJDq4sPdxFo3/4OqYbUg=",
    "cpf": "U2FsdGVkX1/U5NeuCTePa97ZjplLYqEHvntpdgE6Pm0="
}, {
    "num_cand": "U2FsdGVkX19Z2H1aqFwXeVpdWOh/LqHWdeq4lk4ymZA=",
    "cpf": "U2FsdGVkX19IkEAvBy3wdtLGs4/uB1WWcGDWVomWrrA="
}, {
    "num_cand": "U2FsdGVkX1/T4kdg6u4/Q/TBiFUnjlK8ZKyLPtme8ow=",
    "cpf": "U2FsdGVkX1/f0yWiduOQVqC+QSbang/xWli7yK08EPU="
}, {
    "num_cand": "U2FsdGVkX19FUDSmdB3I8Cn37V50WuzLe5a9i3wk910=",
    "cpf": "U2FsdGVkX1/5EwMhXrgu/6Ow/Dd/d1ep6uw0C/1FuZo="
}, {
    "num_cand": "U2FsdGVkX186BW6FFTKEAN7watyvoz6ON4IDMn7q7rM=",
    "cpf": "U2FsdGVkX18xxnyHWnFIQOqqOX0QlU8D+3z2lCxGfv8="
}, {
    "num_cand": "U2FsdGVkX1+EJDg+cZ6pFutbLG0/51IcvpJHuDqj6o8=",
    "cpf": "U2FsdGVkX1/HIomwh9dPWsYQA/iyz7P0lIWlt4J6Ao4="
}, {
    "num_cand": "U2FsdGVkX1/zXxsObDgdfIhjZtT6/TK7nguOXO9FVXM=",
    "cpf": "U2FsdGVkX18J2qZKC3IrNWzGhMgtxc2TZYNHLKiJZbA="
}, {
    "num_cand": "U2FsdGVkX1+JG3OLqpmQUkZfHzd/1MJfH3Px+2gbcEY=",
    "cpf": "U2FsdGVkX1+BCbXNfxjXPGSIZHJUjn55KtVTjhvULyg="
}, {
    "num_cand": "U2FsdGVkX1/pbE29UIec1bVio8XU29Mp2pIIV8bmj3Y=",
    "cpf": "U2FsdGVkX1+aS/XmP7FxI3U6hOwNUkSn50HAa+jwKaw="
}, {
    "num_cand": "U2FsdGVkX18ZS6rmjWHBTHbWvVGRh6j9SDc27KsxefE=",
    "cpf": "U2FsdGVkX18h2THKVkU5mCUCuUc1tesYfuIgfw+o/ZQ="
}, {
    "num_cand": "U2FsdGVkX19E+vfF6FYKhqfGoGeeKnZON2re9ps/F9g=",
    "cpf": "U2FsdGVkX18acqw4I9u2qXHR7PduFtX7A7YhnGEC40g="
}, {
    "num_cand": "U2FsdGVkX18XocZm4NVayrYZP4CUjLP5qaylmUSYAN4=",
    "cpf": "U2FsdGVkX1+Q7sPMrV6PP7IgO/jfI/Y+aMv+tD+7c3U="
}, {
    "num_cand": "U2FsdGVkX1/1oxmKDpVLrTGLCxB1KJ3RsROOtEvmO84=",
    "cpf": "U2FsdGVkX18VTLojBOb7XBF8b7FBZa8t/uCgAhN86lI="
}, {
    "num_cand": "U2FsdGVkX19CjQH+8QBqgfbe63aWk4jQEsY4vV60eDg=",
    "cpf": "U2FsdGVkX1/+RbhwxY9Awttea6gRdqUDjzT2cTAUMbk="
}, {
    "num_cand": "U2FsdGVkX1+IB5GKvGX3O/eni4364YS/Pc9SvjkN1q0=",
    "cpf": "U2FsdGVkX1+RpZi/pXYnbmvVQ6jqOqLIo0AaGepIhmo="
}, {
    "num_cand": "U2FsdGVkX19GDz2+pr6VduLrAf/Jsk0BAWnYfzM97Gs=",
    "cpf": "U2FsdGVkX18C2X68dRHsOllnhO8WW32QHXb//j3NnrY="
}, {
    "num_cand": "U2FsdGVkX1/es9YpM24zb/4lPIm4eiIAZHeKyyICuZ0=",
    "cpf": "U2FsdGVkX191Ed+0/D6SjiVZQolKDC5eVRlWow8QvHw="
}, {
    "num_cand": "U2FsdGVkX19MNmaveOeTL6z6+MyG7SWoBh6yf0FAb4o=",
    "cpf": "U2FsdGVkX1+JeuDyywLqDfdTU1giclSK7Aekp2qvRkY="
}, {
    "num_cand": "U2FsdGVkX1+dVAPXoMAzhxYNHYeOFW1PqRiB8yQVOXI=",
    "cpf": "U2FsdGVkX19vELz+vFrPCNJnAu2xX7piqLDIzblhpbk="
}, {
    "num_cand": "U2FsdGVkX1/jZ8OCFgLP1rcPAca5KgHzJ1SvQxkoNB4=",
    "cpf": "U2FsdGVkX19nOJWfYlAas1tO8I88eNcQTkdEhysArls="
}, {
    "num_cand": "U2FsdGVkX1/sDRj0dsVX6L31GNLWjS7mTDWcvje7CQM=",
    "cpf": "U2FsdGVkX18sQqlhhh4noe/9XGsoZtAxCMT8CTI8T0o="
}, {
    "num_cand": "U2FsdGVkX1/GMNl6v/bbTZ3nRZbVRCK4o20kJ3Z/Sp8=",
    "cpf": "U2FsdGVkX1/D/SYbyFqtJ7dT8Lk8L3ovZyuH9sl7ZAo="
}, {
    "num_cand": "U2FsdGVkX1/Yk6Kfx222LDEy/ZfPc8s++Ts1SYbIxdg=",
    "cpf": "U2FsdGVkX1+aPKh7yFmomkG8403q9NLPkhQv6hHYazg="
}, {
    "num_cand": "U2FsdGVkX1+mRLM7iGY/+c5Vkkzc/ShV7SqROZfPHBI=",
    "cpf": "U2FsdGVkX19oy4rEWbl/kDlrQ9WrT2Ej9VkNml0qk0E="
}, {
    "num_cand": "U2FsdGVkX1+m0GyYfB+BbY1YHCy/dZl/AGbuo8+K5l8=",
    "cpf": "U2FsdGVkX18FctjpZlT1GZrnYVjfjN0EnYXL7+JAf8s="
}, {
    "num_cand": "U2FsdGVkX1/tLr9sXnIiQAdeqaqNKKPwNHu0AuHmpPo=",
    "cpf": "U2FsdGVkX1/TvNTXOn4gepLXUr5kehWTKjCwL9xenqo="
}, {
    "num_cand": "U2FsdGVkX1+tvpq5bIuK5I/gkjmvu6bOqCiyj8o1A9Q=",
    "cpf": "U2FsdGVkX1+BPdz428oFFtYByADM2YYPc1zhGriumWw="
}, {
    "num_cand": "U2FsdGVkX1+2ra5Zt9GQilvplZHSERq/V52WPRMt8d8=",
    "cpf": "U2FsdGVkX18TblaQuLJA+PdS7ptY8TGEH5utAq8bq44="
}, {
    "num_cand": "U2FsdGVkX1/WQyvzXoOOsfq1fTJd4zKv3yQ3EAMBnrU=",
    "cpf": "U2FsdGVkX19YxjwVdnvuaAqdXlU4apI7IifCbaRnFiw="
}, {
    "num_cand": "U2FsdGVkX18UMILTgds3ZyYeTfvk4qwrak31LrmCAvk=",
    "cpf": "U2FsdGVkX1/uw0hKMUJrJTSGovsRWSmEqjTm/rYQqdY="
}, {
    "num_cand": "U2FsdGVkX1/RVEA+217MjuX7PEH7wZ4UPT15/+RZVYs=",
    "cpf": "U2FsdGVkX1+K47AcXRaTb3kmsRz1HbnfSVFzsUuyHE4="
}, {
    "num_cand": "U2FsdGVkX1/YVZA6qcjezw16XHyCblWVWpiuEAV97TQ=",
    "cpf": "U2FsdGVkX1+y4TIvNHTg9nYxhSHC22pDEKeRBQAKnuc="
}, {
    "num_cand": "U2FsdGVkX19NKxGVpI840ZTvP2gD8KXrjmzUfnX4huM=",
    "cpf": "U2FsdGVkX1+uKAnxnOnGqvw1zdCqxNyPBq97HDPQQwE="
}, {
    "num_cand": "U2FsdGVkX1+sOx54Z6vCaQXOj23vPILE9H0f6gKLz4w=",
    "cpf": "U2FsdGVkX1+zIdyS8ZvVOgMuQp4WqH8ALmpUzPccP0k="
}, {
    "num_cand": "U2FsdGVkX1/aeUklMmWVakjl3xFr+n14oHJ3kC3Nhdw=",
    "cpf": "U2FsdGVkX18mFmCtJkDufJY+NjSiYtkxqDQ8WoHaPPg="
}, {
    "num_cand": "U2FsdGVkX19anJaTEEOze3FWrQDV5cbfJbWQs40HDwI=",
    "cpf": "U2FsdGVkX19+7JoDax0dlJwqR0n25wPUgi+bSfIEYi0="
}, {
    "num_cand": "U2FsdGVkX1/V229d+gxPRC6xmOJBPmC1ehtGvJsbpgg=",
    "cpf": "U2FsdGVkX1/Ll9dGkpuuof8MDnHF++Ddaai4LgfcFGY="
}, {
    "num_cand": "U2FsdGVkX19Q2JDtj+sxJONa15GuQNKOY1CaQxzPsp0=",
    "cpf": "U2FsdGVkX19NdchcJZCM63BPw47rD0VB8gdLxNBukhw="
}, {
    "num_cand": "U2FsdGVkX1/yDCvArcp8kuM8R7tTqRc9YBApkSLj5M0=",
    "cpf": "U2FsdGVkX1/J4g1uxL8AdITocL05ubFRS2pX6KuKuVE="
}, {
    "num_cand": "U2FsdGVkX1/qYrSkUSn4nPYTbbLAN5BCnImGRUMwXm4=",
    "cpf": "U2FsdGVkX19ZbUxiYM5jT00lfcBXe6uqoTJeM/giSAE="
}, {
    "num_cand": "U2FsdGVkX19FF92Z8vKxtoQ12Ii7B/OlGNGdVp9Mypc=",
    "cpf": "U2FsdGVkX18uw5goIoz4yBFi/cKsAJvpsXRngWJzFHs="
}, {
    "num_cand": "U2FsdGVkX19l20gOHZpNz6rJLzp5k+UJlAXMUBmk8aE=",
    "cpf": "U2FsdGVkX1/Mvdx4sNOuTO13FYfadQz/v9y3HBpnWhk="
}, {
    "num_cand": "U2FsdGVkX18El7YOyo2h7ej8w9/IOU4U4YlNz0mQNhA=",
    "cpf": "U2FsdGVkX1/gYzT3vdo1u2CGcJ3XyZE/64BHe+DJdpQ="
}, {
    "num_cand": "U2FsdGVkX191YWDfhbhNcVeNEHm2upfXlkj7n/NGOj4=",
    "cpf": "U2FsdGVkX1+jUMXquqnc4Jy8B0VIcC/ryVQ1zgAiK44="
}, {
    "num_cand": "U2FsdGVkX18+kUNtb1fC9aW97IvNgOnbfuGaeRtsHxo=",
    "cpf": "U2FsdGVkX1/Ys+jlwqLkawDQQt3cQ3L+4Xc8aD9OPdg="
}, {
    "num_cand": "U2FsdGVkX18FEc/GDsnozXC7X3KZhK9z89BISGB+xr8=",
    "cpf": "U2FsdGVkX195S134b2qQE55syA3MT9yveE1IhRZTrbo="
}, {
    "num_cand": "U2FsdGVkX18OLBMkcJV+b16aEtRlzxIgC9VMkIIlxU4=",
    "cpf": "U2FsdGVkX1+4EOCQaKwUGRPFp6N7SwU/m/wEjkl3fX8="
}, {
    "num_cand": "U2FsdGVkX1/K0pCZ/SMrVwaIurTEFlj3m+/2Mjv8xtE=",
    "cpf": "U2FsdGVkX19MVk+ujA0QXHMtHC8kxl36rOJjTJnF93o="
}, {
    "num_cand": "U2FsdGVkX182V7Q/9iS0ZKWbiqCkxiBD47zZp34JZZQ=",
    "cpf": "U2FsdGVkX18KiDOwHwY+5zVPJk61eZYEaEwLreHdqyw="
}, {
    "num_cand": "U2FsdGVkX1/khNyM3HkjYR/xw4JFKuwB3nU5V+jNZE8=",
    "cpf": "U2FsdGVkX1+XdgwwcVu3umY8DFEbE9gG89ZnUOlkv2Q="
}, {
    "num_cand": "U2FsdGVkX19ASVQ7HhnrXSBDhlj588+uxQBzRoR3omI=",
    "cpf": "U2FsdGVkX19+V8RhY+89e0XPYoygbfoE2OGFaNmoQXs="
}, {
    "num_cand": "U2FsdGVkX1/BltsjXdE4nehDXwOPdsTDW3idnZY4vG8=",
    "cpf": "U2FsdGVkX18oWvtXFymz++ltRhgYEBsCi+BXaB1aOjA="
}, {
    "num_cand": "U2FsdGVkX1+6RD/Yg+in/vKWV+h0h/XhDDWa18wxP84=",
    "cpf": "U2FsdGVkX18eFmuim5Z86+b+5GBO0Ni3Kv21zZe56gs="
}, {
    "num_cand": "U2FsdGVkX1+1OOf3KeiipytdeX2jVb3shnzI+yMXjH4=",
    "cpf": "U2FsdGVkX1/aAtn5qBfSFqojkmxRFiHtZ1aF3t/J5/8="
}, {
    "num_cand": "U2FsdGVkX1+01Z6/NoaKr6uHldPkAvPoiS+G6a+AaBo=",
    "cpf": "U2FsdGVkX19npaEKpRGoKBOhvkzxuKQh8hc2wd4RnKw="
}, {
    "num_cand": "U2FsdGVkX1+nc9q7Gwk8Vz81lGYi4k7itTe73TUq/74=",
    "cpf": "U2FsdGVkX1+EoOUllFXfI3+Bt7hJs9nD+41Nl7J+0/s="
}, {
    "num_cand": "U2FsdGVkX1+cEXS7H0Vz2Z681eSABuLUj88NKHhosYY=",
    "cpf": "U2FsdGVkX1+gFOUWEWwZDhTwDRzLBhCVnhBMm6XwklQ="
}, {
    "num_cand": "U2FsdGVkX1/TWcxp2c4HncuzBzVAFrDVTqIuXkaTMoA=",
    "cpf": "U2FsdGVkX1/mHqesraPFbwWotO3ZoidflGABi/hfsTA="
}, {
    "num_cand": "U2FsdGVkX19mqnFOQvFglMWOXwqr+XwnhNJj87wd45A=",
    "cpf": "U2FsdGVkX1941Ds00JlaxJUUeoF6yP0gWpeWzYtgLKg="
}, {
    "num_cand": "U2FsdGVkX1+VBJj1Lq2VcD1VfFgOydy0HG0rjDZ0u7w=",
    "cpf": "U2FsdGVkX195kxkm5BcXl9eEHshQ1UkHrccCrbqEuLE="
}, {
    "num_cand": "U2FsdGVkX1+wSbN0NhWClzErYWOq+P4ivl5giVp3BcM=",
    "cpf": "U2FsdGVkX1/oUeFCSCdbApse47NJ7b1EwGdhuQ6zylI="
}, {
    "num_cand": "U2FsdGVkX1+bPrQ4kGu9PlbOtfcKAmRHNpEWPoZwpoo=",
    "cpf": "U2FsdGVkX19mo+rue0tJaBLQXvvLVIO4Jlyy4R6918U="
}, {
    "num_cand": "U2FsdGVkX19XbWaD+Gk8O6web8SNInsGf2np6BkbbcI=",
    "cpf": "U2FsdGVkX18KGi4X0wt6wKMXoS+XD46iL4kKRhbI82Q="
}, {
    "num_cand": "U2FsdGVkX1/sz3y0CsN4uQ/1uVRKUQqMLGMKgYNq7uE=",
    "cpf": "U2FsdGVkX19UHRybNrppheqOeOqSAZBlUktnDkCszls="
}, {
    "num_cand": "U2FsdGVkX19J1VOEsdRSj5Qfvi6bmmVVMD15fSwaUIA=",
    "cpf": "U2FsdGVkX18FozjUQIspUtb9EOcESM2Q/cSAL1ADEZU="
}, {
    "num_cand": "U2FsdGVkX18pBB3jhE8cvt1nZPt6aKFc6q/cdI208PQ=",
    "cpf": "U2FsdGVkX198+6j/aQ7vNcLdRmBBZXwHlwfWW3oQMFs="
}, {
    "num_cand": "U2FsdGVkX19WgJXNLAE//07uzV4is1rLa15F71mrCMM=",
    "cpf": "U2FsdGVkX195nLeETC+FZutalUMvIQhDAtCQMVZP3Hw="
}, {
    "num_cand": "U2FsdGVkX1/Onby2M2pE2brSQzKnCcGoKTo3mxjlae8=",
    "cpf": "U2FsdGVkX18yLt8OFZJrwoOKu9CAHbzE+t74chp2F4U="
}, {
    "num_cand": "U2FsdGVkX1/kwCGzeJOEwnR4716IvEzm224PKPu7B0M=",
    "cpf": "U2FsdGVkX1+4cIYEEAmaZL8eHneLLBZSiZHWal8BF10="
}, {
    "num_cand": "U2FsdGVkX18x3gwZyRdoDar7XU53PgcPlxPhpKIejVI=",
    "cpf": "U2FsdGVkX1/sMU+AjXacfm5IToJJ1NPaTfvzM/+O3aU="
}, {
    "num_cand": "U2FsdGVkX19/yvCGFSV7J/QxcadXy3E5COrywXsrlB0=",
    "cpf": "U2FsdGVkX1+okGf5LQmT5/kZFsYFSFidcRXmruoJOBQ="
}, {
    "num_cand": "U2FsdGVkX195ae5ncs0JzQz5W80cbxh7fiGZwfQT8r8=",
    "cpf": "U2FsdGVkX185oCG3O+5TgcKfvkhiSqvK2pxH3PiI4R4="
}, {
    "num_cand": "U2FsdGVkX1+u7GVyQQpDDj37h7oI3SaIPU8fVQYwpFY=",
    "cpf": "U2FsdGVkX1/pHnb3FyYLc4yh/LGUgdTa15GrsS5JaKU="
}, {
    "num_cand": "U2FsdGVkX18b42dy2xJTg86o1IHY2S/Ki3pWV7TQlFM=",
    "cpf": "U2FsdGVkX1/xF0nk8xddBRPAA/5T9SRK4EbcNEP9wkk="
}, {
    "num_cand": "U2FsdGVkX1+ouDofP8kmP14t1vsiPSOfusP2RILG0rA=",
    "cpf": "U2FsdGVkX1/U2WBqKSSHvJbJs0SJSpMjRYNnEOisul4="
}, {
    "num_cand": "U2FsdGVkX1+MX3EPVVNI6vQp90bjcF6t54L13T8zevk=",
    "cpf": "U2FsdGVkX18qGfN+9ZdjMDFIoQFcEgMFdax3Ud7Gt5U="
}, {
    "num_cand": "U2FsdGVkX19GyIm++07gbRCtjOw6M62KwCeUBk9wzes=",
    "cpf": "U2FsdGVkX1/8gRT7d5VkRcX2HqKwnTVWRCkU8vdAtPE="
}, {
    "num_cand": "U2FsdGVkX19j2Z7TBMIAMuaa7XpIZfLF2gUjelSz2k8=",
    "cpf": "U2FsdGVkX18l8bIgHjzQwe8euUfdnP4CiI9zLyDiiHE="
}, {
    "num_cand": "U2FsdGVkX1+tAlqpEV59ilcE+D3fY9iP+2UVZoG2Bzw=",
    "cpf": "U2FsdGVkX1/zsvmEfFZART5A5IDXW6uwBe+YSooACV8="
}, {
    "num_cand": "U2FsdGVkX18X77MX+PDM8EbuRlgOblHr2k5psuJae/Q=",
    "cpf": "U2FsdGVkX18E1hNlRSMUDJrw5sXq9G9jlrAMB8LQIg8="
}, {
    "num_cand": "U2FsdGVkX1/Vd/KTEhZiaCEqpBUGhVhmS8EZArmGgTM=",
    "cpf": "U2FsdGVkX1+SuNX+K9bfoP/YF/mdknrJuQVFYWkmnQg="
}, {
    "num_cand": "U2FsdGVkX19EzWvgcDkDJqK7PLBK6uKyzVrjiHFy22M=",
    "cpf": "U2FsdGVkX1/k7N/fKNliEEISdbLt3eUFb9S7tJddp/w="
}, {
    "num_cand": "U2FsdGVkX19bWgrw5DBOHc/uxph38j9mKeAADROOa8M=",
    "cpf": "U2FsdGVkX1+ZVCeKuPlum14El5ZVQavQ7bqnjNXXwRA="
}, {
    "num_cand": "U2FsdGVkX18D15N2XSZaIBb60As3BVXCKWL2duMmlf0=",
    "cpf": "U2FsdGVkX1+qR8BkQyS+HCZVGEr0qyGZ8sj7D5qwwGs="
}, {
    "num_cand": "U2FsdGVkX195sQwfqunzcvD/2rz3VRG0IzXQ4wIXDew=",
    "cpf": "U2FsdGVkX1/g7K2VhuPhiBBynJQUJeudegVEwOUk85s="
}, {
    "num_cand": "U2FsdGVkX19UXfXReE+0Y0KORjX15B07fAQzDo8sUSw=",
    "cpf": "U2FsdGVkX198prOR9af8ubOgzIGbe1dI2mIpmu+qHyE="
}, {
    "num_cand": "U2FsdGVkX19cP3hMi4LRk3NzD1Lk7WWee1PgKthq/VM=",
    "cpf": "U2FsdGVkX19LNSK8qvX+6oWmFSDFNEGZBeCNwuU1yks="
}, {
    "num_cand": "U2FsdGVkX18FEqXDEU2ni1TbNoPRzDXVXHgvZf2/AC0=",
    "cpf": "U2FsdGVkX1/F3+KhVbCLuCQgfC2koshiGaKgvjTCT6M="
}, {
    "num_cand": "U2FsdGVkX19WAUbIQTMcisL0yQmUzpagc+gINatrasA=",
    "cpf": "U2FsdGVkX19x1nlisyMhAgiQZOgBk3XirN7KD/l1WGE="
}, {
    "num_cand": "U2FsdGVkX1/O36spoKvDQZkhhC62Iq8YcGgROakkI/4=",
    "cpf": "U2FsdGVkX19Fs/I1KqT2aepRLKAlG83E0KHjLH8znyw="
}, {
    "num_cand": "U2FsdGVkX1/cb8Tf7DPDSukm5PbJTYe5EtI0ZOu3sg0=",
    "cpf": "U2FsdGVkX18IgsLErXTWKDS0o0Ljg21J5fyIH9qajE4="
}, {
    "num_cand": "U2FsdGVkX1++Y6RJGCqY8tJ9viFBQyZJTXGYZ2QIHVs=",
    "cpf": "U2FsdGVkX1+gU4pNS8DZW9rG/nGSxSOsQMWhdN+Usnw="
}, {
    "num_cand": "U2FsdGVkX18OLWpB7ZfAvQSy30MlF9PlI/TllRnIeOU=",
    "cpf": "U2FsdGVkX1848LeVYL8wh27zEjlCcpGYb8qii04mU9M="
}, {
    "num_cand": "U2FsdGVkX197CSfSgCj1DgRQ7n++KbkFIVTk/PkD5C4=",
    "cpf": "U2FsdGVkX19PJeJQy5iIUlfkxehqcSV4M/FMBMCi52g="
}, {
    "num_cand": "U2FsdGVkX1+CApmyh59dIK7f8yIpiehY3F1d1sQ7I+I=",
    "cpf": "U2FsdGVkX1/QeTzAhChrXPSItDlRqm3xWgYWoONz+lk="
}, {
    "num_cand": "U2FsdGVkX19cOH/sdFENn34VjxBUVE45tMaqj//VTfg=",
    "cpf": "U2FsdGVkX1/wKL1gV6opaIu0tyFrme5kjclQ8tO5ieM="
}, {
    "num_cand": "U2FsdGVkX1+oWYfBUkygZ0lzuRiRY/7gaz8RuJXwhis=",
    "cpf": "U2FsdGVkX1+AdbFEXo4S7yk6VDfptycCUy7s7CnYIx8="
}, {
    "num_cand": "U2FsdGVkX18U6VqBTRGMCixBsZ6VqEKhqClf/yAt2xg=",
    "cpf": "U2FsdGVkX1/z4rCK5qOhug0F+xRTaqTY3yoZSI+7SP0="
}, {
    "num_cand": "U2FsdGVkX19bsNlxliXCuh9qAjDlNdDOI2QKsWUUYaY=",
    "cpf": "U2FsdGVkX1/f6FPBudh+xH4QIoljAtb9uD/uWr3p21w="
}, {
    "num_cand": "U2FsdGVkX1/VpekkBL1CPwsHnz0R82rU1FYaaaobdZ0=",
    "cpf": "U2FsdGVkX1/gVvQNYUC3QuDiaiIvwKmptV8k8xBCHgA="
}, {
    "num_cand": "U2FsdGVkX18R0ZkvoT4pgaNZ2M6boYNz0kQGSvT//7w=",
    "cpf": "U2FsdGVkX1+llgh6cbKYXmuItqmkmKKNtnYuXoVkUDI="
}, {
    "num_cand": "U2FsdGVkX18wf0p1WUe4olqG9FR6pbJROHwraAqR2f4=",
    "cpf": "U2FsdGVkX1/EtvUG2Xx7c923zKa9lmfoxfJoS6NGcwQ="
}, {
    "num_cand": "U2FsdGVkX19z10+d8Btk3XAXOq/1AXBF+YauvB/oq24=",
    "cpf": "U2FsdGVkX196BToVLRbz+d4AN0IiowzR9YTNd9oZgIc="
}, {
    "num_cand": "U2FsdGVkX19jjqhD6AMAEKSfhwLitfSP5qhU/Z+pAnQ=",
    "cpf": "U2FsdGVkX1+V7CuytO1bIFyW6pqlK7VL3boaEOfDJlM="
}, {
    "num_cand": "U2FsdGVkX18MpWQeQkdyDnpc4R/7DL002FSvGBchOUQ=",
    "cpf": "U2FsdGVkX1+lk14WkNq3OxA0wLb+sYkkyOSgi+k4Asc="
}, {
    "num_cand": "U2FsdGVkX18LMXPMw7DRhvjW1dX+MCcrFZuujcMrqZY=",
    "cpf": "U2FsdGVkX19CJFgE+Ula4tNWQm9B9XInb+fEqFbBr2I="
}, {
    "num_cand": "U2FsdGVkX1/0JWNUQ4b2YDBpMPQ0WFxR3sHRnxO/Gfs=",
    "cpf": "U2FsdGVkX19Ieldh1Dq6u0Cqeg0ZEnlhRw0OvzZ3P6Q="
}, {
    "num_cand": "U2FsdGVkX1+WklXj6Puw2MWEnMMQG70dP26WGIXhNy4=",
    "cpf": "U2FsdGVkX18PWwuSPWT+ki3zOoShyAZJ1DciLN5X0rA="
}, {
    "num_cand": "U2FsdGVkX1+x/C/APxksfHptoMphYRDlBOBMjvFQ3kE=",
    "cpf": "U2FsdGVkX18u7SghBDOUqfGnExe3Wmj0eujZbPz2bgU="
}, {
    "num_cand": "U2FsdGVkX1/wxZqWKJ/CoB9Xs2ehbv/zEyg6cQ69u6c=",
    "cpf": "U2FsdGVkX18paWmONJy2hfOx/ngeEGFOtlBYJ6qfD9Q="
}, {
    "num_cand": "U2FsdGVkX1/beWGLT8bEmoPYxI/HT7+Q8JcKP/esWEQ=",
    "cpf": "U2FsdGVkX1+OlczBE+qnSW6uvQyGu1zUhES2M6GT6KA="
}, {
    "num_cand": "U2FsdGVkX1/9F+VE9PIGqN5g4JgRLD3JbUYQQFR11rE=",
    "cpf": "U2FsdGVkX1/e/oR/4E+U5ryNzCteI6rm9ta8C5Phol0="
}, {
    "num_cand": "U2FsdGVkX1/IKUuKsE8HrfNEm7R8QsHrFVIbeiG5X/8=",
    "cpf": "U2FsdGVkX18HJ3RfcFaxE68E1lhjjdBLvKlXNBHkZbY="
}, {
    "num_cand": "U2FsdGVkX19qKMu+Ee19JbijqO4uKeqgbFd2JHBr14s=",
    "cpf": "U2FsdGVkX186gBI7pRjDbKoETGp7Hmit3pZ0/mQbnzc="
}, {
    "num_cand": "U2FsdGVkX1+RqLtJRjftIs3IkuybGRqqfEGRG4nz3PI=",
    "cpf": "U2FsdGVkX18Rw22ZxjCjDGb7QoABkABxwTQq0/neBx0="
}, {
    "num_cand": "U2FsdGVkX1+XyDpEsnu9DKmNYaBOgYC2Y+H/YS0nobk=",
    "cpf": "U2FsdGVkX1/CWIBhoTiiJX+ots8PrYFZ1shzd2cyyiw="
}, {
    "num_cand": "U2FsdGVkX19quf+MfWO5HIzpUsmeAb/sLTmxu3ndF3Q=",
    "cpf": "U2FsdGVkX1/uCVoBAntjQQA2PMCzqGLBxv+atBTkbXc="
}, {
    "num_cand": "U2FsdGVkX1/szoLz609398ABP/YPelviC/jDCxVbgY4=",
    "cpf": "U2FsdGVkX18mZyYNGXD8Uaqld+ze38PEygFZNmq4FiU="
}, {
    "num_cand": "U2FsdGVkX1+IOn/ovaA6Q5sntnyFbhvGttWOM2tbCFE=",
    "cpf": "U2FsdGVkX19cfNBDOXb3M4zVXrONUJ7P1HnZOqBo5tE="
}, {
    "num_cand": "U2FsdGVkX18XipXta7HTqjLOry3DTIfKqQiHPw5nIYg=",
    "cpf": "U2FsdGVkX1+OW244ZVyYqvZfm7ArQiT1ueuMRLyHNMo="
}, {
    "num_cand": "U2FsdGVkX19dnW13gWdl+u2BRih2L7W+inmw6cA9nGM=",
    "cpf": "U2FsdGVkX197t2uIKX+od593iE3Ho7vW6+tHfrd3pxE="
}, {
    "num_cand": "U2FsdGVkX1+KIHR7bAHnLyDnU5kJt67vy0cqGmCt6Zk=",
    "cpf": "U2FsdGVkX18vk81OJ2WL3++HTKbWMKfWzRz3TlbNx4A="
}, {
    "num_cand": "U2FsdGVkX19CVG2nzgseyEEeZIm5jITT65PYHh76txI=",
    "cpf": "U2FsdGVkX1/YgYkYMp8nd/eBZKo0/n+FdrzP9qBGRoQ="
}, {
    "num_cand": "U2FsdGVkX19dk0liziOwGDn4pqK+US6QlmOxGhhly5A=",
    "cpf": "U2FsdGVkX18lOb1lIS7Kq+jksSEDi2OZFEPZcMcYc9U="
}, {
    "num_cand": "U2FsdGVkX19s+9c/Fc53YtxT3PeiZIeAhKv0A1pQtSo=",
    "cpf": "U2FsdGVkX1/F388A9a3oVfLJR4Y7cl8PC5TFDlBLyMY="
}, {
    "num_cand": "U2FsdGVkX1+Y9dbcwmNpg4kDidbi93QzornKtbrR8LI=",
    "cpf": "U2FsdGVkX1+EUR4uaKBifN5FBn6fp2Wke8RZ4cJSrY4="
}, {
    "num_cand": "U2FsdGVkX1+jQItfBRQPpUw+Bea2NeHjcepgkZglcKo=",
    "cpf": "U2FsdGVkX18CGI9ik+JO6x43+vUDk8rOnZpC57omUQY="
}, {
    "num_cand": "U2FsdGVkX19grNTZvpdVQPV/G3WfEkmA32tUoVCiDmk=",
    "cpf": "U2FsdGVkX1+29jZoYq8yKSPpDZSSoOAzn3O6zgmVPTo="
}, {
    "num_cand": "U2FsdGVkX1+H8TUqNL5McxYPNVXkldlpNk2f6XzTss0=",
    "cpf": "U2FsdGVkX19uht0z0082UIX3GVmpmcItg4hG6wX7+M0="
}, {
    "num_cand": "U2FsdGVkX1/JVAHfpVxsnhj8oXYhCLXCx7CrZlWgLfk=",
    "cpf": "U2FsdGVkX1/GTz8RXKqZCoDAxVyS+WcGDOjHYPz7WRo="
}, {
    "num_cand": "U2FsdGVkX1+Qhh8uG3SFWl/b/YrpwtUOJfDdpQUYANs=",
    "cpf": "U2FsdGVkX18Xg4zso9Dszb3Wz6O6z4YoDbBNGfOmbk4="
}, {
    "num_cand": "U2FsdGVkX189pe9SufZuMp6yn2iR9uOumf6rNTQKqm0=",
    "cpf": "U2FsdGVkX1/M7K5/rKwNX6CoIuyEYVoQb08RjuYkWlQ="
}, {
    "num_cand": "U2FsdGVkX1+bxRrEb0AvU9AQVAxcqBmDgyxz6eOPG4o=",
    "cpf": "U2FsdGVkX18WG02ZrMmgLt4lYgAyFkGvr4oph/20N3A="
}, {
    "num_cand": "U2FsdGVkX1/vMgcTcmuhm8hkrKUBC/GVl2LgqPaIwTY=",
    "cpf": "U2FsdGVkX18ajc7d8kUEEOKtjGTh8hsFtQycYTKLauI="
}, {
    "num_cand": "U2FsdGVkX1/578Kv52XH1Qnb6pVQyvsyvtQiySq9oCU=",
    "cpf": "U2FsdGVkX18XoBWt/dd9zH1PWY76EtWvwENS1Z61RtY="
}, {
    "num_cand": "U2FsdGVkX1+itk+S1Hu/GIGA95dLByTXVs6lo3BuCic=",
    "cpf": "U2FsdGVkX19Wnh9CQBFUrLUb4oy+mdFh91bsBxF2wO0="
}, {
    "num_cand": "U2FsdGVkX18DcfrMADI/0PVD9tvEM4qUos1GFbCXR0A=",
    "cpf": "U2FsdGVkX194oADqoHOHeKmu2D4784mIgHMCHxI3CMQ="
}, {
    "num_cand": "U2FsdGVkX19svJ6LTACqIMZk2sQP08DobE5Kae70YUA=",
    "cpf": "U2FsdGVkX1/MAVqrCUTlrqbEbo88QqexYhCopy/LUIA="
}, {
    "num_cand": "U2FsdGVkX18QR0FwSnwXYnX/+METe4OCG44zNVsIpKA=",
    "cpf": "U2FsdGVkX1+hOPYG416yyoA9TxIIlG1o4oKKNh6tlsk="
}, {
    "num_cand": "U2FsdGVkX19rj55/KpVYO3TpI2xmtzq0GTPgSVsPXF0=",
    "cpf": "U2FsdGVkX1/lNASsUE95eC0K8rVyKn5HYPjjsFZnsr0="
}, {
    "num_cand": "U2FsdGVkX19Rsu58PZ7wE4p/vHHbOqd9YcbUoCFUff8=",
    "cpf": "U2FsdGVkX18TiWS8UB0F/Bq0jdgSAeaOXiZfB+dlkQ4="
}, {
    "num_cand": "U2FsdGVkX18nYpUJB9g9lh0ccAS+O3uQAgBQ9gBbCfk=",
    "cpf": "U2FsdGVkX1/u4n+UsP7nwEG9iOuuBzZclnk3KMs2L5Y="
}, {
    "num_cand": "U2FsdGVkX1+Ugb2t1X+uAsh0FIoCPDcdWjRKBTj1feo=",
    "cpf": "U2FsdGVkX1+HfNMfL4cYmHl/xGJB8T/Oi1DJcRGMDac="
}, {
    "num_cand": "U2FsdGVkX1+Gs1F9lLGhEKLmCrU0b0Ilf0iqESLmwk8=",
    "cpf": "U2FsdGVkX19nR5uDArfNO2ZkpJngvXsi/u5XQeDz2v0="
}, {
    "num_cand": "U2FsdGVkX19ypnqqWY2AmAN4iyBeoJItrV+qmuuNt1w=",
    "cpf": "U2FsdGVkX18QwTXICJC+ePVEdeHBZZ+zcqu8lPy4b3U="
}, {
    "num_cand": "U2FsdGVkX19BWCZ4le21AjHy0M+8j4YiNWPPljoSIN0=",
    "cpf": "U2FsdGVkX1/NEyKEbl4teWkfguVIC0uMtfWqu0F43Yk="
}, {
    "num_cand": "U2FsdGVkX18eEaHSvhkMg6RSGsyyXOXngR2ZuuvlrBs=",
    "cpf": "U2FsdGVkX19jRe0QdIoETResugajvfPAD2vi1h0lNqw="
}, {
    "num_cand": "U2FsdGVkX1/1x+TigoC9qyx52Mt5FatZPQ7r3F3E9dA=",
    "cpf": "U2FsdGVkX1/1230Zbd1uWrwASaIALGSiFZ/9Ls2fzbY="
}, {
    "num_cand": "U2FsdGVkX18NE2HcdkSUwbT+n24WCBr2HFYBf5xuayU=",
    "cpf": "U2FsdGVkX1/bNA6J/KVs8KRx3Hiq8j+08OeE65a8M7o="
}, {
    "num_cand": "U2FsdGVkX1+14jtgzjLZmdvqK3z63muvxNn/6JpiENs=",
    "cpf": "U2FsdGVkX18uzN834Yef4IYHSCkGSH0dahGDFWjY7Q8="
}, {
    "num_cand": "U2FsdGVkX1/IMLZX2J69LkmTz8VVZAxOjXpDA04usWo=",
    "cpf": "U2FsdGVkX19+ctq21lSH8wUMEiPdTVB+94mBFbNk7Cw="
}, {
    "num_cand": "U2FsdGVkX197BtIaV/+me85NOf52zot2gqqxjVCrOGU=",
    "cpf": "U2FsdGVkX19Z8kvtSrermoLDVVmQa3MmumgvxQrz9rI="
}, {
    "num_cand": "U2FsdGVkX19uU2W8XT8u/I5bxpnPS49Sb8QhwfFecng=",
    "cpf": "U2FsdGVkX1/KKUrGzo4Y4J73St2QPvLqHHnCbWaw3t0="
}, {
    "num_cand": "U2FsdGVkX1+UsJ5xr1uGwkrD30EPCOlrpUplrSD+J1E=",
    "cpf": "U2FsdGVkX1+mM3Joxn5CVnC8g+VOU1WX+oFrap2bylQ="
}, {
    "num_cand": "U2FsdGVkX18ZjKpl5EfigervVzwBL/Wx93R8wZTsMdc=",
    "cpf": "U2FsdGVkX1/UK+etiupfsAz/9M1OaXwlYteqp6VIW+0="
}, {
    "num_cand": "U2FsdGVkX1/la2c87BwOFlkkQKUUTaYRn5Jkw02ecVA=",
    "cpf": "U2FsdGVkX18lcI+/YYRU/JkptqudIjkAW1SyPAInN10="
}, {
    "num_cand": "U2FsdGVkX193syHjC2xRgiqkYyid/9eSOrGdTXLiPAI=",
    "cpf": "U2FsdGVkX1+9/SN0CCFExu6FZ0xH5dYX3qMb3s/znPE="
}, {
    "num_cand": "U2FsdGVkX19OhZRVI7JqGKnaRTCh6erbBb5kaHE++YU=",
    "cpf": "U2FsdGVkX19CisQd6H+lIYn5AC1FQ2h2idmX8gJAVPQ="
}, {
    "num_cand": "U2FsdGVkX1+gui+Tcnc6EG5Cjovr/GM06GrBgw5UV/8=",
    "cpf": "U2FsdGVkX1+fFzJxxCsrhOBnGMhH8Kct/4vD3dtHEls="
}, {
    "num_cand": "U2FsdGVkX18J17+zmGbdtcGJZOY7YR8iRKCxEadoyxE=",
    "cpf": "U2FsdGVkX1+kv03eujrRnst4mRzs/joBxpoovFuImAM="
}, {
    "num_cand": "U2FsdGVkX18vA169IUlTrq9tCI4TFaAyrHbPsEbe038=",
    "cpf": "U2FsdGVkX1/6+hKq7rv/kMVNoael52UnseojKpApHEk="
}, {
    "num_cand": "U2FsdGVkX19qcGqbLs9kUsdvx05/2QffIH5J2CA4gRk=",
    "cpf": "U2FsdGVkX1++9Wr2aoNdWR1QDc8ndYkuv/c6mj2NAVc="
}, {
    "num_cand": "U2FsdGVkX19JwKOXAhd+yUPBnm/ALTOsJ95CFA9OqIg=",
    "cpf": "U2FsdGVkX1/Gs6Nj00ATkWD8CXcA5esaCLVQmcwvNw0="
}, {
    "num_cand": "U2FsdGVkX19heCQ/QijvRJ6PD7h/UFWxxSELP3bDw9I=",
    "cpf": "U2FsdGVkX18+V5Tqpoim0K5gPegZUhD+ajmuXC70LG8="
}, {
    "num_cand": "U2FsdGVkX19ExZjlQ6vn5MCqPDBOlMXJoZbHmkzjOSk=",
    "cpf": "U2FsdGVkX1/sDi8sRcTFjzfeAl1P6B+zmMHeTvChCw4="
}, {
    "num_cand": "U2FsdGVkX1/Hpgb+DXfF2t8L7K9J1wVDQ7l2g99nZ8M=",
    "cpf": "U2FsdGVkX1+UgaCxG82jkGWqo9c8ALBwL877c00HkfY="
}, {
    "num_cand": "U2FsdGVkX18/O3w7S8Z2VyNa4AQx/l++9j4vFF+Wa0g=",
    "cpf": "U2FsdGVkX1+Sg40gWiEsmP41h84zD8jDqddCLYA7ij0="
}, {
    "num_cand": "U2FsdGVkX1+bmmuvq01XvNN0SqekYm2Bf00PmV6ArYw=",
    "cpf": "U2FsdGVkX1+VYnZY6rnY1pejcRg3is6zWGcUGBM1CBs="
}, {
    "num_cand": "U2FsdGVkX1/DaKt5T6b+eyoDeKYJLOWVhlmcZZkp3Dk=",
    "cpf": "U2FsdGVkX1/CAd/FscS4RrFoLXzPoU3PYby87B+uoRI="
}, {
    "num_cand": "U2FsdGVkX18X9g1TKl8/8tH3w7oRERwrAEwPNnFcs2w=",
    "cpf": "U2FsdGVkX1/BLdslwzOAEOMKpLBPjUltlEWzDpoCIfE="
}, {
    "num_cand": "U2FsdGVkX1/DWZe7p0mzb9tEwfW4NrC5k9iRKEOY7KI=",
    "cpf": "U2FsdGVkX19H5rilsKbxFcalwoOVSYXxAF4DMCjzsbo="
}, {
    "num_cand": "U2FsdGVkX192oKyUsTpXmQ9VOY6x7CeTo1qsNdC5qw4=",
    "cpf": "U2FsdGVkX18Juy1/ONQ1hCrQK689wa2lIj5cT39JXNM="
}, {
    "num_cand": "U2FsdGVkX19ScEzVxHuTPhF5K8zD+q0VtSu9ZC+qD7M=",
    "cpf": "U2FsdGVkX1/sjJjrpIhi3ZbpuYjEH1boXulrD21S5uo="
}, {
    "num_cand": "U2FsdGVkX19c2qJULOoPDkQS1l2iiSIEvOmc8TckIVY=",
    "cpf": "U2FsdGVkX1/aoocQBl0ngCBFM75vc92yHuUt0l6uz8Q="
}, {
    "num_cand": "U2FsdGVkX18Z7x2zfnXmOMZH5CowX0RsSPbLVjLjq3E=",
    "cpf": "U2FsdGVkX1+mNozGYqp3uhIw3t3vOi3P09RtRCB/I10="
}, {
    "num_cand": "U2FsdGVkX1+edlhhmV5N1sGhyKO7NHYZwC4B4P8AFvE=",
    "cpf": "U2FsdGVkX1/nb98CNpZZwhLfOJkGWyhCcYWUMR6/AFE="
}, {
    "num_cand": "U2FsdGVkX1+S988VR+Suoam6ZHom0BzFlNPaJkB6Mig=",
    "cpf": "U2FsdGVkX1+2ba1yYVWz3I1rIhLzik+JqjFKtfv1l74="
}, {
    "num_cand": "U2FsdGVkX18A4WTSxj+z6Xu+0Zk7gLwLiWVB25ERmCU=",
    "cpf": "U2FsdGVkX1/LyTkeXRFON3NesnoL07tK+NSp4FpT7Ao="
}, {
    "num_cand": "U2FsdGVkX18hjc5N43O+0KskojUaT9jc87UjN/TsaZ0=",
    "cpf": "U2FsdGVkX1/ikmyT8DFhgcMjmeqhfMDydT0AEQGml0o="
}, {
    "num_cand": "U2FsdGVkX18SViz6crekudRcRoXkYRkn/qTfeK9Afhs=",
    "cpf": "U2FsdGVkX1/wCuSHtyKE3YaFz7pqeVJeo6Hp3IFA7bk="
}, {
    "num_cand": "U2FsdGVkX18VtM1KpiqSjQcCKdyFq+12q+yHpf5b3Yg=",
    "cpf": "U2FsdGVkX1+PMLb4aENJXNGq28jdEf7aThg3DD4NmmI="
}, {
    "num_cand": "U2FsdGVkX1+rjPtJ9+HqQdgZ/ateYHsbCbX8iSdIlFk=",
    "cpf": "U2FsdGVkX1+yOJQocElV8Ru9QKhTkQC0xChHtBQBy4g="
}, {
    "num_cand": "U2FsdGVkX1+TmgaDa6YDguz3xdUtg0NjTnM55oZYWUo=",
    "cpf": "U2FsdGVkX18vpYIGPNSFAl8WStt72fuHwXB9F+xRAXA="
}, {
    "num_cand": "U2FsdGVkX18/Pyc0/2pFdvASZvcfCqY+rjcgvbKOev8=",
    "cpf": "U2FsdGVkX19/PX8/bFUoGo483r4QkjasyiNthLu/oZA="
}, {
    "num_cand": "U2FsdGVkX1/Ap8LBhfdWA7cUgvdMAfxHPn0iqabmkuE=",
    "cpf": "U2FsdGVkX18BFxitajrxkB3lbsXzkDeYlSVSk+E4Ud4="
}, {
    "num_cand": "U2FsdGVkX18Pac4cLP60IC/NM/A1asCgEUT+DQuDVV8=",
    "cpf": "U2FsdGVkX1/aXo3b57e0a1SP4lR1eJ0iwiLKsrrKWUc="
}, {
    "num_cand": "U2FsdGVkX1/lfpmA340dOQ4XtA4AUmZPHdAQJr7iEuY=",
    "cpf": "U2FsdGVkX1+FDC1gaDKhfJ0tVO/z2eaB4SG+EGjralI="
}, {
    "num_cand": "U2FsdGVkX19RhWbRNpmpYmD214waP5bfIkCz0t9VYPE=",
    "cpf": "U2FsdGVkX18nvRqkSw14tU4hCPa513xVfzDktzy3RRY="
}, {
    "num_cand": "U2FsdGVkX19NmQYmcRvi1lDwmlBdBEUUiP5nrOAC7DM=",
    "cpf": "U2FsdGVkX1+UQADYh3masl63JbvF2+CYIeEbfO2rcOY="
}, {
    "num_cand": "U2FsdGVkX1+mVchwPqsqcxiNwKCAzrlyXIAeJ8Cd7PY=",
    "cpf": "U2FsdGVkX18WFIvDEcrcl8xjQxGDC6IIF5pyOEkG1QQ="
}, {
    "num_cand": "U2FsdGVkX188+/1c7aN6V4Tf9AWY+NRSIZT9NqV0KrA=",
    "cpf": "U2FsdGVkX1/hjqT3rGEcZPuB/f/CWdekN+41Q+Cn8S0="
}, {
    "num_cand": "U2FsdGVkX19R0TssYiiuCElqDimZITjjRCOZ7V/HhG0=",
    "cpf": "U2FsdGVkX1+3767HqzQdgcmLNr4TuX6i651gOZcWJgA="
}, {
    "num_cand": "U2FsdGVkX181Jl5bTiKRUw9fuMlKmWqDneLKbhIp/1w=",
    "cpf": "U2FsdGVkX18y2meKIbpl2u00GO03rvlK3ZQKN8pHUKw="
}, {
    "num_cand": "U2FsdGVkX192jpJM5zfiJGlqmNfxS4o/jfnFFbHzNGs=",
    "cpf": "U2FsdGVkX1+C127PhDE0GHWuXy9vVTvnYaM3vjwb+Oc="
}, {
    "num_cand": "U2FsdGVkX19iEWjb+qtPfzT4XT0UZYnzOdDJlqqwBHo=",
    "cpf": "U2FsdGVkX1/SIdHHjc0Ab7wC5msYFKXrhq64VNC1zxo="
}, {
    "num_cand": "U2FsdGVkX19XpNSU8klyDbBxZKW7lrah3q2GKMsMZkg=",
    "cpf": "U2FsdGVkX1+uNEE3OErXzeFi5lhrYpiG93eeGuDn6/8="
}, {
    "num_cand": "U2FsdGVkX18mB6lrgstGw6KTJYsXXbxoJKn19DTLpxA=",
    "cpf": "U2FsdGVkX193eHPZR4Sh3zxc+yLVmjZTC1L1/o+md0Y="
}, {
    "num_cand": "U2FsdGVkX18kTmetqDOF2x3cptruDsdG58t3MIEHfCM=",
    "cpf": "U2FsdGVkX192gMFm/IOHN3f4T+ndJNmvRgoMfkCF+TU="
}, {
    "num_cand": "U2FsdGVkX1/1YmagMKUCFFllwm/wbNaUQlqrRmzGNcw=",
    "cpf": "U2FsdGVkX18/umE+/ULO7Xof+NXsOKiz4ur3XoZXBZA="
}, {
    "num_cand": "U2FsdGVkX1+bkwPuz2AMJ1WKdmOzHbOLiygmbtztuEU=",
    "cpf": "U2FsdGVkX1/oGwbz9iSxpR8b5ySUw7PdYKBJDRlf9Dk="
}, {
    "num_cand": "U2FsdGVkX19j1mrdoKhhsg+WMO6rwPGzFw8ee8OZde8=",
    "cpf": "U2FsdGVkX19nnwNVZGfAUySkMZtAelcyi/rp4Yjmv24="
}, {
    "num_cand": "U2FsdGVkX1/WT3PIveTLFK++d2dW+bY2SolV4sSIDGY=",
    "cpf": "U2FsdGVkX18BlFe9tdshDfr12nfpTMTPxTkEzHjPpVU="
}, {
    "num_cand": "U2FsdGVkX19iootJlcu+qu9na/OpTexTEhNfW30j7eY=",
    "cpf": "U2FsdGVkX1+7ij81gg0Q5ZIVlr0ilutvtsKXx85Kl9k="
}, {
    "num_cand": "U2FsdGVkX1+x4gJgzctyVFbE53tc9eTnrAd1sUjMQvE=",
    "cpf": "U2FsdGVkX1/rwyplwgY7MqZC6vFt5WbKX8uXSbiLXP8="
}, {
    "num_cand": "U2FsdGVkX183F7s+Udlv5gMy2MzO0CTLQ3B3jF2kIt8=",
    "cpf": "U2FsdGVkX1/PXvMK8pToUhq0TuQoGSvsCqKhnQ/fSoM="
}, {
    "num_cand": "U2FsdGVkX1/jjIwvxhUmXKYj5pz8HN5ulhCW9yYkfD0=",
    "cpf": "U2FsdGVkX1+6IWz8zC1LmJR7Hi/TdXcBXG4cRZMcaiI="
}, {
    "num_cand": "U2FsdGVkX18ZYttQls8A+mOhfqEfSSf2X42AHtqXwTM=",
    "cpf": "U2FsdGVkX19EyQV/iuWgk1PYLCmPBAaFf5ndqucWD3Y="
}, {
    "num_cand": "U2FsdGVkX182oRFsSDL3I4dWyVRgmwDe5D8F3G5FnEU=",
    "cpf": "U2FsdGVkX19ORJU9Q2ZSfocV2Dx43Zre3CkzHIt0J/Y="
}, {
    "num_cand": "U2FsdGVkX1+h8DUAlQpB5ej2/vRrE7pdtu7dyhj1nNg=",
    "cpf": "U2FsdGVkX18HZ95LWjrCIAaWs9MNIxIjADRqlCDe0Ww="
}, {
    "num_cand": "U2FsdGVkX19COYNjWlB8v0Vbp0BgG8upWpvIKI3AqtQ=",
    "cpf": "U2FsdGVkX1+Z8m9ZXuKscD1Sljras8PMJFik46KCheg="
}, {
    "num_cand": "U2FsdGVkX18lHhDbFq4vDe3v5cv9McxW7z2r6DmutB8=",
    "cpf": "U2FsdGVkX187wyUMrljpyEoz17WIk1dNqd4/py9Dt7A="
}, {
    "num_cand": "U2FsdGVkX1+x1VeYFkQgA00djLApj8ikNKcQH8U1qPM=",
    "cpf": "U2FsdGVkX19aRVxy/E8xUoI9xn0xHEeTZJyMR39bp+0="
}, {
    "num_cand": "U2FsdGVkX19Ad8i7lbiAUi3Tmm+/mPChKCqgQkZIkB8=",
    "cpf": "U2FsdGVkX18KMX0H64whQHqcb+A2wRHqs0O93V1YAo4="
}, {
    "num_cand": "U2FsdGVkX18fudG0hSVRGGXa0GtUqMYfpmTjW+47y8M=",
    "cpf": "U2FsdGVkX1/w+JinmNfZRz8tJKT3K9aPdK5X7B1KVC4="
}, {
    "num_cand": "U2FsdGVkX18uI87gpcJHwz9rfiI8QL9dvV2pUrGmbtE=",
    "cpf": "U2FsdGVkX19zA7zFKmRCEZMStDoijdZXObXc8ywImls="
}, {
    "num_cand": "U2FsdGVkX19yud0w9uwt0FuCerG5uQZ8llGZ11M5KGA=",
    "cpf": "U2FsdGVkX1+cMS4g4uWYx8EcJRbUAIHT12gvD4WHgQU="
}, {
    "num_cand": "U2FsdGVkX18iv6KqTyXwE3749ebL6LanaJHoi3Cq5qQ=",
    "cpf": "U2FsdGVkX1+nDJx2XcaBEQyTXIfW1pj5qHlHEvSK8Bg="
}, {
    "num_cand": "U2FsdGVkX18YIK9iXM6CG9CYKRU7uplt/pxgmGBWvD4=",
    "cpf": "U2FsdGVkX18EtAgPxASRtWaiDGkrf1vsUaggR34DiTk="
}, {
    "num_cand": "U2FsdGVkX1/0T6FlXOydoiCWwv248UuAeRsGY1pXz6w=",
    "cpf": "U2FsdGVkX1+f63e55n3AJva13SB9/MDyJgBjB1zPQ9A="
}, {
    "num_cand": "U2FsdGVkX19rrJ1woOGGp+1Y0vKnGxcoe/EfBFpxZRU=",
    "cpf": "U2FsdGVkX1/VCylyjHvXEG0abTAg9AxUob0dcoWAZkY="
}, {
    "num_cand": "U2FsdGVkX1+MZUWnCoEUqtQI64xaUX3t5H/ogT6AjvU=",
    "cpf": "U2FsdGVkX19Anrce/QHtUS1zAqscNwCDHsaRYgYMzAE="
}, {
    "num_cand": "U2FsdGVkX19PXTzRHN13bukfyInJdKxCvlFQgm5UZNQ=",
    "cpf": "U2FsdGVkX19Mg93j5W2Khq7fZpS3IVyP93ZJKIY4nX4="
}, {
    "num_cand": "U2FsdGVkX1/6PHIliXrgJp5mxOgDSK+HFy4nlt87hqM=",
    "cpf": "U2FsdGVkX1/kZGraHdFXJnL7w+54VSn9mkhPOjLMVXk="
}, {
    "num_cand": "U2FsdGVkX18J99lwMzToiqM6b82SF5aYxpZvBfyxJpw=",
    "cpf": "U2FsdGVkX1+ZtT2/sxZZ5H88XpjfJCLUm5/bP1HBpJw="
}, {
    "num_cand": "U2FsdGVkX1+78BLgrBi10VtXnxFdXU97Ff8d87SQGTo=",
    "cpf": "U2FsdGVkX1/88DuBOQnQhGKwdG/KCuhMC66g3o9SsKc="
}, {
    "num_cand": "U2FsdGVkX19R6HrHA9TBIZYbl0o84majKUzc0Ckvowo=",
    "cpf": "U2FsdGVkX1/cZcZbRY687yhntdCRFu27Ei1o3R2QXuQ="
}, {
    "num_cand": "U2FsdGVkX191W2OrsGhXI0knrK7Jq4Rj8mDs78GRJCQ=",
    "cpf": "U2FsdGVkX19s6Yj9pQ/5n6m9QEBghWqCV6nQE2P1LF8="
}, {
    "num_cand": "U2FsdGVkX1/RlLR0w1ixGILAGb8elcrV33vt0YMrzVo=",
    "cpf": "U2FsdGVkX180nzJ46qO3WMwiuY0aVUooq8ulMLMo6Fg="
}, {
    "num_cand": "U2FsdGVkX1/AWIEwsfTGRt+EBq59bfzh8gXbN7IRURs=",
    "cpf": "U2FsdGVkX1+5h/jK7Cv8sFWM9OIRiZiftVVul2mrD9Y="
}, {
    "num_cand": "U2FsdGVkX199jtHfneGzCr9HO9iH94IduO6lL1hha4M=",
    "cpf": "U2FsdGVkX185s1AOz9ZxoCjJs5d3hazJVVQ/zAcBNtQ="
}, {
    "num_cand": "U2FsdGVkX1/t8ZL/ki/vsTau0As7e+Zy7BviZKJS1x8=",
    "cpf": "U2FsdGVkX181R63PCRYOCRwS2TJTuS3tFoAkxFEY54Y="
}, {
    "num_cand": "U2FsdGVkX18wLYk+fa0SjOVlXPxTV9tCzv+/bbGO3Ak=",
    "cpf": "U2FsdGVkX19MMPiGr3bSGj6+d6/+qnj5+vskdJYyIfA="
}, {
    "num_cand": "U2FsdGVkX18348cK1X0kB/bly5VL132HNUHfSmhapoc=",
    "cpf": "U2FsdGVkX1/h8aOa8+0PAO4uZ9YrHGlZf/s8XySBC9g="
}, {
    "num_cand": "U2FsdGVkX19ocd/N5ozFXVIzvPk1dP+dVP6ueD9A5Tg=",
    "cpf": "U2FsdGVkX1/jBql58ZIaXMZbVL/UE3Ld9scMGIm3/Ks="
}, {
    "num_cand": "U2FsdGVkX1+qQkvjYLcBBfT19XSwQ4w+VSwiwKA+jV0=",
    "cpf": "U2FsdGVkX1+SnUz5/MDVs7z5I8Y16jopI4h3jFfBN74="
}, {
    "num_cand": "U2FsdGVkX19tLvseGjwT/A+2kcqfF28Hp9aIKtwluiI=",
    "cpf": "U2FsdGVkX1+b/Un40qlQWmwp5XYMKvFtvqz6qNOkRz4="
}, {
    "num_cand": "U2FsdGVkX18gXAytmNnLX1XdgDKKjDtttol86Kkvtik=",
    "cpf": "U2FsdGVkX1/FePXOUOvvGS7noq6AECF6UmEs5syqa5E="
}, {
    "num_cand": "U2FsdGVkX1/7t6cCsSBVKMFCfeDqCvMoz0tlyqQFi4o=",
    "cpf": "U2FsdGVkX19/P49JeP6L0MYti3gmsr16PeMu8n2ArRQ="
}, {
    "num_cand": "U2FsdGVkX18liLaj6cP5ILseDumm4CWbm3vz6xP8iSE=",
    "cpf": "U2FsdGVkX19h/LGWBtJY0aAZ1WSAY2e2/dsNVZrW7jM="
}, {
    "num_cand": "U2FsdGVkX19OSkFZ0fdWXlrEPP0ebCE3e4+ZQ2d9T6k=",
    "cpf": "U2FsdGVkX18kW6NGMI3fzYqoawwaUTB7Vsnupa4QLVs="
}, {
    "num_cand": "U2FsdGVkX19e9q8YKyZoukcMPgMlalEFIvfoP4eT7mE=",
    "cpf": "U2FsdGVkX18FYHrfzqgtRFYXfJ0muDLNL7yf7grKGcs="
}, {
    "num_cand": "U2FsdGVkX1/gVOzKZoEhEvp53GPxBIwXP1julBcriaw=",
    "cpf": "U2FsdGVkX19jOolbv3vwCacQLZZLob05P0u+uEpKdjg="
}, {
    "num_cand": "U2FsdGVkX1/BmNz9GAdLg3jYA3I6QWX8getrSd0TCaA=",
    "cpf": "U2FsdGVkX1/1gIV50fygOoWXgcaRq6kICpzmQ3rhqJQ="
}, {
    "num_cand": "U2FsdGVkX18Rlp3oc3wc7SuL5ZoAXgjbalIVE7tfJbU=",
    "cpf": "U2FsdGVkX188U3ITS/QcH9jIdL2oO5a734YUw/R63/8="
}, {
    "num_cand": "U2FsdGVkX19kh9Ynj8ILO56I/kZ5bS8aKtDU6YgCdyg=",
    "cpf": "U2FsdGVkX19R6JijxfvkapFneqx3vZvkYd1M8UPNX+U="
}, {
    "num_cand": "U2FsdGVkX1+vWIrsobMAN+HB6XzBJjWD0NCK/8aLzwo=",
    "cpf": "U2FsdGVkX1/7l3Gb3LIDtEfAKdDed66hoLpTGPXrTY0="
}, {
    "num_cand": "U2FsdGVkX1/rH3zR6ZooVZVIdxmPpongeRC3+YsOTyw=",
    "cpf": "U2FsdGVkX184SO1Zh4aPyE2uBAswAujnvGFR8HNOvQo="
}, {
    "num_cand": "U2FsdGVkX1+1UJC1U9+lujstJUzmtFNLiI7rtd7x654=",
    "cpf": "U2FsdGVkX1+k2gSir0K9UYEAxZoZi5VpnFd/wo0jq8I="
}, {
    "num_cand": "U2FsdGVkX18BeTTkLqVs14wk13wSyZcxq9pl4TIQeMc=",
    "cpf": "U2FsdGVkX19vxZnpOMXt1vyJ5YNODip7sjI+sJrAMrs="
}, {
    "num_cand": "U2FsdGVkX187V3rdflvMsLOQa9lfZKAH+iwpNzPFH1E=",
    "cpf": "U2FsdGVkX1+61q7EULTS2fDzy5iDDhl2wQDIlyS3+PQ="
}, {
    "num_cand": "U2FsdGVkX18bjMCy19pruA+1TWBFGHX/7iAgtb1Nvmw=",
    "cpf": "U2FsdGVkX1+2vqVreobanxpROMmDKCVZtzUW0EVRD9w="
}, {
    "num_cand": "U2FsdGVkX1+QELQxqNbRo87INKbbSmCBkaeOAVoNLWc=",
    "cpf": "U2FsdGVkX18VeLpH59/HzV4nIvK2omz5KgdOfLfiWwM="
}, {
    "num_cand": "U2FsdGVkX1/I1UzFytyBcusydqlU6xL36uEQ0oCvrRc=",
    "cpf": "U2FsdGVkX1+2NsKmHx4DXVH+BP4U/YHI0TDbNMNROeE="
}, {
    "num_cand": "U2FsdGVkX1+ixC5neO8Q7SLdPIZZdK++3jBV7F8GFz8=",
    "cpf": "U2FsdGVkX1+9AUBMcomaWq/AmXMJhzHgo7EixAFk60s="
}, {
    "num_cand": "U2FsdGVkX1+4TfNX8v7aRemlX/TT4a8Nn9x2UEdHmbg=",
    "cpf": "U2FsdGVkX1+qjuOwdfWkwKyAE+O9niKpSpA69ZXi8jM="
}, {
    "num_cand": "U2FsdGVkX19NDm4qIy0wgMhAqLPRKbkOLDjekraniIs=",
    "cpf": "U2FsdGVkX1/HfaP0YjSwdYjS5oQvHrJFNmbuBVJr2fk="
}, {
    "num_cand": "U2FsdGVkX1/CzYNW4tQ2QEQ8L+w2VccS5K/lVgtB4v4=",
    "cpf": "U2FsdGVkX18nF+SfjNyBybL9SPXo/SmVIGRDCOpK+T8="
}, {
    "num_cand": "U2FsdGVkX1/SPXa0RZAXlaB4fOZGs2ckA8J7QOeP0bo=",
    "cpf": "U2FsdGVkX18Tvv4lEIx9KxCsQtesWj1OyD5yWnuWOBk="
}, {
    "num_cand": "U2FsdGVkX1/q1hDUl1S5Uj4SjvgzaLSioc8QoKTTphc=",
    "cpf": "U2FsdGVkX1+OMSwpkcfjWVdAUvBpdZDB2052PES7Plo="
}, {
    "num_cand": "U2FsdGVkX18d2UC34vtuAsFKQwOVPtNgVCeTKyTP63o=",
    "cpf": "U2FsdGVkX19GTQdD72E2+zJH+wP2/Zv2MxkKnGZtImg="
}, {
    "num_cand": "U2FsdGVkX18NHKINe9CjqEKzRVADwtsPeSO9XjiC5Dw=",
    "cpf": "U2FsdGVkX1/4wUmN5LbKOi4EuDOhTbcExWXI87FH3lQ="
}, {
    "num_cand": "U2FsdGVkX18AvJomnLvND0wwRU0g3/qz2pKzA0EvSCc=",
    "cpf": "U2FsdGVkX1+xEIencV96CYk+MmTnPfbzG/VkLFTtQMU="
}, {
    "num_cand": "U2FsdGVkX1/8ErwRnjegrlqHjiiM12vwIY5IgCFUbrA=",
    "cpf": "U2FsdGVkX1/9bTxdab6H+9OjVzHAh/wmV3KLrkdibNI="
}, {
    "num_cand": "U2FsdGVkX1+rPPQ3QfGknCI3NxcUbd0OqziZSVStubc=",
    "cpf": "U2FsdGVkX18v5Hr12Osg0UrtgA+B9AUmmt+Koif5dV8="
}, {
    "num_cand": "U2FsdGVkX1/1KfW1NntdkvEW1n6lTigXrVRmVhCPwr0=",
    "cpf": "U2FsdGVkX1+sMbMBW5H6NiWksh3Sa3lo0nvgcUDAwVY="
}, {
    "num_cand": "U2FsdGVkX18s7NggGwIdQXe5xUVCGlij2bI6cbRKaD0=",
    "cpf": "U2FsdGVkX1+RShMFH52sqPQZRZO/x1c5U4n4gGDEN5s="
}, {
    "num_cand": "U2FsdGVkX18E8ewJ+HW1Wpvzq0baRH5ckevwmmBruGo=",
    "cpf": "U2FsdGVkX1/sEnIAv6082N8RPJWmDZK66hn4RjiYG2A="
}, {
    "num_cand": "U2FsdGVkX1/jAZ3MvimWM1Klm+2cqN9kXs0d0GqCG5w=",
    "cpf": "U2FsdGVkX1/CRSTYa77qJnUXq0m9pz+KCkBioJt/RhM="
}, {
    "num_cand": "U2FsdGVkX1/99aC6HhVpBohx0ULI4VIM+0JijsMuEgQ=",
    "cpf": "U2FsdGVkX19cqfsz5/I/x7+Lc+DYra9D3iO8TB09QU0="
}, {
    "num_cand": "U2FsdGVkX18ABZ+kBWMtbzbu4w/XP0QlTJLZujeCopM=",
    "cpf": "U2FsdGVkX1+K0Qh/Q684TBCHUIh6xv7f4ibW0r9el8w="
}, {
    "num_cand": "U2FsdGVkX19WcG4kabTlpm5IFsvGYfTFo/WMas+H9Zc=",
    "cpf": "U2FsdGVkX19HeYmxzrkl/YeVCh7TVhs2/h/Kj6avXRY="
}, {
    "num_cand": "U2FsdGVkX18GWKha4a4b9tl1AvBVpCWFHcTKSWy79Vc=",
    "cpf": "U2FsdGVkX19ugFfZG22H09wmnVfTv7LlH+/9jw8xYgw="
}, {
    "num_cand": "U2FsdGVkX1/X3msIchQzO5DgFfC/brDlrJxZlB3/kM0=",
    "cpf": "U2FsdGVkX191VxyOd47P7jKo1u12Nlfwymtk3rgVuDs="
}, {
    "num_cand": "U2FsdGVkX18iXqkLJwGnoUSamgTK/rQdmyP1ilKU7Hk=",
    "cpf": "U2FsdGVkX1/X8NHpXqWnN52sie/3qongcEVJUwavyRU="
}, {
    "num_cand": "U2FsdGVkX19KPjrhA3ZzKia502FFMSfI0gdtzoSQApM=",
    "cpf": "U2FsdGVkX1/W3hc6HcJtKDlrEixHSSzm34vF2z7DCRM="
}, {
    "num_cand": "U2FsdGVkX1+n5TwLMqBTu/6zyWsDcNtIN97aASjV1ZY=",
    "cpf": "U2FsdGVkX19irvFB5P79j1tuljgw+1+jYRduRqhUooY="
}, {
    "num_cand": "U2FsdGVkX19Y72JoYzWGsCRAFHVOv1gFE00pYdgwv9g=",
    "cpf": "U2FsdGVkX186v8SiGrlX9o+9UBqXPjuTu61JY6aHgNs="
}, {
    "num_cand": "U2FsdGVkX18AsyExSJJVk8HdLIehegsJ6uSB22xS+pg=",
    "cpf": "U2FsdGVkX192Kg+xQMz9LxfNirszjCk6WK3DOwzip/8="
}, {
    "num_cand": "U2FsdGVkX18Kp4kGqwgP3+IQgmZqW3+Bx8IHxX+ydPA=",
    "cpf": "U2FsdGVkX189RJklR0vJCfja17nPwdsX4FCNP4Jkf6E="
}, {
    "num_cand": "U2FsdGVkX1/nM4Qeoy8jKkJuH9Zi+yTJBpctrGq78P8=",
    "cpf": "U2FsdGVkX1+As6eC3u8bK7MMsfJd2rzxkUAEs+3ByWs="
}, {
    "num_cand": "U2FsdGVkX1/l0/al8v006LmBOOb8GPR/mPN06t6AX6c=",
    "cpf": "U2FsdGVkX19QEn3VuWCxJ4YF8gjQopoSIhU6n68DMPk="
}, {
    "num_cand": "U2FsdGVkX1/AdgAacBf+a8ioZ1s1Pi9SUWs2lRmNFGs=",
    "cpf": "U2FsdGVkX190yzD+gjyPulkxTMOSnic8FK9mmxMiDN8="
}, {
    "num_cand": "U2FsdGVkX1/QyWSmdgLLkWqPcXwXF3SgGEYKroghJmI=",
    "cpf": "U2FsdGVkX1/T1O7xvx+k0VCftlqH+HrUPvBJOUN/kPU="
}, {
    "num_cand": "U2FsdGVkX19iJrbyEdJtgDJCgt6RjUFDsqpql/KXHfs=",
    "cpf": "U2FsdGVkX183V85umwMxVk4ovSfvsVLdTRD1J4SsDnU="
}, {
    "num_cand": "U2FsdGVkX19KZN57yXOWC4vEAWPa1n3jR6llLKB48vM=",
    "cpf": "U2FsdGVkX1+odnyyij0GgYF62PpLXxIx03AcvA7PBCM="
}, {
    "num_cand": "U2FsdGVkX18po0GsEMNqqou8fE39Hfsz2VKFPh7Fl24=",
    "cpf": "U2FsdGVkX18/nVT3WT6jVcSKKw2qtv+FoLAAsVjuRcw="
}, {
    "num_cand": "U2FsdGVkX1+161w/RtzGzgXcG0LJM95XpY7nEDYZ/8c=",
    "cpf": "U2FsdGVkX1/8qzHQFVB5x+lZvDtZad7o5xjFopF3zOM="
}, {
    "num_cand": "U2FsdGVkX1/hkFG2e/u3KwzuXjJHxb5nh7NoPcLAfO8=",
    "cpf": "U2FsdGVkX18PFtI9xR6uPmP9Aw9WBPWAkfBrr4Rvzpo="
}, {
    "num_cand": "U2FsdGVkX1+fEkOxpoR6IPLu2OLitEkb52LStfs/Fhk=",
    "cpf": "U2FsdGVkX1+1z7yilruotSqVPpE1KeAQdu4cXcce9Ic="
}, {
    "num_cand": "U2FsdGVkX1+q8ijAyna5YhKydqLj/tX2bqJHeONVtZk=",
    "cpf": "U2FsdGVkX1+jTLYkXPOLwZ2HntGs6qLs4B7KM95rQm8="
}, {
    "num_cand": "U2FsdGVkX1+swY+tvTwi16cxNdO9MdgyOltObYZcNwg=",
    "cpf": "U2FsdGVkX19lrfJvzd7yWO1ZS/0egGufCK/R0bczKYM="
}, {
    "num_cand": "U2FsdGVkX18vHxzf//wNoLKOnY7/GapAevRbYe63xKU=",
    "cpf": "U2FsdGVkX18jGlSBaX8MuutOtBImxddjnrR/45XcyfA="
}, {
    "num_cand": "U2FsdGVkX1+9M6gNzjNH0HbyaLXTwjB7shH/cteZ1Xo=",
    "cpf": "U2FsdGVkX18kLCwml+k9RVu/I45XECKqPhzbn2RWQfY="
}, {
    "num_cand": "U2FsdGVkX1/OrZlwj7aZoZycz/gqFx4ttdPN6UN17zY=",
    "cpf": "U2FsdGVkX1/+npSpFRhwE/6K0yErmzsDoq+KvneKdHc="
}, {
    "num_cand": "U2FsdGVkX1/Z3gWD6wzT/nUFUCy8erGfYZi0YPs5YHw=",
    "cpf": "U2FsdGVkX19gCAQqBHiL2PmzvN/SIzN9UJFxPARQ+Tw="
}, {
    "num_cand": "U2FsdGVkX1+edkH9MAEDwN46U3yBWHdxu2h5xKKckcI=",
    "cpf": "U2FsdGVkX182NExyrzVasLUfabNTvbM2QUrzHEIoz/g="
}, {
    "num_cand": "U2FsdGVkX1/HVghNipQIgt0HvjqKY2oyj0dyhx44Pyg=",
    "cpf": "U2FsdGVkX18Muy8IIwUNsysZYCIcWBVhdx0lDJwtQCc="
}, {
    "num_cand": "U2FsdGVkX1/Wm0mbFAAeN7JFrntvvohfaUkJBLkQ2Io=",
    "cpf": "U2FsdGVkX19XQvdi0fmNVfvmfDTlXSo9khr/nyZC+mU="
}, {
    "num_cand": "U2FsdGVkX1+fXU3kQYrQwqpzQFCSSDDPibFWYN8cO7E=",
    "cpf": "U2FsdGVkX1/4wacJk6PGE3YKWoFnCm/1Vbydxsc9tmI="
}, {
    "num_cand": "U2FsdGVkX18R2WKrmloyh5czXHIYGNO75/VcCDfOUp0=",
    "cpf": "U2FsdGVkX1/zh0Ac4jq3R678ntqG82GAsxZXlEoFl94="
}, {
    "num_cand": "U2FsdGVkX19ZT72aqtYfxTLTAa4zst3Y1j9Zn71ZloE=",
    "cpf": "U2FsdGVkX18ldCCBLD3EyshN/o4sZNca0ELxX8DYgdc="
}, {
    "num_cand": "U2FsdGVkX19hqEgV17hcGiw/GvWAtYNhXtaR0WgDhPM=",
    "cpf": "U2FsdGVkX1/lWdOV/nXb3XrpjFVMwY0GIax0aLRHKyQ="
}, {
    "num_cand": "U2FsdGVkX18qGDywar3gUlEXf3lNjjHdc/yTerXIgCk=",
    "cpf": "U2FsdGVkX180cR3R25Vf8MQb3eGbLSWMJE9QbUoRrKA="
}, {
    "num_cand": "U2FsdGVkX19tVzPYDANfd6iwVVPVJxT5Wkm/t14wrWE=",
    "cpf": "U2FsdGVkX19MtRCrTlSas9x3ucLU1fnjaLdG+BsiRM0="
}, {
    "num_cand": "U2FsdGVkX1++PI1qR+oEnh0kHeexl3OSttcCblYIf8I=",
    "cpf": "U2FsdGVkX1+ANgh+TaeOyhjzRfLFD2xDxCvJV3LGIvQ="
}, {
    "num_cand": "U2FsdGVkX1+3b3iZ3UiQtVjV/kUBtMM9l6+VW+yP/6Y=",
    "cpf": "U2FsdGVkX1+Cx14xFZsjoqfhPL9nAuY8xJx+Dmt450E="
}, {
    "num_cand": "U2FsdGVkX19bTVatFD4+3WEAL/JxMObZJM1LlHqOW8Y=",
    "cpf": "U2FsdGVkX1+mUvzVbr35hmnZJVdxaWBOlvFsTxbF470="
}, {
    "num_cand": "U2FsdGVkX1/UpWpvKpB1XKxRIw7139PEuvqn++3OB/U=",
    "cpf": "U2FsdGVkX1+//h+ohaYwwELNYi2QvTIXW2aT9LUD8b0="
}, {
    "num_cand": "U2FsdGVkX18LBfAerqYNxApGH8UD4+qxwsi7jIX6WVk=",
    "cpf": "U2FsdGVkX181VaYonQ+b2wt1xQMvzmzG+lnc5oD997Q="
}, {
    "num_cand": "U2FsdGVkX1+ylNivlBWeJ7NHPvkHlvLH14l1mfnqrzc=",
    "cpf": "U2FsdGVkX18u6fzkQfq9O/Ynb5TOs50LiWqq197t0gk="
}, {
    "num_cand": "U2FsdGVkX1+bwTJUgB8k7nztLBzdeJFmmOm/u6CG8DQ=",
    "cpf": "U2FsdGVkX1+uzde8xZb+IlZ+ceN17DzwJs+Y2nwvq2A="
}, {
    "num_cand": "U2FsdGVkX1/zVPwq2gx8dLdGBNW0oiRkDcnx3QbWZEY=",
    "cpf": "U2FsdGVkX19hjaCK7BqVXNCkrSNTmpLD2noZGlIiskk="
}, {
    "num_cand": "U2FsdGVkX1/3BNsd9Kc5cwacq6AWOFOKyn2Q/kOQvfI=",
    "cpf": "U2FsdGVkX18HIdb3lg2kIv9w54f4mPtZc4aAlv+ok+k="
}, {
    "num_cand": "U2FsdGVkX1/npAqIfZKAIsO791eMTRKUUIwzZiV83Bk=",
    "cpf": "U2FsdGVkX18+Ls7E/HjvRgAfmj76bKs9VLYp/fryPZU="
}, {
    "num_cand": "U2FsdGVkX1/tNr3mgz7InxXtHijVxFa4tzmCgIM06Rw=",
    "cpf": "U2FsdGVkX18MEixC7oP716BfCfIN4aN3x7ZeN9VY3G0="
}, {
    "num_cand": "U2FsdGVkX1/4IfSYXDsa5NwX3J9SJ+zIuBIsMBeTPUE=",
    "cpf": "U2FsdGVkX1+crTDDxfAr5zyEv55a9Ksu7RrXScg8xws="
}, {
    "num_cand": "U2FsdGVkX19sZuzMO1hMANvfoUWpy++qhKqIq7HfO0Y=",
    "cpf": "U2FsdGVkX19qJMUOpWtl+13zYcg1OFplgbgk6JzJULw="
}, {
    "num_cand": "U2FsdGVkX187W0o/2JxLqgLocREGR6G29ItylBejrd0=",
    "cpf": "U2FsdGVkX1/OeGHR9igKYJ44HfcuDz7AA8X5Dp2fnmo="
}, {
    "num_cand": "U2FsdGVkX1+9bypB6ZL0+hcAMAz5IP6KGNkH92a68sc=",
    "cpf": "U2FsdGVkX1+ph9ysisHruO/Ln9kCdUDNWosdL6/puTs="
}, {
    "num_cand": "U2FsdGVkX19kdEtTsq0kiuHjOmqyExFNKmeNec9aDUM=",
    "cpf": "U2FsdGVkX1+MTb4PljubqeagnLr4ebiUTk7Ixo8D8eA="
}, {
    "num_cand": "U2FsdGVkX1+BD/sU+2lpUBZryfrMl/MtlmKtwqvisqs=",
    "cpf": "U2FsdGVkX1+ACsVsnL4jq2QwFCXT/bTDFyHQMwPcPTQ="
}, {
    "num_cand": "U2FsdGVkX1/s0sied26OFEYOUNen+loTkVeI/d5O0pQ=",
    "cpf": "U2FsdGVkX1/7oGNZo6/w9Rz+rziWfmo7hJUva5Wj+h8="
}, {
    "num_cand": "U2FsdGVkX19ai/NZA6MMqelWa2os6oZGGx6BLou2rWI=",
    "cpf": "U2FsdGVkX1+j23kjoLadTVW46ZW9/pfys9RaXH+EYFo="
}, {
    "num_cand": "U2FsdGVkX1/9OGsuk+WOVblseVwTRehtqG4qsvejCs8=",
    "cpf": "U2FsdGVkX19mKY5jxxPBl2dvLlAWM/MjtE2y5vDpOeE="
}, {
    "num_cand": "U2FsdGVkX1/w3JUp+4VpUvzxU8//iaLg2y6mJ10vtz8=",
    "cpf": "U2FsdGVkX18kJIMdyJQTqx7YilwGpHh9qqTu5c3em/A="
}, {
    "num_cand": "U2FsdGVkX1+LIc6r31gonmJ/kbB+UYEfNry/aOU+wS0=",
    "cpf": "U2FsdGVkX1+JG0r6nE4SLOQ2hGmTUjBvIH4z+VNEPcY="
}, {
    "num_cand": "U2FsdGVkX19EZFAbY2QdMjPKvUQRMfcSj52XVyIU8AE=",
    "cpf": "U2FsdGVkX19lNxY8OY8jlvOkN34Q+H1F+OnTLPsKjVE="
}, {
    "num_cand": "U2FsdGVkX1+NKMcmxxaYaj/VEyKaIh6UXKpe5joAjBM=",
    "cpf": "U2FsdGVkX1/6gCxLthGeoa/b1f30EkDMjaei5N8Je/c="
}, {
    "num_cand": "U2FsdGVkX18RUgJjzKzk6oI38tNH7gOKH7br1iU3Um4=",
    "cpf": "U2FsdGVkX196Z7y+r8uCbJsHUVJeVXouanCTY3WTokk="
}, {
    "num_cand": "U2FsdGVkX18wFFnaupvtptGs09Zirv3ylPOwJajCYy8=",
    "cpf": "U2FsdGVkX190JS01eaDbGelRonD172ogNLYGl1Hpa3A="
}, {
    "num_cand": "U2FsdGVkX19Ysq7yA3SaiP7Yv3WVCG38RCqj+1N/63M=",
    "cpf": "U2FsdGVkX1+BG5cmIHnGEkdDgICYdtlu6v6CW16yi7A="
}, {
    "num_cand": "U2FsdGVkX19UfI9Dc+YZSqTTy1T5p78L1TKzPwJxNes=",
    "cpf": "U2FsdGVkX18He6EV4EKi/93ksHpQW433Z1NbmTOLI5c="
}, {
    "num_cand": "U2FsdGVkX1+ZC8ZPmvNf0+w+lUOTyCQjoKwSxYoJE8g=",
    "cpf": "U2FsdGVkX19oAJbvntYQM1vQoaq7tYKsdV3ZiXaOYaE="
}, {
    "num_cand": "U2FsdGVkX1+XrEMtrR+ML0xxJAAkVYFqhIS67Pi04l8=",
    "cpf": "U2FsdGVkX1+3Qfc7W6CI1vgyfOHGL2AnWzOGQdSsXX0="
}, {
    "num_cand": "U2FsdGVkX18qqWPE+J9hcqK/Qn4rfl97vikKK+YPgeU=",
    "cpf": "U2FsdGVkX18FlUY2Ib18C7eWRP5G8Fl4XsYSBPVysOo="
}, {
    "num_cand": "U2FsdGVkX1+WsSJZZf/SdyT9oKmO5kSfCEweCHbUfjg=",
    "cpf": "U2FsdGVkX19+fPch6N/qG6EreWc7Y9peYiMuxxFZXlM="
}, {
    "num_cand": "U2FsdGVkX18kxh+wpe03J/XKA7Bp497DowsVk/n+298=",
    "cpf": "U2FsdGVkX1+Mc+I/Fhm/9NqgigNnoLpx997C6ZhZYqs="
}, {
    "num_cand": "U2FsdGVkX1/BpFUBeVU6nG4Ef9/ZA0PV4qUsPGGw88Y=",
    "cpf": "U2FsdGVkX1/S3gSwHdueRQZM2gum8Y3AkJ50KDfmyCQ="
}, {
    "num_cand": "U2FsdGVkX1918c64pKUmOpujESyiIij1ZotYfbQVo50=",
    "cpf": "U2FsdGVkX1+jVm8LjKmRo/mA74F4BmOhbcXbBw/nZxs="
}, {
    "num_cand": "U2FsdGVkX1/6cK5LoZhHN9o71sG0Oh3YhQv/vq/MsTw=",
    "cpf": "U2FsdGVkX1/OBQ+ExPTBmKQaoCRuZzfXXC2YQCtCjpc="
}, {
    "num_cand": "U2FsdGVkX18Nvf89NM/s5rqEx45ubSCTfU3rOOMRVIY=",
    "cpf": "U2FsdGVkX1+j8ytJgYLtOnkxou/YjxrvuEOZTp2L6r4="
}, {
    "num_cand": "U2FsdGVkX19kcihcl2E32qhO/CMdBMFXtZ2/QS1ZgdQ=",
    "cpf": "U2FsdGVkX18FgY9AL5FUN1EunNEPTd0gWmD8rrmMXrE="
}, {
    "num_cand": "U2FsdGVkX1/GsBAtt1wAEC818nAAI19NGY0OthD8V40=",
    "cpf": "U2FsdGVkX1+lGExx5PI9YvSxZIMXuQ5WHPkxhPp5H6Y="
}, {
    "num_cand": "U2FsdGVkX18zPVC3e5JBQJf+JUSReZZcnLW2pNTOA0M=",
    "cpf": "U2FsdGVkX18RBaI8HNlSFaox7qK9YGS5/Z9uiQi+hKQ="
}, {
    "num_cand": "U2FsdGVkX18exsUsJkrCuUXLuGM23hlgHVQBqC8olq4=",
    "cpf": "U2FsdGVkX19Nalt6u4u7teq86vMhidvCKOXYVyjIQnk="
}, {
    "num_cand": "U2FsdGVkX19uSCMCTy8Hq7bauogsnVfrhQj/2CN4IFw=",
    "cpf": "U2FsdGVkX19536Ehl1Zo6FsQUFbcAfuPYnjyPcVTd3o="
}, {
    "num_cand": "U2FsdGVkX18rwrH29nCIqZOP9U9JSedYcnwrrSYieOk=",
    "cpf": "U2FsdGVkX18riFEUKqm/IwSp4R7j8+RCnSrwwJbjSfo="
}, {
    "num_cand": "U2FsdGVkX1/W5MrQRVNUZ270gz6iWfbKxXJ/uOHCpnM=",
    "cpf": "U2FsdGVkX19VdMfPTue1QJDOK0UOxdS/4qRR1d5qW4Y="
}, {
    "num_cand": "U2FsdGVkX1/Z0VHoLtzzdN82oCqxnd84jIPLT2WDsEM=",
    "cpf": "U2FsdGVkX18nHv9SR6zA4TflNNDIVkwh2+FmhQXfVoc="
}, {
    "num_cand": "U2FsdGVkX18xmiMNWnXAXNAysHx0XW9ZP3ZqtYOuZwM=",
    "cpf": "U2FsdGVkX19PhooMOdVC3cp1DbKc9iJiTq6dhPrpAiA="
}, {
    "num_cand": "U2FsdGVkX192ykiH9HNr/U/hy4Kon+wo6T7SIm7igy8=",
    "cpf": "U2FsdGVkX18OAWtCvCMC0v9U2Z9BGHjCjsKBxulXZLg="
}, {
    "num_cand": "U2FsdGVkX18SPOM9ha3TbVBNJakT/uwJ/3TSXzRNFwk=",
    "cpf": "U2FsdGVkX1+yEDLdXsl5bCbjEFjOHjisSQ/KhkjWdfE="
}, {
    "num_cand": "U2FsdGVkX1+kyWMKJ8cf5u04v/J2q+Qw/1gcU9FtJqY=",
    "cpf": "U2FsdGVkX19iDuNXYYWMKb+90tZXUdlasQoFvWf9cUw="
}, {
    "num_cand": "U2FsdGVkX19TzApcfmU5VNEsZbitGvoEquOvdUga02k=",
    "cpf": "U2FsdGVkX19QYxXG6HCJjTeFIENlec5FgCoC01xp3lk="
}, {
    "num_cand": "U2FsdGVkX19hHvYSX8IJubh6GD2Gloukgza1oWbJ5Zc=",
    "cpf": "U2FsdGVkX1+TMAQtiT1wiZpLrKhPxp7NrV5Pc09WL/8="
}, {
    "num_cand": "U2FsdGVkX18J83tGUDRYTI8s3fGKY98iw+ge+GMZi3Y=",
    "cpf": "U2FsdGVkX1+espMqtTZcLlaWJBWQtQrCD1LificsRr0="
}, {
    "num_cand": "U2FsdGVkX1++j9t+O83hEZ66jNdy02N76A28ey5fMzk=",
    "cpf": "U2FsdGVkX19w2D6c1c9Phxrmz4LVz8k/J0MzHEfkxGM="
}, {
    "num_cand": "U2FsdGVkX19zP0TUWNHcB1F5Z8KoR+csnr2qe//EO3g=",
    "cpf": "U2FsdGVkX1+zQnzJWkLIhAma7Ck3x0UR3iSTFWNBkU8="
}, {
    "num_cand": "U2FsdGVkX1+CDXP7jGVPnLaLL+qXXDgAXJhQUJ3koUA=",
    "cpf": "U2FsdGVkX1+3PVDvn5B72Bv2+hp+EqdSNqWy+CVfwdM="
}, {
    "num_cand": "U2FsdGVkX1+/LHWFxgeaFLHVvRku7snv5rNCblnt9Xk=",
    "cpf": "U2FsdGVkX18m8QatLLsxHbNzbvvQuMwdKv/xInAtfM4="
}, {
    "num_cand": "U2FsdGVkX1+rruAE7ZLJD4ihBJFp1iUXKoa2rf8oE7Q=",
    "cpf": "U2FsdGVkX1/IgijfFm3lpKLbYwhpLyxGBz5UomXiKKE="
}, {
    "num_cand": "U2FsdGVkX1/Kk1jpk8lIaFyCZq3xBjcVdxgux060iSQ=",
    "cpf": "U2FsdGVkX19mT4tRId8gWjDMi6qxt6uReDFN4P8Kdy0="
}, {
    "num_cand": "U2FsdGVkX1/7ejigTIIL7sD7ssZkZ17Vq9EnOVzbwUI=",
    "cpf": "U2FsdGVkX1/i8+BAA/MMnV93QLM51X20eVi86Xs/e1A="
}, {
    "num_cand": "U2FsdGVkX18Q07x14YJYhwSTvmlUl2R1PBN/kTQ7UPY=",
    "cpf": "U2FsdGVkX19nrr/fRUfW1YJ8pHHnMOmKCEF7+NIkRiU="
}, {
    "num_cand": "U2FsdGVkX1/bOzA67nYn9oyR+5p8RTNYTvZCe+sRcJw=",
    "cpf": "U2FsdGVkX184LzGpnvl64zYgiI0BtsP297oMI7kCWPQ="
}, {
    "num_cand": "U2FsdGVkX1+/rd+/d6U7xhH1Adl+u9bKHjCDA+PeqVg=",
    "cpf": "U2FsdGVkX18eBxqr9uilleoEflfwDlRDfzLSQAxcJIo="
}, {
    "num_cand": "U2FsdGVkX1/DXO8Ly4yQ8EBGaCXK8NMCkTDiEjgpi8w=",
    "cpf": "U2FsdGVkX1+ACZPK9YoxVxCbTf3wFeP3RR0ALNr7mhY="
}, {
    "num_cand": "U2FsdGVkX19bGxy+PAiMT/sn2/iNSsBfz3M0lgfngH8=",
    "cpf": "U2FsdGVkX1/hWSN1rh25OQnwlA6h0zxTgor8PlqpNsY="
}, {
    "num_cand": "U2FsdGVkX19h2BvrjoASr8ZBkjl4HA9cQEIvZTB+CCg=",
    "cpf": "U2FsdGVkX1+tVg6QIlNBh6fkkVB4pyLZxX4ysXuwn84="
}, {
    "num_cand": "U2FsdGVkX1/WLb5wE2pAVlqkd5XRrcVTthPipwB9X08=",
    "cpf": "U2FsdGVkX1+qRRGcjMUvsVuKyzS3tz85Yz2b2PI77dw="
}, {
    "num_cand": "U2FsdGVkX19V40hAyyIDcyCdZ4rH14+nXygelYs+iVI=",
    "cpf": "U2FsdGVkX19SuLQ9ptF5CofOBXLn3yNSJRt5IwvhiaE="
}, {
    "num_cand": "U2FsdGVkX1+7yBRBjnqoCAgNKWoWXNfUHWN/t4AA8aw=",
    "cpf": "U2FsdGVkX18ppQIegwWbp+UgobnJbs9q9vo23xR8EUM="
}, {
    "num_cand": "U2FsdGVkX18l/Ldg+OPunYh7WcBZKS/Yj/mveyW1H7k=",
    "cpf": "U2FsdGVkX19POf75pwUtDt029N3Jsyr6tIezlc3feAI="
}, {
    "num_cand": "U2FsdGVkX19jL5+sTU0Arz9dS9U7O7Xs/4/e4UA808U=",
    "cpf": "U2FsdGVkX1/0EtzRCaIbjgEmOlns8f9N6DqGOQklTos="
}, {
    "num_cand": "U2FsdGVkX1+rX8cwNxZvpFgdNwxievNZm9papoj9ULQ=",
    "cpf": "U2FsdGVkX1/0lGv2ON1FoG/8h1iN4zTs2KxH/Sku2Gc="
}, {
    "num_cand": "U2FsdGVkX1/YyVkkoMWRca1n7grDym8nx/X7lsLsG/Q=",
    "cpf": "U2FsdGVkX1/hcTj2djzJYqpoNMiVXmatnWcauOt928Y="
}, {
    "num_cand": "U2FsdGVkX1+LEbMw7E3Ork/5o6UF3uWK/s6z1KRndbQ=",
    "cpf": "U2FsdGVkX18NdzMtarv4F/v55LSnwxgcKPvYE1wbp50="
}, {
    "num_cand": "U2FsdGVkX1+a4YN8vL5XNLRmqmeD1ADzqqFSBs0lOOY=",
    "cpf": "U2FsdGVkX18kRmfz1Lg8awXrNhvys9XWu20ZI/5UmZo="
}, {
    "num_cand": "U2FsdGVkX1/n2wnnK2c+inDfsdLovjdZZwWRgNllGOE=",
    "cpf": "U2FsdGVkX19zJ034zL3cuxzYVGP2nqYtsy/V3RhDQrw="
}, {
    "num_cand": "U2FsdGVkX1+JzzcJfz2hCzG0KqbdRcHUukWyEOEZttI=",
    "cpf": "U2FsdGVkX1+NodAwpbGrY/9ahIvXphE3DIm0kR2OYOA="
}, {
    "num_cand": "U2FsdGVkX190fEGHdER+QsrbD/Dw8r46Osrc2lseVo0=",
    "cpf": "U2FsdGVkX18e0Cz+T5+z+PztL9ZyVMHAa1ABRB1BFQY="
}, {
    "num_cand": "U2FsdGVkX18rPGYl/3Swzvvggi/TIjWKh8EwMt0TKzc=",
    "cpf": "U2FsdGVkX1/I+0jXPMSdfBT1BScu9MXEYz6TPUG9w7k="
}, {
    "num_cand": "U2FsdGVkX19EfUDGlFo/R2yPoq+ceXcVoPKBJaQxSTo=",
    "cpf": "U2FsdGVkX19S4eWxDeHM3zDbvA9mkTqRmJPqHo93xdA="
}, {
    "num_cand": "U2FsdGVkX1/jseboeTQqYWSv8A+OY5LMpWd7bk1tlhI=",
    "cpf": "U2FsdGVkX1/Dps2exp3R8ISqtPZi0CiagoY7TtaqBC8="
}, {
    "num_cand": "U2FsdGVkX1+HQJWBjw66vSar9pyCN3szReV9H89k2YQ=",
    "cpf": "U2FsdGVkX1+Ms2Kv2m22XMPy/+ey0Jm7NC16ns2YPu8="
}, {
    "num_cand": "U2FsdGVkX1/9uwFTHDbdWfQ5qXhqoMZ0d138eoQop5Y=",
    "cpf": "U2FsdGVkX18AJN5BcaEefUO56dXfF26WAhMhu0l6ikM="
}, {
    "num_cand": "U2FsdGVkX19ZZ5zPsUdFqQV1iQ1SRuw+OGT6AcHBy0s=",
    "cpf": "U2FsdGVkX1+jX+Qk+tm10S7Ns9SUyjpXVs54UaUcqKw="
}, {
    "num_cand": "U2FsdGVkX19UnRTrV4jCYTgwCxYJ6fVogsUCE2NW084=",
    "cpf": "U2FsdGVkX19aQUA8P7IJwq3jp+xudIYuYYejzi81Wcw="
}, {
    "num_cand": "U2FsdGVkX19U9xzd7KK75oAKeWN0VpXo0Qm9iVY1E4o=",
    "cpf": "U2FsdGVkX18ctdVokt083sP9RyF0iK0VJSPSD/DQb80="
}, {
    "num_cand": "U2FsdGVkX18DkBjip26iIHlVUJAd22+67H+WqLmJAdk=",
    "cpf": "U2FsdGVkX19GsNMef44rb8xtcG4I6gJ5kKwLszTlHzs="
}, {
    "num_cand": "U2FsdGVkX1/2JUp3M1rb3b07ntz7kfUraEd2D+e/nzQ=",
    "cpf": "U2FsdGVkX19/k6t/2hgQtg4Tq+6+q4t+1p+ngpRlPtk="
}, {
    "num_cand": "U2FsdGVkX1/jZe3Kab5f13tU/50TxgsC+G1DAPZQoK4=",
    "cpf": "U2FsdGVkX18sjZGA3qYk4xwnCtp0OwzqHsX+6M6G2fw="
}, {
    "num_cand": "U2FsdGVkX19efCmEQZaIWeTZkMH3wSBtFxu7e3TXFow=",
    "cpf": "U2FsdGVkX1/U8s7Rxy9HxUxbhzzh1fM8dzangAvL3f4="
}, {
    "num_cand": "U2FsdGVkX19aW31VuDVcZ8I71KYwnxBfaJ3SPtNqOfc=",
    "cpf": "U2FsdGVkX18kkc3435wZhLvSF9f566Bv9RkReStzai4="
}, {
    "num_cand": "U2FsdGVkX18eLaJ7P78FVKk5U3MY6ioEYePlbhq1Kco=",
    "cpf": "U2FsdGVkX18yXImGLXOYA8DoDmNK77YzS9W2z+99TU0="
}, {
    "num_cand": "U2FsdGVkX19+w3CvJ/iLfMMl5maeVv5oz4PLL+ZahBY=",
    "cpf": "U2FsdGVkX18gwqwuhPGrHwus69nP8fmyfDQgTtu9ntk="
}, {
    "num_cand": "U2FsdGVkX1/YqSdxK386k0S9820IbVy+cB0UyyxJgwU=",
    "cpf": "U2FsdGVkX1/kSSykLxPge9JLuKwzUtdRPhto+NOU1Wc="
}, {
    "num_cand": "U2FsdGVkX1+9M1FEjXKOzRKp+byq/ySj760wQ+0vm9Q=",
    "cpf": "U2FsdGVkX1/VVL+USYPV085ULSTeYnsvR/IMwgO90l8="
}, {
    "num_cand": "U2FsdGVkX19pzvOcp+914qEu5zKtgkDQWYiE3huWcWU=",
    "cpf": "U2FsdGVkX19WnMsakkDU0rfX4tiVw9ZEgBhxbHuzvd4="
}, {
    "num_cand": "U2FsdGVkX18xiDaLoJJ7bqXhN3MyRYnMgHfXcZF1Im8=",
    "cpf": "U2FsdGVkX1/S/H8VzVeNsO0QcsPaHYO6qYIG4QxTz0Q="
}, {
    "num_cand": "U2FsdGVkX1/UI2UIqbDF9eMbEjM4b+paITzl+RB+21g=",
    "cpf": "U2FsdGVkX18tqIZJX3PWczo7hMqpf4eXdTUIEyK9640="
}, {
    "num_cand": "U2FsdGVkX18+uUBPEHhggFSwTO4xt+O6hSLF2ZdX3kw=",
    "cpf": "U2FsdGVkX19Qr8UeznG7CeX4jMTEB27Ouy8GtaQfOFI="
}, {
    "num_cand": "U2FsdGVkX18cOcFIHfCNwPICh+oSwddU5VnE4IhsmtM=",
    "cpf": "U2FsdGVkX1+6GmuVtqXp2jQVrub9r0dOgaO5SvnbZPM="
}, {
    "num_cand": "U2FsdGVkX18BKBH9WyfOBQ8D4e8YjxERhSatcHcxacE=",
    "cpf": "U2FsdGVkX18tG9yIjTqDV10kYyrx9kowdhgqeMEs4zY="
}, {
    "num_cand": "U2FsdGVkX18ifSTZDRhECjp03O/2kLzCmZ0oNBmJP+M=",
    "cpf": "U2FsdGVkX1/XUzLWO10tmjzCjwCZ3X/yon6Sv0RaJ/M="
}, {
    "num_cand": "U2FsdGVkX18h940XpEZTUQqvR4PqiFL93zB9YHJBmMg=",
    "cpf": "U2FsdGVkX18hLWjv/hyM9pwn81tRMTNN41BFpsuMVS0="
}, {
    "num_cand": "U2FsdGVkX1/ITvdvc7g5jXCerjtoayZIapiBO3mQnsU=",
    "cpf": "U2FsdGVkX18oGis3peikXdJwHpkGC2yXicR4u0cxxq4="
}, {
    "num_cand": "U2FsdGVkX18ewBN1KvyfSDjpjSMi3/rnKt1+qCUlGhU=",
    "cpf": "U2FsdGVkX1+wVTCnMjEQ9OS8Xv4Z75JfPNJRgn6S+0Q="
}, {
    "num_cand": "U2FsdGVkX196a2eRVQD+EO756NZhzaUVJ9Yh8Pzgflg=",
    "cpf": "U2FsdGVkX19plaHSof9N5DVTdKaHPiksfhPbW4m1XXs="
}, {
    "num_cand": "U2FsdGVkX1+v6u1qlyzH/IU8dRxlnIsL8Pbbqq3/MsI=",
    "cpf": "U2FsdGVkX1/s2EU8LIAIXJvAClcCjYMHHryL4Urfv7M="
}, {
    "num_cand": "U2FsdGVkX1+RYdhgJ0BBO2XC4FN7k5Gzh4Xl2IEWuac=",
    "cpf": "U2FsdGVkX182vtqzwDsYMWZE8E5sdYeVa5DmjkwxwP0="
}, {
    "num_cand": "U2FsdGVkX18S/7w4+DemeTQPqxJPGlupQg928BqU3Mo=",
    "cpf": "U2FsdGVkX1+3xgAU5xbIjeWyPmOsNqzOLuGBba5zT4c="
}, {
    "num_cand": "U2FsdGVkX19VaE21crkqaCx/pmyZXa4Sro9sgYMIAyk=",
    "cpf": "U2FsdGVkX19c3hHPRQN94gB4cTMcaoO5Gk/+8B41RVE="
}, {
    "num_cand": "U2FsdGVkX1/yp4HEdoQxmE5ik7r/k0eakpRXXvFq2ag=",
    "cpf": "U2FsdGVkX19ief40LUjIXO40INLqAkL+zdPB8lyQBkk="
}, {
    "num_cand": "U2FsdGVkX18BQiCgrBQj0ZStC3aDFnXe8yGARdROsZI=",
    "cpf": "U2FsdGVkX1/7CY/0/gGeybwgbNKdif9M5sXyO8hpXJo="
}, {
    "num_cand": "U2FsdGVkX18xNBY9Geo0daSUqck72fKOph+jB2sFaQc=",
    "cpf": "U2FsdGVkX199eaeg1GuvqD2bseDVv39V6VOKuTRu7pA="
}, {
    "num_cand": "U2FsdGVkX19Q6w6arRbVwab0QdY+RC1KRTSGpFC3jmc=",
    "cpf": "U2FsdGVkX19JR0d4fppO3GIzJXcDuc06mY4w3rNVdzg="
}, {
    "num_cand": "U2FsdGVkX1+a0tpybM5jmfzoqxk6yRlYXroflTa+DUY=",
    "cpf": "U2FsdGVkX1/DqlMKhUB/CZvfV2U1ptpLqoXvo48QL+U="
}, {
    "num_cand": "U2FsdGVkX19zF4UnfyvymHFNHllKRoi9yZLvMAyTJcM=",
    "cpf": "U2FsdGVkX19sB5t4U2BDk+nZrJ9o5IQdOFJ1Sx5HXWY="
}, {
    "num_cand": "U2FsdGVkX18oba6qahqdaelPb7+Uctb1aW8paCx5k5E=",
    "cpf": "U2FsdGVkX1/QHlcTDUtru/6K/NKjg737CTlgt/aOxS4="
}, {
    "num_cand": "U2FsdGVkX18iaM6TR8VseVaZYa2tUaZ8M32MRMFQQ8Y=",
    "cpf": "U2FsdGVkX1/r5O0qcOJddla7DVC32zycVj94mkBAxko="
}, {
    "num_cand": "U2FsdGVkX1/kJnXfKJofDUV9xr7xAMhZ7Sj8vWcNXgs=",
    "cpf": "U2FsdGVkX18U4bHeQtfyuEq8Z3zFXz9Xuvi31NOJ9Ro="
}, {
    "num_cand": "U2FsdGVkX1/MkGpUCjIzo/zwb0MMVFI0dI6LqPagAQM=",
    "cpf": "U2FsdGVkX19NTafaON/D35HvBRbgEsqLolYaSZWBMX4="
}, {
    "num_cand": "U2FsdGVkX19ca8qbw2c/1xAwzhgx2LR0/KHCJI11/SI=",
    "cpf": "U2FsdGVkX1+/hVrgYgzE8A22bDAjXfKa3qBeMMPQr94="
}, {
    "num_cand": "U2FsdGVkX18gGxWzp/gY5JL6Qb4oOXcq2tg97/U0qzI=",
    "cpf": "U2FsdGVkX1/F17rX8nXBN6N7/U4Hfllex5o14ge5d5c="
}, {
    "num_cand": "U2FsdGVkX1/c38DOwpmcmuZook06Jr/IxGwf3JHx8KI=",
    "cpf": "U2FsdGVkX19VN393xWPT3bAWvl7d+LvGC7AA2779Gx4="
}, {
    "num_cand": "U2FsdGVkX1+XkKdSligLrI+JdzjIKe4Ah0OaGDvRz+c=",
    "cpf": "U2FsdGVkX19MmnuUJNBrLDLq02+fIRAnF0AVQqMXViY="
}, {
    "num_cand": "U2FsdGVkX18VcQt0Q9/cRcdIS5mJ4gdsyTi3SAR9NPI=",
    "cpf": "U2FsdGVkX18gC2O9EzsQeiKPIW9Stk93hlfOzRbycuM="
}, {
    "num_cand": "U2FsdGVkX1/j2X7sjJACr1BvsZoIZHd9keDEEXeGn4c=",
    "cpf": "U2FsdGVkX1/Ucxw3PnTQvqK+D0JdFzZ7mL2c0qYjU64="
}, {
    "num_cand": "U2FsdGVkX1/sjqoUIaob7WVhd90KSPHNI1h/PyRTWSM=",
    "cpf": "U2FsdGVkX1+XxRvqZSh+ubAdLlTYthSIt9TsvluZEoU="
}, {
    "num_cand": "U2FsdGVkX1/IHESB80BCYEtUkjsi7wq2XJP2pnj7OHg=",
    "cpf": "U2FsdGVkX183FzIEJY4y56Ai99cUm850sHOVat7AYs4="
}, {
    "num_cand": "U2FsdGVkX1890NLPtpSqXgUd+moweuRvMZ/7r5QUGL8=",
    "cpf": "U2FsdGVkX18eS3A1qqXffI6QpYL4CDtyrmuIJ7Dmf1s="
}, {
    "num_cand": "U2FsdGVkX1+g81XFjiXiohKSQjiM7Jk7hclAH0AApbM=",
    "cpf": "U2FsdGVkX19KB8JT/NVHD/S8mEEtIkbA2ZgBf8VnQTE="
}, {
    "num_cand": "U2FsdGVkX196a5Tkol7+i4GzanqS3K4D1RWdo1iBo4c=",
    "cpf": "U2FsdGVkX18BouUd79PD2hsNQrpJTm95mOxcyItPB6I="
}, {
    "num_cand": "U2FsdGVkX1+hnA16qiL810CtLn96fLH1e/IYwfUrvVY=",
    "cpf": "U2FsdGVkX1+ZvDLImWj+CW8CY1I0kNPMgMBjwB2C2n4="
}, {
    "num_cand": "U2FsdGVkX18U9s+VHnrOy4tKvPomEr3YHAtv9keZPJU=",
    "cpf": "U2FsdGVkX19s3eSaydI1KEGhmo+de8PK435H/qRKcNQ="
}, {
    "num_cand": "U2FsdGVkX18ZSagUlXWZaICsYqBb2mo2aLTzHIh05K4=",
    "cpf": "U2FsdGVkX18EYC0qIyD/Tt6Nva5mfkyJ8N6JznFrgOQ="
}, {
    "num_cand": "U2FsdGVkX1/YWv+jGFrK52SNDZHb6xzFklz5FwasDPY=",
    "cpf": "U2FsdGVkX18uschC4Y87o4C3QckE2fVoCy6uHuJK15o="
}, {
    "num_cand": "U2FsdGVkX1/KxAaPPywCp9mR5JOBFhoZwNjZaiAmmL0=",
    "cpf": "U2FsdGVkX192m+GQGoISpaAKM1+Oa5ZdqyqoJ5UUNx8="
}, {
    "num_cand": "U2FsdGVkX1/hIiksGnjmHBEkKPGdDziSR8/7IkFykiw=",
    "cpf": "U2FsdGVkX1/5Tza/yap29J1jsowQFb69tSIdoDSVcpo="
}, {
    "num_cand": "U2FsdGVkX19zzBsc3NxjCL9M74eZF9sP1TgjXLX4SQw=",
    "cpf": "U2FsdGVkX18uM8oxtF6juVE2DExVh3NViEA3OX8bIoA="
}, {
    "num_cand": "U2FsdGVkX18WCclaBhOeSBQ4aPd0IK4vU48ki+fxTac=",
    "cpf": "U2FsdGVkX1/phqzKYoNfiV0+Khy6SHe36NKvanNcnbo="
}, {
    "num_cand": "U2FsdGVkX19OSVhmSOPjkJApDntM/6NwklBADXgo8FA=",
    "cpf": "U2FsdGVkX1+2phpkOmCEvxBs54tqEbGzELxpBXZJqD8="
}, {
    "num_cand": "U2FsdGVkX1/5P0aPxbIjiB4ltkvKGOEayL41BArL1dg=",
    "cpf": "U2FsdGVkX1+rbHNaUwl84yPAVKVz9bSDQGJlt8VqKVU="
}, {
    "num_cand": "U2FsdGVkX1/1CCx2ei7pTc4A3artr4YMOPVUlG8E4gs=",
    "cpf": "U2FsdGVkX1/t1/sE9u3pvWS5nNSTb7Ll8FeD+RvgZk4="
}, {
    "num_cand": "U2FsdGVkX1/Z1FOeeutbs3VYvwxcOldwY87YhTEnd+k=",
    "cpf": "U2FsdGVkX1+33WtYjSb8TcQndRfP2ECDhl5UZUsSbLs="
}, {
    "num_cand": "U2FsdGVkX18AahNumwVwZZIs/bzkImhypp1/9fsB5HM=",
    "cpf": "U2FsdGVkX18nPknUhmZmH7Nmge/hDf4o5NkUIU7Acq0="
}, {
    "num_cand": "U2FsdGVkX1+OyxYaKepWt7d+jduUYNEhCAv6KZStkro=",
    "cpf": "U2FsdGVkX1+wQsEomYi4QvVg2MWscDUwX9vWBY0CXzE="
}, {
    "num_cand": "U2FsdGVkX18oJkswl9zBWif08aAN82D7qt4y+2coPNA=",
    "cpf": "U2FsdGVkX1+J99Zj8IU4TwosXufr66cSx7sEcFEkx4U="
}, {
    "num_cand": "U2FsdGVkX1+xiLRTN18SIBKOhsbsz4pnsll007taS0o=",
    "cpf": "U2FsdGVkX19X2P68M/Kev7Ou4KY+93ahjGDw20R/PKE="
}, {
    "num_cand": "U2FsdGVkX18kl5E7cza3fvKNblEM9x/ry68rW1pRzvs=",
    "cpf": "U2FsdGVkX1+JyrzQUPIDLk7PuzYEmtOq5Loiedd6qSs="
}, {
    "num_cand": "U2FsdGVkX1/cfVgqlpkfOFdywmMJl7DJdh3Vo+RmumQ=",
    "cpf": "U2FsdGVkX190ke+1d7rf3bHupY2HV2hyhQjsv+N0RpI="
}, {
    "num_cand": "U2FsdGVkX1/pVLX5MFF8RkhmXwontrMHVToW+lWj1V0=",
    "cpf": "U2FsdGVkX18KRL9f4peTyfy4o9hl6i+KrZYB5+R/JIc="
}, {
    "num_cand": "U2FsdGVkX192D4+LIDRa2nGD/Rohm9zfD9bR/VE0dbQ=",
    "cpf": "U2FsdGVkX18mPuZFClyGqsIC9MFI6iaKHzjXs6FDoyU="
}, {
    "num_cand": "U2FsdGVkX1+0dMnuzxUE+oHdQ8Y9JRs63turI2m1zAk=",
    "cpf": "U2FsdGVkX1+X3dDVCS5OBWLbUR7PVBhczlbPV3on5pw="
}, {
    "num_cand": "U2FsdGVkX1+h+7fmVKl5Ax5DRnFxv0NE9GRxWgHBwJ4=",
    "cpf": "U2FsdGVkX1+63yJWTpgrU+gelJhYaGxm7IwkzmSEtgM="
}, {
    "num_cand": "U2FsdGVkX1+xJs2mbd/65jUCGMBgJipgEk2W8qKBa/A=",
    "cpf": "U2FsdGVkX1/JVdMU71sb5uRP8didkJbqsgeO7oQXUWE="
}, {
    "num_cand": "U2FsdGVkX19Zd5FRV/0kOhSHppThsahX/3o6fbxKKpU=",
    "cpf": "U2FsdGVkX18LgT0n+AoYlXcH4whFTINa/pjvz4EgKyo="
}, {
    "num_cand": "U2FsdGVkX1++dGZxDxmuUzYNXvtXjORjytiQuelzP8g=",
    "cpf": "U2FsdGVkX1876sgJ1Ug7F6jtv4gfmNTfTEzp/jxr660="
}, {
    "num_cand": "U2FsdGVkX19CeX60lZ4Pl10bjx6cF0OshEzDGkriPHE=",
    "cpf": "U2FsdGVkX1+q0/youGvooPIVeZS8VQJbTBgp6MdLVaY="
}, {
    "num_cand": "U2FsdGVkX1/LqMaPIwv3fShqMbMux5sx7uysZM8ufYI=",
    "cpf": "U2FsdGVkX1+eSaItXX/GwbzynGU+k2E3rd91TXL1Kt0="
}, {
    "num_cand": "U2FsdGVkX18s9AeghSfW1gNgK8LxZ64bis4sScjGWxQ=",
    "cpf": "U2FsdGVkX1+1SxIuibop5TSjQnHgAe5oxbmChfSzlIk="
}, {
    "num_cand": "U2FsdGVkX18a14hryCCXyFah+sluVOK3lX3zVwI4qoU=",
    "cpf": "U2FsdGVkX1914vj4Ew/sC1384cWbN+2O5Bwixd8/Icc="
}, {
    "num_cand": "U2FsdGVkX1/gPuok8EKXstfNb9aknul6jZZnVjDNdIY=",
    "cpf": "U2FsdGVkX1+5SO1FGpaI3HSr6V3blF4juBXCYoatDWg="
}, {
    "num_cand": "U2FsdGVkX18qV3m/seHbWqXJOB36IlUZRQgxF8xO7iw=",
    "cpf": "U2FsdGVkX189tmDiXdzHjFIeR0OgOMbKOpqtxIAsAn4="
}, {
    "num_cand": "U2FsdGVkX18sr1uFQuFXA2jnLOLy7EKLvXj1c01RTv8=",
    "cpf": "U2FsdGVkX1/aNoTGE/G3fi2DTdW4R2prf4ibEeurr8s="
}, {
    "num_cand": "U2FsdGVkX19wF+N1lG4kH3qm6L9ePDumFO6wZnguCEY=",
    "cpf": "U2FsdGVkX19OCNy/0Xl2kfs56gf5TshclHUBfYA7ZvU="
}, {
    "num_cand": "U2FsdGVkX18E3kAHOyYbwyC+q+afvZf+Vg8gNnxUiuo=",
    "cpf": "U2FsdGVkX19E4dsAVU3IMu9z0anEKt0CmbjdxAoKSP8="
}, {
    "num_cand": "U2FsdGVkX19PCF64OaQnAic44mUQtWYoxGAtsfUsi+A=",
    "cpf": "U2FsdGVkX1/FBnMP2dO0sOjnHxJsMa/ddMH1bqWQ93Q="
}, {
    "num_cand": "U2FsdGVkX19xTYDh4DPKtwh9B993b348HyJujlw1lEo=",
    "cpf": "U2FsdGVkX18AXXBFdt5uAd9DQWdVkh0OQuMlSZnJhDs="
}, {
    "num_cand": "U2FsdGVkX1+gJa+bNg6Mbt138YYSJSs+/LkhfASL5TQ=",
    "cpf": "U2FsdGVkX1+BoaxKajyBgjl/d5wUMe9sDnSFxDQgjOs="
}, {
    "num_cand": "U2FsdGVkX18Vc0GGXIQ7WMn8FhOXqm2Asu5u8qyVaZE=",
    "cpf": "U2FsdGVkX18EPXrlwL3cUjgEtnn117UOST8vVHAy1aA="
}, {
    "num_cand": "U2FsdGVkX1+A75sUHz75Je/NjnmobSRz/qvCfnOmkdA=",
    "cpf": "U2FsdGVkX1+GqxlVbOBlT3JfmcWwMFuH5bgptpfiTmk="
}, {
    "num_cand": "U2FsdGVkX1+RIERIEYSsKfQ8i56OH0DpEamxWkIz3o4=",
    "cpf": "U2FsdGVkX1+4514dSOhWjbdOpIk+aFGEV2DlGJeb4xA="
}, {
    "num_cand": "U2FsdGVkX19u2EsYBbAnK5CQi7bRTzo6G8JdZuSEalA=",
    "cpf": "U2FsdGVkX1/0pZcOREJsb7aIgdZJpikPMl1Kl/LJqOc="
}, {
    "num_cand": "U2FsdGVkX1+wenbYJ4Q8OzUzUB9wH1qqXPqgWUCT4vc=",
    "cpf": "U2FsdGVkX19qhIEp4i10YsNEWxlFbwc5aCXANQZwYXg="
}, {
    "num_cand": "U2FsdGVkX1/M+RZcQEhu3Vy3Eu8LtBGdCHbJ5Rx1Z4k=",
    "cpf": "U2FsdGVkX1+P/f5jxlurL295uultu6EjM6czoaKofvQ="
}, {
    "num_cand": "U2FsdGVkX1/I51t9RsjaTi+8ebJQLIw63+IiO90kpXo=",
    "cpf": "U2FsdGVkX1/FTWC4RSRvNn4TDFjCTHbs1vnrf3WQ9u4="
}, {
    "num_cand": "U2FsdGVkX19q67i5M87dM0nb8FOyHRCwfsqmNxo6Syw=",
    "cpf": "U2FsdGVkX19sqqQBYYkQ1WrO76Hlx095R4Nd/YTEXTU="
}, {
    "num_cand": "U2FsdGVkX19RGw05xvUqaIqtym3Rmtxpb3NSt4ktksg=",
    "cpf": "U2FsdGVkX18F2YAXy7/7XzG4DVfENE121w9Ubal63oY="
}, {
    "num_cand": "U2FsdGVkX180lCfPil3+WwgD/VMqJfE6E1sQTofeetM=",
    "cpf": "U2FsdGVkX19UimmdC5/lILls7gOfXV58/LQTeOUAKZI="
}, {
    "num_cand": "U2FsdGVkX19dWw+E+/hWvZo61ypYCFKXs26oHazZuoQ=",
    "cpf": "U2FsdGVkX181ny6xOBic/5Q5IBJRRj8/quXOAR1pg+g="
}, {
    "num_cand": "U2FsdGVkX18l0Avyt3ulTn/WlIKdin5MSsYoforhQ4U=",
    "cpf": "U2FsdGVkX1/zRQXvwG87jrHJOEb4gS3vHT0MNZiqgNk="
}, {
    "num_cand": "U2FsdGVkX1/zr/9cxcMDOa4PSmsnVcQkDpcXCkyDsAQ=",
    "cpf": "U2FsdGVkX19nm2kEGgbpvwky6rP+FwPMTp25VGl8Liw="
}, {
    "num_cand": "U2FsdGVkX19mdIL1ekzaIAmeUQQlVmgaiY10om8jKUM=",
    "cpf": "U2FsdGVkX1/ADjJoAhbDYEWrSjoW8fYB+fBzDILArKY="
}, {
    "num_cand": "U2FsdGVkX19qEY6XnTZ4kDLUoof8Na9K337BTiiFd2E=",
    "cpf": "U2FsdGVkX1+uFSOFWrXUJvtv4hJH5XDZ6FcxE+zEYfc="
}, {
    "num_cand": "U2FsdGVkX1+1bH+TOChNsjB9lNa2DywDqa0vGs5fom4=",
    "cpf": "U2FsdGVkX1/siun0+j8elj0hYhPGMHXFMiejk/PmQ3o="
}, {
    "num_cand": "U2FsdGVkX1+f3w8TFX3gVcv/KT0KpILubFqAPrEfV0w=",
    "cpf": "U2FsdGVkX1+2YPj8aIWkjSlzxqUxvAEv9DmDC3AavY0="
}, {
    "num_cand": "U2FsdGVkX1/ngHIDwxV4OX5HfYqpeVYBCJDVXmuS5UY=",
    "cpf": "U2FsdGVkX18oCJFQ2rSy3x6zsY6TAR7siUiaMlGGYwI="
}, {
    "num_cand": "U2FsdGVkX1+SHB3L4TTTA8bbAyEKKhHfunSah/hP4ps=",
    "cpf": "U2FsdGVkX193Atnhey9yFuNnDrK73ve9pk2q2++hCHw="
}, {
    "num_cand": "U2FsdGVkX19EoZGxAK0WgkhXTjNCiDHMXA5lxpX84uQ=",
    "cpf": "U2FsdGVkX19LiJCMgSuVPuPn305A020RmhGGzKCGwDM="
}, {
    "num_cand": "U2FsdGVkX18bIb2ZzMThurhEr1pwdCdlj/xEzLMPqZQ=",
    "cpf": "U2FsdGVkX1/ts7oKAucd0eZiuT0Dp0cZ5DjFtB5Ct60="
}, {
    "num_cand": "U2FsdGVkX1+bqJMXh62UVQEsYITIiN+kREzklumRHj0=",
    "cpf": "U2FsdGVkX19pyprituzPjY5XPZ4cbmzNk3t05AlKc8Y="
}, {
    "num_cand": "U2FsdGVkX1+J9JjZ+X6llxvStvZ9UDKg9KKb7knrW3Y=",
    "cpf": "U2FsdGVkX185Q8LWhYLOhmiunkgQBMfuoNmUODJhoMk="
}, {
    "num_cand": "U2FsdGVkX1+h+KwX0uWnWS/ynuwSm+Jkd+6XErbYQRw=",
    "cpf": "U2FsdGVkX19NZ30OhpzcZCYt10GGXmDzUXNdusn067I="
}, {
    "num_cand": "U2FsdGVkX18qkXxCNN0g4lCokfzPHHFNB6rH9Z11ScE=",
    "cpf": "U2FsdGVkX1+Q27lcBiJ12JUtZQlRWrCzbMsFfyeGFOQ="
}, {
    "num_cand": "U2FsdGVkX19OBppxiSlnCEgTyiEhCf0m2fQS1Vtum64=",
    "cpf": "U2FsdGVkX18LwOkoE+reKAPTnZL/LSB+GZPnzk5RkV8="
}, {
    "num_cand": "U2FsdGVkX19KfcG812xpbBhqBqt44RqvfgL4jrfn4S0=",
    "cpf": "U2FsdGVkX18yMGW7F9vC53Kz7Aq+ksLUiW23pR9oTnc="
}, {
    "num_cand": "U2FsdGVkX19sr/FPZfNSmUpFLrXWyAWs/1FAxD/Z89Y=",
    "cpf": "U2FsdGVkX19OZqfTdwOjcHHOSpQXjQ5FmREVKsFAWNE="
}, {
    "num_cand": "U2FsdGVkX1+F94iqrQeWQELP42oRuE6jzE617GDEjRk=",
    "cpf": "U2FsdGVkX1+J7hBMsuff6ZR/d5HAJn0eJ1tO57noav4="
}, {
    "num_cand": "U2FsdGVkX18kYQNr/QvfmyQgIrnGsURHCj7ARTj9imE=",
    "cpf": "U2FsdGVkX1+W4Vb+KR4uLhFEzyoYt40hJ6z8qT1pQu0="
}, {
    "num_cand": "U2FsdGVkX18CHWj62DEdhQHuV4ZuwhpnGIk21uihfX0=",
    "cpf": "U2FsdGVkX18B+alrGwhlw/sGiEaPjd/aI+uL9PLXQUY="
}, {
    "num_cand": "U2FsdGVkX1+x0jFEo0wxna5Hq+JMDT49JcDCtUVkcWY=",
    "cpf": "U2FsdGVkX1/4cTKnfnwt8cH/kKDpXIorPFCjSvnUAZY="
}, {
    "num_cand": "U2FsdGVkX19boOirlIH5/t0Z/NcD8II9OeXHxUONnio=",
    "cpf": "U2FsdGVkX19qDmwJnvIyZTjDpLcvrSc08Bu2uvezieo="
}, {
    "num_cand": "U2FsdGVkX1/DS5SLVgPL0u5d7Xql7Kx7Ly2DxiZHK4M=",
    "cpf": "U2FsdGVkX19qZDbhi586LgmHXSjgGVp+eTQd45hHiIY="
}, {
    "num_cand": "U2FsdGVkX19GV0jbMT5wGL9QBePz1wW1eBXIat+F+QA=",
    "cpf": "U2FsdGVkX1/hz7qCQL77S0vmYIQItVWmQFDtC0s2UiM="
}, {
    "num_cand": "U2FsdGVkX1/xjgFbQsrptg9GExyWDvBFBC0x1jKGOLo=",
    "cpf": "U2FsdGVkX19MoChgaC5ABaB6fZVRv/+iaqH4smv6LMU="
}, {
    "num_cand": "U2FsdGVkX198xRn9H7P80S8/1TjDmzrggdeH8Ha0qbk=",
    "cpf": "U2FsdGVkX1/XgD34ADPC77FdWc83lbAtmMVIAi59JQI="
}, {
    "num_cand": "U2FsdGVkX19OhyF40ok+j9MGyZhaduelxMUPPcXxEIU=",
    "cpf": "U2FsdGVkX19jDLWp/KHnhIFL4rtyQMcBoUf7vjxgbC0="
}, {
    "num_cand": "U2FsdGVkX19UJQStyCUrRpo7BcstLZN9wx79sq1Th90=",
    "cpf": "U2FsdGVkX19ZPA4t9w5H1+ZimMBg3vo1HhGFz+eszcI="
}, {
    "num_cand": "U2FsdGVkX1+OrlPG6wlHyfwHkHv9pXzBMk/SwCmaVWM=",
    "cpf": "U2FsdGVkX1+y+czhkKgqNxYmWhZtM9n22Nr9sJoNb6U="
}, {
    "num_cand": "U2FsdGVkX1+8GPScIKQPoAdKppR4cnn33m1CFyo26zg=",
    "cpf": "U2FsdGVkX18qWHRVa8LmvOCvc1SOFsp63CCNrKgq5Fc="
}, {
    "num_cand": "U2FsdGVkX1+YGH2vEk9QPZDi5UhYiMpgIG1SrCVtJLM=",
    "cpf": "U2FsdGVkX187QYpb10XOJzIvc+vdtMmJ+A7U5lmyAYQ="
}, {
    "num_cand": "U2FsdGVkX1/+ZP3UJ/ie912yIuTjwfzMKn1Rvrrdj4A=",
    "cpf": "U2FsdGVkX1/e7jEAgsB7hCYqZK532blV3JmaewDLgdY="
}, {
    "num_cand": "U2FsdGVkX19DjhcBWYxvJtmRhhML8Nl0eTW9FNxmvaA=",
    "cpf": "U2FsdGVkX1+FwBN7niTRGriPHhVxXtxBcClNpw8AyAs="
}, {
    "num_cand": "U2FsdGVkX19MAneHkr85crONYDJhqAmveuMMchd+sQs=",
    "cpf": "U2FsdGVkX1+WZ0kpfwbumkHws7UAhf94LGvCddqU7Vo="
}, {
    "num_cand": "U2FsdGVkX18nGWRy1cshPMNOqToKVMgj/F6ochIYua4=",
    "cpf": "U2FsdGVkX18FNZojjGnrtupsXPH0yDv+a1Um3TXzNsg="
}, {
    "num_cand": "U2FsdGVkX1/zgPW0Ah77GSyU3/dZ/53YfhZwVr1isH8=",
    "cpf": "U2FsdGVkX1/7D0lHPgHhyYVuXk9raL3ATgSrGqRHyyQ="
}, {
    "num_cand": "U2FsdGVkX1+B15YbwTFAF3/ojBIpWsyFXkB1vgd90U8=",
    "cpf": "U2FsdGVkX18F2I0IfQoujXHgd7S0p893W4GnBpnfjXA="
}, {
    "num_cand": "U2FsdGVkX1/fnavOUqBwogtGzW0qoRQ51Uk51AAVAI4=",
    "cpf": "U2FsdGVkX19ty/eyqNnyp49Y9zHdSHXacfTp8TTFvEg="
}, {
    "num_cand": "U2FsdGVkX18vG0uSkfsLERhMBYQT+xueHYzKfdUG7Z8=",
    "cpf": "U2FsdGVkX188N3liK02NoQ/KzFJ0+GR9Pdy2c9ZcK+w="
}, {
    "num_cand": "U2FsdGVkX1+0kwG8dE0DyG3B2dfyquGwEcPO/rGsEwE=",
    "cpf": "U2FsdGVkX19QkMVBSAUews8LclJQKr6H+10jBvz1UYo="
}, {
    "num_cand": "U2FsdGVkX18zT1R6HetS4q2x4TJO2rg9PSeXvZsMVlU=",
    "cpf": "U2FsdGVkX1/vTj3ABbJpiD5sljV4qT/miG857Oyps5g="
}, {
    "num_cand": "U2FsdGVkX1+irJfrZxIn02cVNc1TZf3Ko8qXHP1Dg44=",
    "cpf": "U2FsdGVkX1+ecQb3oV+tURQDAj54hpAct5RyTeVr0D4="
}, {
    "num_cand": "U2FsdGVkX1/CmBugmwf5TFbabb3Z/OnsVgdMeDxLBhQ=",
    "cpf": "U2FsdGVkX191cPLNBmriXdbaDoYyKUJTtI9Dp5foIHw="
}, {
    "num_cand": "U2FsdGVkX19Z5HVca6jhN9Vp6OG9HycYmlWtxYwK4co=",
    "cpf": "U2FsdGVkX1/elm+gIHGsgjlX7354pzwyAKIfZLZLL6o="
}, {
    "num_cand": "U2FsdGVkX18X3I0kJPyqukMMw1p/vx7im4rQU6vuFbU=",
    "cpf": "U2FsdGVkX1/xWEV9m72Yaf09V3QxBRrTmvuOLPiFFKk="
}, {
    "num_cand": "U2FsdGVkX1+XKDQIFbMsuzfLkSQwhcaDl8Eg9FDBEB8=",
    "cpf": "U2FsdGVkX19MV+sVZK0IcjxVNEXxldsjZh7+eljo6rU="
}, {
    "num_cand": "U2FsdGVkX19Ef00VYBV+ogepuvvxi7hyCxAoTbpqae8=",
    "cpf": "U2FsdGVkX19wBFC+ZSBZq2fla5kuISli0z0Ojp4VP9w="
}, {
    "num_cand": "U2FsdGVkX1/jMhXuHq0I1dtEF6kGC7s0J6aHq5n3uFU=",
    "cpf": "U2FsdGVkX1+Y8fR/Apfmm2LmT/YfwtObTEY0o6T+RP4="
}, {
    "num_cand": "U2FsdGVkX19aMu985BZ9HL88JkfAVU04JeUS2a8beX4=",
    "cpf": "U2FsdGVkX18/A5eIc0Oi8CS2NptopIGxwrDc+9hx7wo="
}, {
    "num_cand": "U2FsdGVkX1+giVgg2wcTPzoTLlGBeIXoxo5SrbdWxCA=",
    "cpf": "U2FsdGVkX19+1pSW2ppDkD1aq+w39j9ZZFCmd2pgZJA="
}, {
    "num_cand": "U2FsdGVkX18yt4BOIHxaIw7dQ5NLsh1Z64l874GcT6A=",
    "cpf": "U2FsdGVkX18kD0IiCT3qtJaVeqVxnL0HHdovsHyyMAM="
}, {
    "num_cand": "U2FsdGVkX1/izorKmSvgraHbPC7/l5tLlEFs4mmN8zE=",
    "cpf": "U2FsdGVkX19jFEHqtaPYYsW/gdEds4dbiUVG6BTHlmg="
}, {
    "num_cand": "U2FsdGVkX183Cn5p5xWkP6QLiRQ8o9XRCaV9BILRAp8=",
    "cpf": "U2FsdGVkX18/hBU1IZvcZfiHCEhaOX00I7RmVMgslN4="
}, {
    "num_cand": "U2FsdGVkX19V62h8247LGD25C3y+9jHOYBUb0FnVeqg=",
    "cpf": "U2FsdGVkX19y5WMbbkoPJtPFNzWMA5jHjt8lGaT3pmA="
}, {
    "num_cand": "U2FsdGVkX1/TZZxfXXs9AO32aBUR+6SxeUJNheHenxM=",
    "cpf": "U2FsdGVkX1/V4PRLwHQrPB9yRBi5z17qUjHeKLU3FbQ="
}, {
    "num_cand": "U2FsdGVkX1/WrW1ZOTbnzdsgI+AI6ELJO84hzDvFj7s=",
    "cpf": "U2FsdGVkX18PqGRzQtHqTQajDwqHvrXtnrRjyq2M6YE="
}, {
    "num_cand": "U2FsdGVkX18+nA3eELV2gdzcpYKsA0j2qnLzGugA31I=",
    "cpf": "U2FsdGVkX19t2N6E1YWLUm7SHZxnvdBZr/hGpIwKHMo="
}, {
    "num_cand": "U2FsdGVkX19h7g8teZSaAmGOG/F/iWxzW1rH58sCvFQ=",
    "cpf": "U2FsdGVkX1+v2oRajxPAWE4Qp90rB0lXmCIxkRhw+b0="
}, {
    "num_cand": "U2FsdGVkX19zHfkyGIPm2wL4AC0WcAQ3ic1OSkldsoY=",
    "cpf": "U2FsdGVkX1/jfMpkXFCOTBjNKmVGfLk+eWiwE/6i6so="
}, {
    "num_cand": "U2FsdGVkX18C/EYwhGzt4RjXwshSkOtA+n5PvtDGnRQ=",
    "cpf": "U2FsdGVkX19kIciYpwDu7ZHbml83IB/7YtABlEQvBiQ="
}, {
    "num_cand": "U2FsdGVkX1+GryEv208vuk2sJ2HIs2vCpGnGpyCd72Y=",
    "cpf": "U2FsdGVkX19mM/MVzyqVFp31D5iOr5rGKXV7nWI7uM4="
}, {
    "num_cand": "U2FsdGVkX18z+4u9MB24st6p4QPkqCGJPEkaLBkpEj8=",
    "cpf": "U2FsdGVkX1+BVuYlGiU/LxMlyluUfe/JMdcjDlpGwvM="
}, {
    "num_cand": "U2FsdGVkX1/xHH0FXQuVvCA4e747/+504hUymzV1f0M=",
    "cpf": "U2FsdGVkX1/86l5xO16UeZfMJF+pX2Xh+VCe1xI1Ok8="
}, {
    "num_cand": "U2FsdGVkX1+4joyL3s4YbTrgF0Es9Ks4FY9jOvGm7xw=",
    "cpf": "U2FsdGVkX18e1uqmxgg3GZI9EOKc4hkE12yObxtSFkM="
}, {
    "num_cand": "U2FsdGVkX18Pa9vcST7wXA2WAY28Orfn/0MpTKtPhAA=",
    "cpf": "U2FsdGVkX19HtpvzW6+3/ZznyiM3AWolUenSvkg/quM="
}, {
    "num_cand": "U2FsdGVkX1/O+/egrsYTfyHuhFxI2F7oMCNJRMnLpXI=",
    "cpf": "U2FsdGVkX1+1Mezz8rpX6FvcURVpMse50J4nMM/orIM="
}, {
    "num_cand": "U2FsdGVkX1/osT33SArag+tC9iaDykViWrmEhGqJuno=",
    "cpf": "U2FsdGVkX1846dOFNMXLivuVy2nTBbGZxQ2MqJduLzE="
}, {
    "num_cand": "U2FsdGVkX1/v5Vh6pG4UZn2ESnysKNCJmza3BuhgBrI=",
    "cpf": "U2FsdGVkX19suQUU7IdBjVIVW1lz0Lf2rsbLni3kc3w="
}, {
    "num_cand": "U2FsdGVkX1+HfZf2CIGk6wLmoTN/byXhoEtLmJnl+tc=",
    "cpf": "U2FsdGVkX18xQI4X60ZY5Msh64Gnxxo1UvHEfpoTOeA="
}, {
    "num_cand": "U2FsdGVkX19wCJsASrKV+7bgEKVfXKdiGld8qjSSpwM=",
    "cpf": "U2FsdGVkX19aG6mefTwAMvn9MxNrK3P2zOpJp4rMtzc="
}, {
    "num_cand": "U2FsdGVkX18lS9j4gkLRgQGwFWd88coclG+C45ASX1E=",
    "cpf": "U2FsdGVkX19SS6Jkb0xBDNvyFLaHiH/xd4u/4WPWh7w="
}, {
    "num_cand": "U2FsdGVkX1+nYo3e6Kupf/bcv6bfBjho5dE3nUVOf5Y=",
    "cpf": "U2FsdGVkX191nqS+1r09PMVq5PLbMdnLLSsrlNP+0cU="
}, {
    "num_cand": "U2FsdGVkX1/aUTrwLkvcF415fIanelJSjOsXIT+xJbc=",
    "cpf": "U2FsdGVkX1/sbThNcQHDTgm3Gt1YVp02pzHbWJswJLQ="
}, {
    "num_cand": "U2FsdGVkX1/2kzVar1xIJWrU1MNW2vBepmAa7ex/fgg=",
    "cpf": "U2FsdGVkX19gNtw/pUteiezt6Ut7l0LF1aGr5+VMRJI="
}, {
    "num_cand": "U2FsdGVkX181nHLix7A277Z6wDcAKaecW9GQ1S72A68=",
    "cpf": "U2FsdGVkX19JMtNckE9LvOGd66oOgi9uTW7ImtKGw6I="
}, {
    "num_cand": "U2FsdGVkX1/dIHuNRHHhszHViVOYyBNA0UE+x0y9nN4=",
    "cpf": "U2FsdGVkX19/utGfxGU3Gf7J3xSeORz9EX5O67ews3Y="
}, {
    "num_cand": "U2FsdGVkX18W+LOUSVT1+yClbs1OPXm7g4Turj+i/wU=",
    "cpf": "U2FsdGVkX19pdCPp4rwBXvtc6n7/Vc3lJC4SAmiID+g="
}, {
    "num_cand": "U2FsdGVkX1+jIX1Ft8/+MKCT0GwRNmFT72dg9iiplDE=",
    "cpf": "U2FsdGVkX1/VbvbvVAJZmTtui8u2djXChv1xAPIyDjs="
}, {
    "num_cand": "U2FsdGVkX1/qnB3hqSsQPP5jdtZAwv+CdkKN8d9/7jc=",
    "cpf": "U2FsdGVkX19fthVfszrQZv778a5GGdefx9wH9VJalqE="
}, {
    "num_cand": "U2FsdGVkX19A0Eq2foD0UboQUEAXsziErWictRAq3bk=",
    "cpf": "U2FsdGVkX18mRzLJcziL3P1l+4pco1tJq4quKv8OBHw="
}, {
    "num_cand": "U2FsdGVkX196/wNrDcqqGOn6BxTTMFP5KXSMLecWygU=",
    "cpf": "U2FsdGVkX19yabTR104uKy9Qs/OQXsUtHHnR43AEvsI="
}, {
    "num_cand": "U2FsdGVkX1+mF0IuINx4xpHdMuQDaWn3q8CAEn2lK1g=",
    "cpf": "U2FsdGVkX1+JA6djjhAw4JoOU29iKshDwdWTh7B/tfw="
}, {
    "num_cand": "U2FsdGVkX1+cVtT6csW0Sy6Njq8vsUItUUh5jnrU+ww=",
    "cpf": "U2FsdGVkX1/+65fcLv320OWdiiM7e/hE19tOkMIn32I="
}, {
    "num_cand": "U2FsdGVkX1/OkFPhuzK4hysXH7u4NFmgutilBfRmvPo=",
    "cpf": "U2FsdGVkX180kVNN75WFtEkcmKcBWQmpLfSnnJE/IQs="
}, {
    "num_cand": "U2FsdGVkX1/62uuEQvT+oueCJbld2Pgllr4h7e+4M8o=",
    "cpf": "U2FsdGVkX19fuS6Kc7bYpEPijdldo+HhU6lDH8qNBAg="
}, {
    "num_cand": "U2FsdGVkX19UzmpTDOI7mk2aHZiZGHbdwYAPhByMS1s=",
    "cpf": "U2FsdGVkX1+7F5QJveIuR9Lg4kOLgYwwL0Bsk5vxTGQ="
}, {
    "num_cand": "U2FsdGVkX19ra5lippWNxcvkM+uRnAPMX4IpGgvVqU8=",
    "cpf": "U2FsdGVkX1864AQuDI6H4EO9LYFWMR8FN4u5y/DbA90="
}, {
    "num_cand": "U2FsdGVkX1+H1KNtohg2E0Gam4Mq3a9s8DmTArqpS20=",
    "cpf": "U2FsdGVkX1/6xl/InFuLDj/cVFnFUDVe03tyu7TlQ5s="
}, {
    "num_cand": "U2FsdGVkX1/OqhgFqQh6TljAREdJPC4e3j20nypfEpM=",
    "cpf": "U2FsdGVkX19AMwVPF+rth+mpGNKijbPBcdQVdPgKMPU="
}, {
    "num_cand": "U2FsdGVkX1//MiAgSItF3ORQ0sonbbFGl9KCqRcM0dg=",
    "cpf": "U2FsdGVkX19K6Npmxd8/UY7sOnCjNRC5D8wURCwfSdE="
}, {
    "num_cand": "U2FsdGVkX18JZ0YF7fcqYypHW6rY6KWVIIEHSraNN3M=",
    "cpf": "U2FsdGVkX1+WuhSYhU6G5w1FwssLfLXESa8coTTBXSM="
}, {
    "num_cand": "U2FsdGVkX18S7EIdQgUyjyfmz4tf7mJ6XFyq6OU7b7I=",
    "cpf": "U2FsdGVkX191rIDGa5Pwt9rqG0fq2CPWtxi6aYoOR3c="
}, {
    "num_cand": "U2FsdGVkX1+cnqbcNeIuZvRjTRCsoz0B4mq3z2Q0qf4=",
    "cpf": "U2FsdGVkX18Y+JSSyc8U+pc5jXAnax304Eu2xCZnL80="
}, {
    "num_cand": "U2FsdGVkX19GlRYBf8xwSSDyJu4CtcPFWOOkp6vRsYY=",
    "cpf": "U2FsdGVkX1+Uzua+bYZQXgTwQg/zCAWRtVW63vKiEck="
}, {
    "num_cand": "U2FsdGVkX18J0sDqhGkt1fHTlUAEk7CZDQenFpXB5bM=",
    "cpf": "U2FsdGVkX18zTWiCIRiH8+30vD6kaa+nbWUzYtvgVPI="
}, {
    "num_cand": "U2FsdGVkX19rDNbsP7thlpOfQRv6Cp/XzL/RjOku1UU=",
    "cpf": "U2FsdGVkX194EP/keXJUa9AqpG/VfRW5Y0jWH8wW31Q="
}, {
    "num_cand": "U2FsdGVkX1/tIoarXYeiJwC0QtTF/xwk9Hnf3y2SD5M=",
    "cpf": "U2FsdGVkX1/JVT+58U9uFH9GnXvtnZVYbIXcjnZR6rg="
}, {
    "num_cand": "U2FsdGVkX18exKf99fDXJ94UNP5/q7WELH6VIP85a1E=",
    "cpf": "U2FsdGVkX19RTO4u1YhV4n9xtztLGI9FcCzCz19WVfY="
}, {
    "num_cand": "U2FsdGVkX1/pMl3iyCc6FJPoa5E9NauLnWhw3bx1US8=",
    "cpf": "U2FsdGVkX19LKOCXmZ5PtMRufX4giWorRh10YTVvrGg="
}, {
    "num_cand": "U2FsdGVkX1+IDDH64Kw+XURuvCaNpMUlR+YW1ymKwJM=",
    "cpf": "U2FsdGVkX1+lpWxrhH0d6Z1/wdcbH128L6gyVzdG7rk="
}, {
    "num_cand": "U2FsdGVkX1/NvdN3NGoe6CizgcMgN/WIJsmSWoA8SFA=",
    "cpf": "U2FsdGVkX19QtCbdKgv6JmbkFD8AE6gRhs2EOoIYWbs="
}, {
    "num_cand": "U2FsdGVkX1+KcLfVnIiDiPVVACLHGYDYkAcdllMdQGk=",
    "cpf": "U2FsdGVkX1/SoAgcNlIuvrFulXCtavMrDGyaIWdv9xo="
}, {
    "num_cand": "U2FsdGVkX1/tMOw7ApbxTMGNS1xzlH+8cCr9iufTOxY=",
    "cpf": "U2FsdGVkX1+TrMNaIGO0TzPdbXrs9+0PAn6WAhKmu+Y="
}, {
    "num_cand": "U2FsdGVkX1/vcln4Xa51lJ1S6w1sHKbPbkJhkXZ5DG8=",
    "cpf": "U2FsdGVkX193YdACOSjbQg5LRnLMog21CaIRiUGb8RE="
}, {
    "num_cand": "U2FsdGVkX19MmENFI/a9sNTJ6QGgW5p6eyy6Tac8MMI=",
    "cpf": "U2FsdGVkX18ppoJLQd5sqEA/51ArOsSp1RGUju0J8mM="
}, {
    "num_cand": "U2FsdGVkX1+5anqzO+t9//Rf8WUMF+oVYOqb+N3JVns=",
    "cpf": "U2FsdGVkX19+7TxYWW2f5te4Z8wOdpWqfBcD1hE2KfE="
}, {
    "num_cand": "U2FsdGVkX1/KtTIjK7+4Po76Y1tOT4DLxg0rvwfZ4iI=",
    "cpf": "U2FsdGVkX1+j/HWyCugoN0AIJicPXYTRemx9zJPi6Ws="
}, {
    "num_cand": "U2FsdGVkX19x/g+831+CGirAJm23CsgRH3UKMDBHgf8=",
    "cpf": "U2FsdGVkX1/ULoe3k8uFEmWLKoFYJo8CHxK7SmdS9Aw="
}, {
    "num_cand": "U2FsdGVkX1+HR7XlQNkRbrwrWUfHqos7maiwokK4T5o=",
    "cpf": "U2FsdGVkX1/fccADO0HnWmkQMZM2RNIlL9prmiTp6a0="
}, {
    "num_cand": "U2FsdGVkX19desvKJIPrjFYOoPlu4pyi99MWTKzl9hM=",
    "cpf": "U2FsdGVkX19KpCBt6vXP6SJTR0siGYIo9KcgL8DJVmQ="
}, {
    "num_cand": "U2FsdGVkX1/F3xUa9iqoIbWvjIRgSWxlfdt2HGxt8sY=",
    "cpf": "U2FsdGVkX197FeZ+MCev7Xk3A1M7pVypvikRUkuYwCY="
}, {
    "num_cand": "U2FsdGVkX1+T77w+IFRZFBJRjw6twJs4rNN3nVcgw6s=",
    "cpf": "U2FsdGVkX1+dnpHYcAhYQElPwiey1H04BZBOSTgWRGs="
}, {
    "num_cand": "U2FsdGVkX18vIoFNZjWCfuLpDlkkz4v8NksLoo+06AA=",
    "cpf": "U2FsdGVkX1+HED/zgOKGKfsBvmdfSjJwoRSuZ5eGU+w="
}, {
    "num_cand": "U2FsdGVkX18QNNUYHFYWbHh17ZwmjwuQgzb9F06af+g=",
    "cpf": "U2FsdGVkX1/SVs2QByznrczYaLeUwInF6gB+GMyt8Ws="
}, {
    "num_cand": "U2FsdGVkX1/SCISz8S0wh8nD9RC0Y6Xcoo++sRTuKvk=",
    "cpf": "U2FsdGVkX1+SJ1CH6Sf5k5jHRFInGkaNeQv5Xk4KlFQ="
}, {
    "num_cand": "U2FsdGVkX1+8w+mDRNt8UxYhv/3+DaHnjK/2bg2E5nk=",
    "cpf": "U2FsdGVkX19yj+LFfvrkOQdn1gkUeGd/R1vRm5R6bwA="
}, {
    "num_cand": "U2FsdGVkX1+jNfA8mABP0jSmBFNRGDC6XgY4BW0tLRY=",
    "cpf": "U2FsdGVkX1/e0aCaFC2bIVuOaK9q0v70ck2KrqLmU90="
}, {
    "num_cand": "U2FsdGVkX19wktJ2wz8tquraN4rZPXwuJLVlb1c33BE=",
    "cpf": "U2FsdGVkX19ApEW9qxOmVzCxKSMSLnhAvGkACWLSG4o="
}, {
    "num_cand": "U2FsdGVkX1/FoYd4QXaAGSA2+gcag8PUJPpJ2iKX9pc=",
    "cpf": "U2FsdGVkX1/vyH86RHABDG/Wajw1vK6bLpU4Y4pozzE="
}, {
    "num_cand": "U2FsdGVkX1+u1R15U9U+nG/R3um4KhxWn0gbLIpjoZ8=",
    "cpf": "U2FsdGVkX18K+RtYxAG+OUYrx8SlbXYiGKOUsZL42sc="
}, {
    "num_cand": "U2FsdGVkX19q344J4CUswZ88yAnKKZmGuYOqvSjMVI4=",
    "cpf": "U2FsdGVkX1+1XcsW9/RMbNZqXXQzl6GUV0H7tYNiOl0="
}, {
    "num_cand": "U2FsdGVkX1/nBGak1S+dYsOvDo4Db0L4hK4Is71zCO0=",
    "cpf": "U2FsdGVkX18MmkB6WRA10MNqwBu3bEm51HutgQuMla4="
}, {
    "num_cand": "U2FsdGVkX18ZQ/CPUb/tbY8o1RWoiPwqXu3EABCQ5YI=",
    "cpf": "U2FsdGVkX18pQsAVV0a/w10BH/0xOXUacgg1JDJecaM="
}, {
    "num_cand": "U2FsdGVkX18XAWCCyeP6XpLc49rYT84TS9SH2Hn5PUE=",
    "cpf": "U2FsdGVkX1/LekWIOCVddyoYRx0hbiGuFUj9X55SWUg="
}, {
    "num_cand": "U2FsdGVkX18gybSSamKGPhS7bC/vBH9aJvxWxEubpio=",
    "cpf": "U2FsdGVkX1+mYR9ksd6rPlHaVailzHdCi30zHiXa2zw="
}, {
    "num_cand": "U2FsdGVkX18cgvPppgU7J8umYH/uuaGwkDnWZN7p4FQ=",
    "cpf": "U2FsdGVkX18/LEQoHfraTDvdDETbWCqt4IPMiayfEsE="
}, {
    "num_cand": "U2FsdGVkX1+gXNQDFvTd2F+xses1oI0qNe7+CphAJjs=",
    "cpf": "U2FsdGVkX1+B6dodia8jyYb+3ESeKpPROpTwORzevUc="
}, {
    "num_cand": "U2FsdGVkX19rC2AJNv2/PJcVyOaSWQ0AP/l5hthlZPU=",
    "cpf": "U2FsdGVkX1+nfKYICBkO6WRoepJhbQQ+W+b/bRaJhH4="
}, {
    "num_cand": "U2FsdGVkX1+2kO0IrJI7n1YB/yj8fiuBo3IJHPAhGd4=",
    "cpf": "U2FsdGVkX1+b16k5zfMm2pDNU9qwgD9xA1Xm3Vv7XWY="
}, {
    "num_cand": "U2FsdGVkX19i8qFQGh3y030BE+mtzgM4QHMgpX4sHGA=",
    "cpf": "U2FsdGVkX1/ZiWKGDAAF4kg69vdpIN30cxUVSlWlgvQ="
}, {
    "num_cand": "U2FsdGVkX1//ykI0KFULI6mR7nTwKQZY6xZs8PuJlQw=",
    "cpf": "U2FsdGVkX18golaiPwcX2OZHQFKgWIU7hqQVz/TWgi8="
}, {
    "num_cand": "U2FsdGVkX18+aQRVwh8EW/HxtadCGJI7IMoksa+jJGk=",
    "cpf": "U2FsdGVkX1865pgkks312ygZcPaStDY8GeZDh8o/H+4="
}, {
    "num_cand": "U2FsdGVkX18cf1fI+8Nbk0mus1xZ0+ydXPpbTK+KL5U=",
    "cpf": "U2FsdGVkX19p9FVPHseFkSZFcALuTfyfLZTORM9Ef7k="
}, {
    "num_cand": "U2FsdGVkX19MWQqK7rEeDY9Kx7+iaxwpExwzSziyXpo=",
    "cpf": "U2FsdGVkX1/fRQgT4+TiFN4Bp80xFhIeJFRPtrCYAs4="
}, {
    "num_cand": "U2FsdGVkX1+WLApFT33HnMXWRMAE0hs1XaFw5lgz428=",
    "cpf": "U2FsdGVkX1/3y6o4otqRwMu+G21Lr/CQFgYtux8kplI="
}, {
    "num_cand": "U2FsdGVkX1+1KJ+p7/+Zw+qjq/A06lP3k6ODQ83gkP0=",
    "cpf": "U2FsdGVkX1/fq04shiK7up0QdaAQGWu8GGhI2Rt3u0A="
}, {
    "num_cand": "U2FsdGVkX1/l6odTgiMzvGWEO44c6vXHQAox2FyOtvE=",
    "cpf": "U2FsdGVkX1+DLL5jXdoOjT7OXa6kSL12IAh/480D4vI="
}, {
    "num_cand": "U2FsdGVkX1/Q8sagCwnLk32jZrmtWl/gx6oHJgkTEsk=",
    "cpf": "U2FsdGVkX18rOmWFr8jVmfPWrF3nou5dCiEePkHEBSY="
}, {
    "num_cand": "U2FsdGVkX1/WWV+FX9HHh+ZkobSml4GJg2L4Q5jhkgk=",
    "cpf": "U2FsdGVkX18mpiyacd2labWYnko1ANiPvqzZI28YDaw="
}, {
    "num_cand": "U2FsdGVkX1+HnkFvYPn9JQgeOW5buNTSP4ULv4Lv3g4=",
    "cpf": "U2FsdGVkX1+pgSTkjiWT73nqMQtlLNylr/WMCvpTql0="
}, {
    "num_cand": "U2FsdGVkX18sD/PN4p1LxoqLvWoThp7GjPvgq9S0TIM=",
    "cpf": "U2FsdGVkX18p8aSVwafSVjT1MUEumVYDdT/oBpjzaag="
}, {
    "num_cand": "U2FsdGVkX1/EFva7HsckveVZVLTnK2tmdHGLLkZzjtQ=",
    "cpf": "U2FsdGVkX1/E1Cgqfgwb5N8+zHaL56R4ImlHYEmAxZ4="
}, {
    "num_cand": "U2FsdGVkX19jHgULWQZlw/GLrDRaa+66ZJvAnGHMw7E=",
    "cpf": "U2FsdGVkX1+SDcVdZ7OKwnl+Ln/N+2T7dhCJX8JVe24="
}, {
    "num_cand": "U2FsdGVkX19+w9OZrHrAk28jz+NR5rsvzSH/7eUKY88=",
    "cpf": "U2FsdGVkX19TlYMZbo2CQlnO3EbKDfDcE799gxQk5/c="
}, {
    "num_cand": "U2FsdGVkX1/IiUZ+MwP7Ja2W37mOTooK4szpPQ0QQKI=",
    "cpf": "U2FsdGVkX1+wtKeNfCGZ3JdlTs0C44ZjDZR9HAazBFU="
}, {
    "num_cand": "U2FsdGVkX1+gOqto3BFuVHnYa8TK4rKZEMDnwBkVWvU=",
    "cpf": "U2FsdGVkX1/r203UVEVQVJd1yiHpA+rHKspdbqiiDiQ="
}, {
    "num_cand": "U2FsdGVkX1+WwteJirYsbBg2bwXJts8BFYnqwP+Vpjc=",
    "cpf": "U2FsdGVkX18nG3TGQceJ/H2EndI18+Ju+sHcqFX8Kqc="
}, {
    "num_cand": "U2FsdGVkX19Yx33qsERGNRq4Jn7HstpufkZdy9LNMxQ=",
    "cpf": "U2FsdGVkX1+gjCiHeoFQcuLxqKewav4vlVtSD9XI0/0="
}, {
    "num_cand": "U2FsdGVkX1819WYsAQVUGry8qkLudwhCJucV4RUccpw=",
    "cpf": "U2FsdGVkX1+e8X8cscwMwEKcj2i5MUZC8+SAnfbJcyw="
}, {
    "num_cand": "U2FsdGVkX1+A6xFl2L7QrMIdCfaeMcGCRubtD4B1wjE=",
    "cpf": "U2FsdGVkX1/6Vo48K7dic2Ilk0ZAVwTc9pVfLCuPx1w="
}, {
    "num_cand": "U2FsdGVkX19PDr+Ok57Rq8z+ILSGcm2lkBeoGIWgefE=",
    "cpf": "U2FsdGVkX18f+sjJgcIA3W8VVLPFGX4hv6TsWP8PWuk="
}, {
    "num_cand": "U2FsdGVkX1+F/o1fOdp4lQj7RuAriyq+ZZcPDUCWrrU=",
    "cpf": "U2FsdGVkX1/QlVc+rq8QCS9Guv9tJO8X4abSCBrTIXs="
}, {
    "num_cand": "U2FsdGVkX1/JkbCspaI8bsEGyMHgGB2xWyi8Is9D1uE=",
    "cpf": "U2FsdGVkX19dag6+RCwlDWbi4PKk9ceZHTuJk59m1xc="
}, {
    "num_cand": "U2FsdGVkX19exNkQ/XaspKtpPbU9ex1/MzIzGDAXCBo=",
    "cpf": "U2FsdGVkX18/lCiJK/88on5sjIJsiIKZS8XMIyc525g="
}, {
    "num_cand": "U2FsdGVkX1+8yATYJLdtWwnOvKoT6b4wxbyMppW4zoU=",
    "cpf": "U2FsdGVkX18rN0s+REkrckR3aFIFF4U0WKwZGP87/j8="
}, {
    "num_cand": "U2FsdGVkX19tZzPirvsXluSysex2aQ8PlmhMaX7TswU=",
    "cpf": "U2FsdGVkX18VIOi74DHslJy25cBsLsxzmtGMiQ8ThQU="
}, {
    "num_cand": "U2FsdGVkX1/q+pma2johkCMDmsNtWtie+NzpJn8VDGk=",
    "cpf": "U2FsdGVkX18GOqR2QAuSikjMOuLzyGI0Vchcp7R2eII="
}, {
    "num_cand": "U2FsdGVkX1/S8ukYnSVXAywj4mx2jmIZcU3MQyNQRPs=",
    "cpf": "U2FsdGVkX1+UrzhiBsISp0qyRfvhrjVnCkolefnV1fg="
}, {
    "num_cand": "U2FsdGVkX18gpXukEktvucRjp7o+wWEYIeb3WlG3P/E=",
    "cpf": "U2FsdGVkX19Nx5amRIe1LRZHcErrZeoAUMIHgf+GUO8="
}, {
    "num_cand": "U2FsdGVkX19FdDEw2L/lzOJSOhjYE4bHVE/8PDiBmQo=",
    "cpf": "U2FsdGVkX1+DPHLSIyStQN088RIQahuRfAMfKDSyj7Q="
}, {
    "num_cand": "U2FsdGVkX1+38rhWcXhIk5qBd0lUgKbk2YVtU8c1VaM=",
    "cpf": "U2FsdGVkX18Op1QnZbgDPglFpCOUQfuAQIUdO3/4BzE="
}, {
    "num_cand": "U2FsdGVkX1+IKvFNTyxLLxP5zUztYcZ96Du9E49mp6I=",
    "cpf": "U2FsdGVkX1+KfaG6eI9ccrTHM7+cPO5Wf9AyQzfymW0="
}, {
    "num_cand": "U2FsdGVkX1+i815JuM8tfsgRehziZUpJnql/LVFLSro=",
    "cpf": "U2FsdGVkX197RDkzNDRFBwUYVmE70Xx33M3incmSp7g="
}, {
    "num_cand": "U2FsdGVkX19RNXmzMKDMjeJKbm0gqXKC64dgGPu/TRo=",
    "cpf": "U2FsdGVkX1/QIWqCY9o/w6FPDZu50NhwV90cJqQez38="
}, {
    "num_cand": "U2FsdGVkX1+g6SM4ewv4ItovzbRflCHw0VLEQCgQWuM=",
    "cpf": "U2FsdGVkX1/Ez1FfVUKzzO6exZb2RwGpVBvbSeaVc7w="
}, {
    "num_cand": "U2FsdGVkX1+PwNC0KLjIGxqY4a1xfXU2gps6PwzuQXc=",
    "cpf": "U2FsdGVkX18nD6hRUJOwoivnfl2phl548fBrTSQDwJQ="
}, {
    "num_cand": "U2FsdGVkX19Z7XcsdWzQgmphVpzpYoQDX9JvpH10IlQ=",
    "cpf": "U2FsdGVkX19Y1EVbMvq+9q9ez5a1E+H8ghfpKfxg0nI="
}, {
    "num_cand": "U2FsdGVkX19SGlVJC73DUw2rKvnCafONUfS48T9m4wo=",
    "cpf": "U2FsdGVkX18PoE6P80D3UFzqigtdHz3RGSUbdVF8jAc="
}, {
    "num_cand": "U2FsdGVkX18OQdi582fqB2D6/svibrtVaPzIrkIQSVY=",
    "cpf": "U2FsdGVkX19gJnhfNznQY+xKYM1FoVhxLkkqwwEjpAk="
}, {
    "num_cand": "U2FsdGVkX19E9DwsK+f9XQqxOJow6KcLxUS1D+w+Zq4=",
    "cpf": "U2FsdGVkX1/VhSMM3n/+HnKwaFQcDr8diEvdhGR6dM0="
}, {
    "num_cand": "U2FsdGVkX1++F+xmNpX2F/r39UO0nnRXDPVhphdug9s=",
    "cpf": "U2FsdGVkX1/xY9BHRsBH1eVsw5e7xcvkYEwxpyMfMEw="
}, {
    "num_cand": "U2FsdGVkX1/H+GIIOx26kv38MrlGft91aSzYc5bjPQ4=",
    "cpf": "U2FsdGVkX19stCpOMex6yLaPuUoRV3XVCf4eLzFKvtY="
}, {
    "num_cand": "U2FsdGVkX1+HUPr24fbMczny3tD+E+ez8KwCEkNNazU=",
    "cpf": "U2FsdGVkX19Vmaxuv7agMyfQjIiZbPgmtDSSEGjOMs0="
}, {
    "num_cand": "U2FsdGVkX18eDpC93dLTfnj3NTmvjDviGBkutEtgdbs=",
    "cpf": "U2FsdGVkX1+5U5CDgvyHr1Kn/tPgSbYU+zZ7O4LIjwA="
}, {
    "num_cand": "U2FsdGVkX19PEDyB7Fp0F3jzE7RQIuuHPxGShl7Sgn4=",
    "cpf": "U2FsdGVkX19dj7naHizvyGub8WrJ28aKuHjc0mK6bNk="
}, {
    "num_cand": "U2FsdGVkX1/Bw/l8HTkNeNpHpETXjN6v3m32K+V3pBU=",
    "cpf": "U2FsdGVkX19UAOyHnQyCLKU0ZHg2+eacWZ6WbNAVeds="
}, {
    "num_cand": "U2FsdGVkX1/mmLwJ6rLJzCRBWmh5PPPIoSHrbsq56uM=",
    "cpf": "U2FsdGVkX19fq66C4k4TirsrUHbIakFuR9mn5qHRq4E="
}, {
    "num_cand": "U2FsdGVkX18HA/sHF1glHjIhqrTCgsPz4Ys60mG5p9I=",
    "cpf": "U2FsdGVkX1+3B2DLJKpxfIJFbmKtTm+rIv8csjw6yfs="
}, {
    "num_cand": "U2FsdGVkX1+FnFx7ly3qa0va1bUZbiuq+wIYOSTWVfI=",
    "cpf": "U2FsdGVkX18BDaUSfpKZk7ThSSezObLfdDzi5uPjxvs="
}, {
    "num_cand": "U2FsdGVkX1/XzU1oU4TOyr7M493UGCqxwbDCuBwcVmM=",
    "cpf": "U2FsdGVkX19ZakSQHbqquhYkM19x46Pv9yLNx1tZci0="
}, {
    "num_cand": "U2FsdGVkX197XFBHj/Ng1i0NFmIEVjy7nV+Fdh51SQk=",
    "cpf": "U2FsdGVkX1/4663kU/gPFBSOPnAa8ZTTjRv/8c2nr9Q="
}, {
    "num_cand": "U2FsdGVkX18BfUjmY5Dj+XAM1Dda9CGCpQMXuSbWr4A=",
    "cpf": "U2FsdGVkX19c2Cf/zOytWAe/TblqluE0wHBVG97YAxI="
}, {
    "num_cand": "U2FsdGVkX1/dk+ZJLHLWH6BIi5ZWzxGRXQsdNLYl0oA=",
    "cpf": "U2FsdGVkX1+hZJDl91kXJobUF4GVmbyPmDwj++3kHYQ="
}, {
    "num_cand": "U2FsdGVkX18V9XBxA/kGOBhZ88/8b55MkTg/rQeH6so=",
    "cpf": "U2FsdGVkX1/WnmhEa84JJdvDvx6E/1/zu3q+xRAwIcg="
}, {
    "num_cand": "U2FsdGVkX1+YV9lJj1I82a3cxoSQ5wB1d8+oZiGSY7Y=",
    "cpf": "U2FsdGVkX1+72PExF/xkJ0P2wfaVG0+d++PTKWKE2RY="
}, {
    "num_cand": "U2FsdGVkX1+fOs8J4af8a96mWTxlg1mlKUSkvyrDDWM=",
    "cpf": "U2FsdGVkX18OP0r2hvciRFxND0rye7mc7A8z1z5LOgg="
}, {
    "num_cand": "U2FsdGVkX1/xeoF/kgTvGxKeYRs+Zz7K3fIrxYUuJg0=",
    "cpf": "U2FsdGVkX18nK/ncN4zhC/68YqjJnDBWM8LE5k3ptxw="
}, {
    "num_cand": "U2FsdGVkX1+hYZt5s0cntdY5zc91PVTybedhOyKQqIU=",
    "cpf": "U2FsdGVkX19hOYzm8CDPCGrnFw6TJRrbWwvqSYjAWKE="
}, {
    "num_cand": "U2FsdGVkX1/RnSUJMR9JoXs1qzNtQ5U7kwNCbRm49Hg=",
    "cpf": "U2FsdGVkX1/kUoUEEbI15HUr6qw7ju1TjMnT85Zsrvc="
}, {
    "num_cand": "U2FsdGVkX1+qLJZbkeeTN7JlUo38fARXTJrBOJqDb8w=",
    "cpf": "U2FsdGVkX18JgAO1DPDT3lEgjJ3B0loUTrwFrj2LkNM="
}, {
    "num_cand": "U2FsdGVkX1/HbHPCqJ6nY34NKhb8oXbpBzfAdEzpZQI=",
    "cpf": "U2FsdGVkX1+2pb55v/Rfv56nkauB6SSgokeM3MQkTEU="
}, {
    "num_cand": "U2FsdGVkX19PChDECSWb9kwpgVqI5JNFumoi0rDYwFo=",
    "cpf": "U2FsdGVkX1/oxKRKzSGQd84wmekcTBN/9iT6nkSQFwc="
}, {
    "num_cand": "U2FsdGVkX1/XiWmaorhdrfRIh5gyg1n9SghSyZ15YfI=",
    "cpf": "U2FsdGVkX19yCNsz/Al0Jc1XC1hzYlGmO/Ho55yW9HA="
}, {
    "num_cand": "U2FsdGVkX19OPywmIPCQpbr8OBB9JXlNHR3BEDiHljo=",
    "cpf": "U2FsdGVkX1/E/IwWaj9lItsof4bJmDTGc443VOxFpa0="
}, {
    "num_cand": "U2FsdGVkX19zK/wOl8TkfFkoi3d1+XoFjOKPd70/d4s=",
    "cpf": "U2FsdGVkX19bXWX9VBU8vJ7tTN9g1nT7TMYz0Sfw0GY="
}, {
    "num_cand": "U2FsdGVkX18ocF/IqdaEaHZe7pJwpoNU9RZmHd9KbWw=",
    "cpf": "U2FsdGVkX1+SPUTdd2hQxsmhALAHrW9jYOXcbvYmxSo="
}, {
    "num_cand": "U2FsdGVkX19v89fsUy83U0WrKZeg8JIxlVSW8VAdJUo=",
    "cpf": "U2FsdGVkX18w6sZ4aGV4QAwOUc7gH+9gbv3UsQIG1/8="
}, {
    "num_cand": "U2FsdGVkX1+BNPZPw6aMiLkihGMnuXTqo/p9mHoqQas=",
    "cpf": "U2FsdGVkX1/4AY0QilLGWPUh5vEIKOmTTwbm/qBFdBA="
}, {
    "num_cand": "U2FsdGVkX19ZQlIiRVnbj8fJ6eUIPS2yTeKSu3UqlcU=",
    "cpf": "U2FsdGVkX1+mO2TgyXaEJ6sLgO0ltezcFWZFr401lgY="
}, {
    "num_cand": "U2FsdGVkX18h9Dum/iNyMkPt6Rp+sZ++Q9Z4gY1ThgA=",
    "cpf": "U2FsdGVkX1/LKxCR22ZKCT1c/de9O+rXPG/rNEsAvQE="
}, {
    "num_cand": "U2FsdGVkX1+Iyii9LKkGEijE3GhRZmIKCu6vjPcWSP0=",
    "cpf": "U2FsdGVkX1+DlkyGr4ftViprL//Tps4g6m9KoQtBYQg="
}, {
    "num_cand": "U2FsdGVkX1+5tzoIof2cSBUlqX9EjPUewVYk3mZY5xU=",
    "cpf": "U2FsdGVkX18Mr3x1ffgLRF8fSmBbYo6cbEJwD0cDH1o="
}, {
    "num_cand": "U2FsdGVkX18YgO2Wb9njYqmRLvBKFhQr6aqk9Ac3k9s=",
    "cpf": "U2FsdGVkX19mcNwln3/RZMtwYlstFLo8mpYA6NmS6Gk="
}, {
    "num_cand": "U2FsdGVkX18xi189TNTywY2FgEsLQjf70dMeOeBXYE0=",
    "cpf": "U2FsdGVkX181Kd+PVWzuA6KFIIvC/eMKPITD0jx5dN0="
}, {
    "num_cand": "U2FsdGVkX1+Jno9noR6lkDgcHtL8Mk4epzMYRNXQOwQ=",
    "cpf": "U2FsdGVkX1/S657WocVTpAqL7YHtdE4qmnIIxemiZPM="
}, {
    "num_cand": "U2FsdGVkX18l1AEuMmTj0jrXwRfGc2phk2RWd5/Z7ks=",
    "cpf": "U2FsdGVkX18xK25iB5ZQKG3ujLpjWhaGrNWOvph49U8="
}, {
    "num_cand": "U2FsdGVkX1/qFbcSc5ydW5hKf+myIeLPuPV43zHdjIY=",
    "cpf": "U2FsdGVkX19vBu0K2FP7oNMySYCvSSxNSPAu9oJfirk="
}, {
    "num_cand": "U2FsdGVkX18NB96aT9uIrqlr96WXa+2uC1T6WNSfpSk=",
    "cpf": "U2FsdGVkX1+OtMMhDFF9usMfC5daPDKvZ5ng1luogAg="
}, {
    "num_cand": "U2FsdGVkX18WYeuB0rGM0lH/uyoLCDVJrLWzFQcRytg=",
    "cpf": "U2FsdGVkX1+6Su5dvwY9oh5YZCwPkj2dYk/9AGA/ec4="
}, {
    "num_cand": "U2FsdGVkX18HF9Imme2NzdDjxhdHrJRAssJIooKOxkk=",
    "cpf": "U2FsdGVkX1/gl4ljMj2vqwH6C7u2OJWVHXlskR5VQl0="
}, {
    "num_cand": "U2FsdGVkX1+espgCWXNSHbUWSe/6rhH3uB+uTsqOSgg=",
    "cpf": "U2FsdGVkX1/bV5O7nWtzMS2UvRaDjHyWOr8B45ZFfVA="
}, {
    "num_cand": "U2FsdGVkX198IceFKR3zA/n8RbIXFIxPNLKoHGKWQ6w=",
    "cpf": "U2FsdGVkX1/lRSU/k7yD52HllOnzWps51FvuU4nXVs8="
}, {
    "num_cand": "U2FsdGVkX18TE5Ik/qP2waefaeL6FvAOnP7LETqc27U=",
    "cpf": "U2FsdGVkX1/t6aMyV7rs0ieUp2aVhOBK3BBEbx1bPHo="
}, {
    "num_cand": "U2FsdGVkX19ke1u9Si3wDKcalQfBIvGSxQ0HfPAneAI=",
    "cpf": "U2FsdGVkX18Eq6RWS0biXtTCvBhuz+wGiTqZuOU+lWI="
}, {
    "num_cand": "U2FsdGVkX1+tyMshT7x8YY0BWLlRvs0xDQdpaWRW1ps=",
    "cpf": "U2FsdGVkX19/EroearuZjhuIfqY6YBitBN/mfDgkOws="
}, {
    "num_cand": "U2FsdGVkX18kOexv3pEjUt1juViO4jnGJ6D+HkYC4JM=",
    "cpf": "U2FsdGVkX185Ta8sA+O88156+vnz46RxsOqgYub+WcA="
}, {
    "num_cand": "U2FsdGVkX1955syjBOGUq3SnIVPiRqjDGvtPs71wLsY=",
    "cpf": "U2FsdGVkX1+are7jKFE3kwDiOuYZI65WVjESq1skPUY="
}, {
    "num_cand": "U2FsdGVkX19Ac+B0CEMlgDt+5r9x6jON4ROGPTImUZg=",
    "cpf": "U2FsdGVkX18E4HjdVaL93SqAIkalB33iNA7UDStLNRE="
}, {
    "num_cand": "U2FsdGVkX1/yOVIKYCgmRKsWqbCnpI38npnqwTQil5U=",
    "cpf": "U2FsdGVkX190taD/nOl6C5ZW1MiB4ii0Oh2SqrY2tQ0="
}, {
    "num_cand": "U2FsdGVkX1/mD5KBFyY6/VfBJ7BOx2nYCLNidsvmkLA=",
    "cpf": "U2FsdGVkX18x1ygqO+NqgnjhS1GqgC8oSfCYKCwZYd8="
}, {
    "num_cand": "U2FsdGVkX19P+Lswwm9rVj1HRMlwog18a2pPff6ipIo=",
    "cpf": "U2FsdGVkX1+I5cAI1dPlFDuDnw4JQzQT728R73oN4wA="
}, {
    "num_cand": "U2FsdGVkX187YqGQ9ceTHhOrSJbNiK77IhUE4tUVHIs=",
    "cpf": "U2FsdGVkX1+MX3LQCzPsERTc3mtMVAb7zBo/If/17g4="
}, {
    "num_cand": "U2FsdGVkX1+xjHVLvmxzZqU9+/2B17HXIP+f5elH+kA=",
    "cpf": "U2FsdGVkX1+5DcerZPStOk5g5JBf2X2PT4Jccpm8G3M="
}, {
    "num_cand": "U2FsdGVkX184WY01oo7RP4jMr8BvXvKoBiSZxPIH5a4=",
    "cpf": "U2FsdGVkX1+uJOEIsMbOygKYoT9HFnAit6ReCiBj7q4="
}, {
    "num_cand": "U2FsdGVkX19zsVhq0yBmvpKUyvbdcyMHTlTMI/vB7to=",
    "cpf": "U2FsdGVkX18+oztol478rFCPQd/9fuMu0TX4W4EREi0="
}, {
    "num_cand": "U2FsdGVkX1+wgIy7ahAQywY1uFEq2oPzhKdJghvfxYI=",
    "cpf": "U2FsdGVkX18O9g999WAHSyKbyG60qbQ1ADwRnc6ocX8="
}, {
    "num_cand": "U2FsdGVkX191X7Qcglb0DKhm1YGI6Q+blp6xs3yBoM8=",
    "cpf": "U2FsdGVkX19C6UpkrOcEZ+JADyOclHphwcsaKzSDlIo="
}, {
    "num_cand": "U2FsdGVkX1+ONStiAgIsbnYSf8WGAbC61pB6EVsytDs=",
    "cpf": "U2FsdGVkX1+qRPs/D+rKTA6N3yoMePtLlmc7aSnx5aw="
}, {
    "num_cand": "U2FsdGVkX1/Ol1GxBPPyoGC+ir0FV7Sl7+WGFBZqCOE=",
    "cpf": "U2FsdGVkX19RSwFpOY8qNd3aIe4Q6qPs62KCWzVONfI="
}, {
    "num_cand": "U2FsdGVkX1+IM+3eJLXOtl6yd9MWBaPA1TnR2CkP0i8=",
    "cpf": "U2FsdGVkX1+sdftESw+ItJuklg2nNQ0H6z984NTFU1o="
}, {
    "num_cand": "U2FsdGVkX19yE6LHOUbE/wsoxxReC86bGNB89tzi7E8=",
    "cpf": "U2FsdGVkX1/RWRek484Csz6+fZYuv/cXSxib57KDk7w="
}, {
    "num_cand": "U2FsdGVkX1+sjrvpV9qJ3PMeTyWcrbhOapL7dR0wZYU=",
    "cpf": "U2FsdGVkX1+uSZ4ucQD14qag/MagJtwyT5NFAJDZOX8="
}, {
    "num_cand": "U2FsdGVkX19+FXnVQ1km47SFHCwr7XtoGvxHn5FeL9w=",
    "cpf": "U2FsdGVkX19rf6suXZgHOcxpy3UA2HBojP4ZbpuEsPc="
}, {
    "num_cand": "U2FsdGVkX19MzO+n++8fYl4pvbrPZ9DEGd/QhXz+cxM=",
    "cpf": "U2FsdGVkX18ypscGoQ2DaR13/gmrQzG3Cf8Lnmu0f4Q="
}, {
    "num_cand": "U2FsdGVkX19eXncfWzQOsZmxdhBn+N6MNwwZGUFQEnY=",
    "cpf": "U2FsdGVkX187A9cjr4oVbTCgJlpNrffaGLSuluzP++0="
}, {
    "num_cand": "U2FsdGVkX1+Dp2HfW+49YtBzFRj10VUH4emEmd0tb00=",
    "cpf": "U2FsdGVkX1+WrPPWd3Su4ESmalhQNsd1MKyiOkSiOxg="
}, {
    "num_cand": "U2FsdGVkX185WvUil9Vw9a0yBCGcEbP4tSG+DWpjr1Q=",
    "cpf": "U2FsdGVkX1+c45qW1qNQRll4Jf7i4dsOA5m5/9YG480="
}, {
    "num_cand": "U2FsdGVkX1/QP6xCIhUXhg0rQpY4QkL5pCrz+m1mhUY=",
    "cpf": "U2FsdGVkX1/qKm8dIVerqOZumzQzIQgMwW4B0cDKrWA="
}, {
    "num_cand": "U2FsdGVkX189TyGcr6ut3dm26Ooy4/xL+Mz3uxpMjYw=",
    "cpf": "U2FsdGVkX187eBxrFXLcl8gmEQ83mhHMUjeAHKCZHyE="
}, {
    "num_cand": "U2FsdGVkX184k6esGHNmxRAx8DHJhJ1xXjDFO2Z+Q7Q=",
    "cpf": "U2FsdGVkX18xWwCFRl4vmc4MxYTyBgwEnvgVwHCMXAQ="
}, {
    "num_cand": "U2FsdGVkX19mRa5RoEGqdD9YX+Ej6ZhuMOFH2PxPvfc=",
    "cpf": "U2FsdGVkX19Of21LYDOcUHfuN6J5hxzW52iYZH34x0U="
}, {
    "num_cand": "U2FsdGVkX1/Zw9uQzeNfig6MDdj9kActJeAs0Nx6bps=",
    "cpf": "U2FsdGVkX18+MQm5lBReby3DPdynGeiQhzDZ0x0Ji1w="
}, {
    "num_cand": "U2FsdGVkX1+HH8eXdrWMCk7mvD1r2y/eUzePDMV5vFg=",
    "cpf": "U2FsdGVkX19FI1rOWKqvJGMh0oIYxDztJUsG1kOXafk="
}, {
    "num_cand": "U2FsdGVkX1+uoM/jJ+AhQUIhFjROW++BeLkxl5LAtcM=",
    "cpf": "U2FsdGVkX188cBX2kUY65E+GUjTzPMtzJN3Rw6JNLkg="
}, {
    "num_cand": "U2FsdGVkX1/Q3FgC5GeGH6TNHflYF6vxhbeeP1hZnEA=",
    "cpf": "U2FsdGVkX19UJY8JBHMrSwzHnZgHoPfOLhmYFSOUQvM="
}, {
    "num_cand": "U2FsdGVkX18p+ECfqe5TYVr8oFO3Tp9L3q3o87mLoaM=",
    "cpf": "U2FsdGVkX1/MALiXBV9iHnw8REGGWsdzW/KtyV4IUYs="
}, {
    "num_cand": "U2FsdGVkX1+8WE1DSbIOkxZ8yYCQKIbAOvi4Zxdxyhs=",
    "cpf": "U2FsdGVkX185ERRxFldSZK/D9GofYuuz7lmBShM5Evo="
}, {
    "num_cand": "U2FsdGVkX1/3eD4ixa1SC+TPqI2wEGF8Q0gmAwoPhtc=",
    "cpf": "U2FsdGVkX18Cor7/HQ7sQdIKaxgsW3rCwP6WMktD0Ic="
}, {
    "num_cand": "U2FsdGVkX19Ohp7LCHtcTWzYv+bhqNiASC1I91VR+EA=",
    "cpf": "U2FsdGVkX1/aY1W6MG1Tq+8qnu04vim997yJGo7AD0E="
}, {
    "num_cand": "U2FsdGVkX18krw7rIwT5V6ehhsc3/JphWV2PuWf3vbk=",
    "cpf": "U2FsdGVkX19cFTe7vgrPuo4JW9OucUdC8ojLIt2A6n8="
}, {
    "num_cand": "U2FsdGVkX1+Ns/upsBNrk/88aiUCW7KjyT0PQH+FuLo=",
    "cpf": "U2FsdGVkX19WSYLY70HWGFB2a+rTGAkD152glfyy8og="
}, {
    "num_cand": "U2FsdGVkX1+G7L4joMv4bcmRe3gey7ERavjoIxYu8cI=",
    "cpf": "U2FsdGVkX1+/Fh7LYLyyq9ilKuEF82Y4BUJG7dzy5KI="
}, {
    "num_cand": "U2FsdGVkX19CPytl2FU54kMWtvIdIG+BqyNyunuBims=",
    "cpf": "U2FsdGVkX1+V8zt7JMxiwMDUUwUjzvwMD/DEP8xERps="
}, {
    "num_cand": "U2FsdGVkX1+mbPR3vIeySgcPrKkh6C3EZQ+j2e8rKRE=",
    "cpf": "U2FsdGVkX18JS+keMUAsElJW/e573+NwTUdgkEm1AFw="
}, {
    "num_cand": "U2FsdGVkX18wJu7PwhJfkx6W8VjOmubxO6fyYvENR0g=",
    "cpf": "U2FsdGVkX1/mkE6FS4C4fdPpr3NzmC9HuuBsWF4XZbQ="
}, {
    "num_cand": "U2FsdGVkX18TcRcW/o+falK557kliECTfG8Rs6jK6mQ=",
    "cpf": "U2FsdGVkX1/3BYOpTE8WIL5h9xH9OJYb/Lc7QiVg2Yc="
}, {
    "num_cand": "U2FsdGVkX1++QI59C9uRSfTX2lw3DKvS9CW/399ZFOs=",
    "cpf": "U2FsdGVkX18rsaSy9C8jy9Wyazqp8uCne0Hya8hu/fM="
}, {
    "num_cand": "U2FsdGVkX193I/EVxeu2Hgyr1GThTpeAe1c3DTUwlaY=",
    "cpf": "U2FsdGVkX18xgRa5V4PrduZSIwCrqtAriqv0sOqLDHY="
}, {
    "num_cand": "U2FsdGVkX1/WQ9YyJhafOo7YnochFf8tlYGkFpYgjQ0=",
    "cpf": "U2FsdGVkX1+b4RawdUCUr5mIVqqUGYpiG56y5qCbOwI="
}, {
    "num_cand": "U2FsdGVkX19SSJPwnbPLvZlbiBHtm1zLl9JOV7OY5WU=",
    "cpf": "U2FsdGVkX1/89WoJv8boF8BmNllNlx1e1ad5Hmzt85g="
}, {
    "num_cand": "U2FsdGVkX1/wo3XqlxOuNb6K7EOmkH2cvS/SIoSzmh8=",
    "cpf": "U2FsdGVkX1/7XNC1Wk4tAU7DoY9ZrZuke6Ji/HalKLI="
}, {
    "num_cand": "U2FsdGVkX19VbIKh9Ndf3oCf9Ze/Vp0BUlOTAhi9ylA=",
    "cpf": "U2FsdGVkX19Sl7aJ3jNXvt4lKRfca0TTCLyqaiOAu6o="
}, {
    "num_cand": "U2FsdGVkX1+QmTAP1mVKDKQ9KLd1i2Y/3nZDs+J9aUk=",
    "cpf": "U2FsdGVkX19fycl33COllwOjvAcObq8B1xqkmNWT3lQ="
}, {
    "num_cand": "U2FsdGVkX19/Oizw0S0VF+/towShVwZYnZXwW7QvSTY=",
    "cpf": "U2FsdGVkX18tLDUv/1FYaTuVUzhdKT7ijUu9d8d6MTs="
}, {
    "num_cand": "U2FsdGVkX19xf8eMZtQvMZtQWsyoYpcTQP5L4JWSzJ8=",
    "cpf": "U2FsdGVkX1+tEEC+MWbyzoncLc7+Xl7b3AFp8IADpAI="
}, {
    "num_cand": "U2FsdGVkX1+q60KkTCRI957J6gCPoa2gQLixHZ30AhE=",
    "cpf": "U2FsdGVkX1+2aQdXUWbQUcJCyL4pjrgU3F8wcNdiFjI="
}, {
    "num_cand": "U2FsdGVkX184DtRQL4dS8l3xY/s7S7USGaJluWQ2ScQ=",
    "cpf": "U2FsdGVkX18x+TkD5XCLxKgHJHkFSz9j+iWDi6ya/Os="
}, {
    "num_cand": "U2FsdGVkX19gMrNHhw1BR0FQsdI1guQsjfVmGUaypbM=",
    "cpf": "U2FsdGVkX1/8maVs0BFVvi/lOjCa1tOwf8h93u05uyE="
}, {
    "num_cand": "U2FsdGVkX1/bZvK71d+Gle+K7zJqBAp2ZWssAW7p/S8=",
    "cpf": "U2FsdGVkX1+vrqVmLxJgvu1sCwlK5/4v+hYvh8n2L2E="
}, {
    "num_cand": "U2FsdGVkX1+pkgkjm9AqqpyWuA9ebEO+23150cjWsqg=",
    "cpf": "U2FsdGVkX1/cxsu4bhpqIQqynOX6EWuXgnBP29EALdg="
}, {
    "num_cand": "U2FsdGVkX19eS0PeotYfo5qh+8yQRnm8Axu47zbqkGE=",
    "cpf": "U2FsdGVkX1/tF8ZvMN8hhMpFqRP2gIi/HdW17om/ZSc="
}, {
    "num_cand": "U2FsdGVkX1/IjaeDQO1iW8xmiusy+mnjT54I8SakJJw=",
    "cpf": "U2FsdGVkX19l4KboFUB+7+PoqxaxQ9GUYmlAg3xC+dM="
}, {
    "num_cand": "U2FsdGVkX1+cdSEWt0WfXskW3MADiDuN8eMWUGCg3ug=",
    "cpf": "U2FsdGVkX18K3U8bXaawR57Jwi9ZLPQoXKJn5nuIbVQ="
}, {
    "num_cand": "U2FsdGVkX1/CEhml4m9HuAPT5UvxwkqkSl1C8HNomW4=",
    "cpf": "U2FsdGVkX1/mqGdhV8twLXQWdUSKqiSe2d0PwNGSTZQ="
}, {
    "num_cand": "U2FsdGVkX19upo02qMMLTc2hrwgT5Wu8cW6JEdZJBxY=",
    "cpf": "U2FsdGVkX1+8/Hyhb9SbC+SujAcg7UbGxwsGJ7BZC78="
}, {
    "num_cand": "U2FsdGVkX1+YxkL2JxVCpu2ysRmCqmPTfWTu3hS0qBA=",
    "cpf": "U2FsdGVkX1+H3MQU3ax8cT8cnllJLJPp7oOPHKFvYTY="
}, {
    "num_cand": "U2FsdGVkX1/xWNBYvfIJFj2/cWJjzbBfCSQob8YDAXI=",
    "cpf": "U2FsdGVkX19YCQ9r4o0PL/GqkIRDn682fY5uA8ZJFBQ="
}, {
    "num_cand": "U2FsdGVkX1+ohimmZpb6CEEQamlANSqvJ5Z2ShPOJ50=",
    "cpf": "U2FsdGVkX192DimL95+5XZJTXD1tEnu0yBbMfep2je0="
}, {
    "num_cand": "U2FsdGVkX19KJI+GVWOoKMQtTO7FDkbi/AHxvHjfqOQ=",
    "cpf": "U2FsdGVkX1+TzolZwEspQW76hPvPXRhNUjKqrk5a+M4="
}, {
    "num_cand": "U2FsdGVkX1+KDpT3nuYDFOz5DyLmY41TAwVh50uF4HY=",
    "cpf": "U2FsdGVkX190YJpRCkQkz/Fy2RkB77YOL813dW7Ucyg="
}, {
    "num_cand": "U2FsdGVkX1+dlDcXpLPlC5RplQbPt5iq0Lpzjk6jXhk=",
    "cpf": "U2FsdGVkX18+0ZoPHzSL3PjqOPFLetup5Obv3UfIvpc="
}, {
    "num_cand": "U2FsdGVkX19jtRhTQKamnecCFGXX9Yloq0Alkf4LGMA=",
    "cpf": "U2FsdGVkX19brVAjTLQGdyQfhuywI3WpR+K6sqkHTXQ="
}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/res_disc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
